export const countries = {
	type: "Topology",
	arcs: [
		[
			[17116, 14751],
			[72, -46],
			[54, 16],
			[15, 56],
			[56, 18],
			[40, 37],
			[14, 97],
			[60, 24],
			[11, 43],
			[33, -33],
			[22, -3],
		],
		[
			[17493, 14960],
			[39, -1],
			[54, -26],
		],
		[
			[17586, 14933],
			[21, -15],
			[52, 39],
			[24, -23],
			[22, 56],
			[43, -3],
			[11, 18],
			[7, 49],
			[31, 42],
			[38, -27],
			[-7, -37],
			[21, -6],
			[-7, -102],
			[28, -40],
			[25, 25],
			[32, 12],
			[44, 55],
			[49, -9],
			[73, 0],
		],
		[
			[18093, 14967],
			[13, -35],
		],
		[
			[18106, 14932],
			[-42, -14],
			[-36, -22],
			[-81, -15],
			[-76, -25],
			[-42, -53],
			[17, -52],
			[8, -60],
			[-35, -51],
			[3, -47],
			[-20, -44],
			[-67, 4],
			[28, -80],
			[-46, -31],
			[-30, -74],
			[4, -73],
			[-28, -34],
			[-26, 11],
			[-54, -15],
			[-8, -34],
			[-53, 0],
			[-39, -69],
			[-3, -104],
			[-92, -50],
			[-49, 10],
			[-15, -26],
			[-42, 15],
			[-71, -18],
			[-119, 62],
		],
		[
			[17092, 14043],
			[64, 111],
			[-5, 78],
			[-54, 20],
			[-6, 78],
			[-23, 97],
			[30, 66],
			[-31, 18],
			[20, 89],
			[29, 151],
		],
		[
			[14469, 9085],
			[8, -38],
			[-8, -59],
			[12, -57],
			[-10, -45],
			[6, -42],
			[-148, 1],
			[-3, -387],
			[47, -99],
			[47, -76],
		],
		[
			[14420, 8283],
			[-131, -50],
			[-171, 17],
			[-50, 59],
			[-287, -6],
			[-11, -8],
			[-42, 55],
			[-46, 4],
			[-43, -21],
			[-34, -23],
		],
		[
			[13605, 8310],
			[-7, 76],
			[10, 107],
			[25, 111],
			[3, 53],
			[23, 109],
			[17, 50],
			[41, 80],
			[23, 54],
			[7, 90],
			[-3, 69],
			[-22, 43],
			[-18, 74],
			[-18, 73],
			[4, 26],
			[22, 48],
			[-22, 117],
			[-14, 82],
			[-36, 77],
			[7, 23],
		],
		[
			[13647, 9672],
			[29, 17],
			[21, -3],
			[25, 15],
			[209, -2],
			[18, -90],
			[20, -73],
			[16, -39],
			[27, -64],
			[47, 10],
			[24, 17],
			[39, -17],
			[11, 30],
			[17, 71],
			[44, 5],
			[4, 21],
			[36, 0],
			[-6, -44],
			[86, 2],
			[2, -77],
			[14, -47],
			[-10, -73],
			[5, -75],
			[23, -45],
			[-3, -145],
			[17, 11],
			[31, -3],
			[44, 18],
			[32, -7],
		],
		[
			[13637, 9710],
			[-19, 92],
		],
		[
			[13618, 9802],
			[29, 52],
			[21, 21],
			[27, -42],
		],
		[
			[13695, 9833],
			[-26, -26],
			[-12, -31],
			[-2, -53],
			[-18, -13],
		],
		[
			[14264, 15383],
			[-1, -32],
			[-23, -18],
			[-5, -39],
			[-33, -59],
		],
		[
			[14202, 15235],
			[-12, 8],
			[-1, 27],
			[-39, 41],
			[-7, 58],
			[6, 83],
			[10, 38],
			[-12, 19],
			[-5, 39],
			[31, 60],
		],
		[
			[14173, 15608],
			[5, -23],
			[19, 10],
		],
		[
			[14197, 15595],
			[15, -32],
			[17, -13],
		],
		[
			[14229, 15550],
			[5, -44],
			[-9, -41],
			[10, -52],
			[29, -30],
		],
		[
			[16432, 13364],
			[13, 6],
			[3, -33],
			[55, 19],
			[59, -4],
			[43, -3],
			[48, 82],
			[53, 78],
			[45, 75],
		],
		[
			[16751, 13584],
			[14, -41],
		],
		[
			[16765, 13543],
			[9, -96],
		],
		[
			[16774, 13447],
			[-36, -1],
			[-6, -79],
			[13, -17],
			[-32, -24],
			[0, -50],
			[-21, -50],
			[-2, -49],
		],
		[
			[16690, 13177],
			[-14, -26],
			[-214, 62],
			[-27, 123],
			[-3, 28],
		],
		[
			[8021, 3736],
			[-43, 3],
			[-76, 1],
			[0, 271],
		],
		[
			[7902, 4011],
			[28, -56],
			[35, -91],
			[92, -73],
			[100, -31],
			[-32, -61],
			[-68, -6],
			[-36, 43],
		],
		[
			[8324, 7708],
			[131, -199],
			[58, -18],
			[87, -90],
			[73, -48],
			[10, -53],
			[-70, -185],
			[72, -33],
			[79, -19],
			[56, 20],
			[65, 93],
			[11, 107],
		],
		[
			[8896, 7283],
			[36, 24],
			[35, -71],
			[-1, -97],
			[-60, -67],
			[-48, -49],
			[-80, -119],
			[-94, -165],
		],
		[
			[8684, 6739],
			[-18, -98],
			[-19, -125],
			[1, -121],
			[-16, -27],
			[-5, -79],
		],
		[
			[8627, 6289],
			[-5, -63],
			[90, -104],
			[-10, -84],
			[45, -53],
			[-4, -60],
			[-68, -156],
			[-105, -65],
			[-143, -25],
			[-78, 12],
			[15, -73],
			[-14, -91],
			[13, -61],
			[-43, -43],
			[-73, -17],
			[-68, 45],
			[-27, -32],
			[10, -121],
			[48, -37],
			[38, 39],
			[22, -63],
			[-66, -38],
			[-57, -76],
			[-10, -122],
			[-17, -65],
			[-67, -1],
			[-56, -62],
			[-20, -91],
			[70, -89],
			[68, -25],
			[-25, -109],
			[-84, -69],
			[-46, -142],
			[-64, -48],
			[-29, -57],
			[22, -127],
			[48, -70],
			[-30, 6],
		],
		[
			[7907, 4052],
			[-66, 19],
			[-171, 16],
			[-30, 71],
			[2, 92],
			[-48, -8],
			[-25, 44],
			[-6, 129],
			[55, 53],
			[22, 77],
			[-8, 62],
			[37, 104],
			[26, 161],
			[-7, 71],
			[31, 23],
			[-8, 46],
			[-33, 25],
			[24, 51],
			[-32, 46],
			[-17, 140],
			[28, 25],
			[-12, 148],
			[17, 125],
			[19, 108],
			[43, 44],
			[-22, 119],
			[0, 112],
			[54, 79],
			[-2, 102],
			[40, 119],
			[1, 112],
			[-19, 22],
			[-33, 210],
			[44, 125],
			[-7, 118],
			[26, 110],
			[46, 114],
			[50, 76],
			[-21, 48],
			[15, 39],
			[-2, 203],
			[77, 60],
			[24, 126],
			[-8, 31],
		],
		[
			[8011, 7649],
			[59, 110],
			[93, -30],
			[41, -88],
			[28, 98],
			[81, -5],
			[11, -26],
		],
		[
			[15865, 15413],
			[99, 19],
		],
		[
			[15964, 15432],
			[14, -32],
			[27, -21],
			[-14, -30],
			[38, -42],
			[-20, -39],
			[30, -33],
			[32, -20],
			[1, -84],
		],
		[
			[16072, 15131],
			[-25, -4],
		],
		[
			[16047, 15127],
			[-29, 71],
			[0, 19],
			[-31, -1],
			[-21, 33],
			[-15, -3],
		],
		[
			[15951, 15246],
			[-28, 35],
			[-53, 30],
			[7, 60],
			[-12, 42],
		],
		[
			[8545, 677],
			[-20, -62],
			[-21, -54],
			[-149, 16],
			[-158, -7],
			[-89, 41],
			[0, 4],
			[-39, 36],
			[159, -5],
			[153, -11],
			[53, 50],
			[38, 43],
			[73, -51],
		],
		[
			[1475, 744],
			[-136, -17],
			[-93, 43],
			[-42, 43],
			[-2, 7],
			[-46, 33],
			[43, 45],
			[132, -19],
			[71, -38],
			[54, -43],
			[19, -54],
		],
		[
			[9568, 920],
			[88, -53],
			[31, -73],
			[8, -53],
			[3, -62],
			[-110, -38],
			[-116, -31],
			[-133, -29],
			[-149, -23],
			[-168, 7],
			[-93, 40],
			[13, 50],
			[151, 34],
			[61, 40],
			[45, 53],
			[32, 45],
			[43, 43],
			[46, 50],
			[0, 0],
			[36, 0],
			[105, 26],
			[107, -26],
		],
		[
			[4172, 1473],
			[91, -19],
			[85, 21],
			[-40, -43],
			[-67, -31],
			[-99, 10],
			[-71, 43],
			[0, 0],
			[16, 40],
			[85, -21],
		],
		[
			[3863, 1475],
			[108, -47],
			[-41, 4],
			[-92, 12],
			[-97, 34],
			[0, 0],
			[51, 26],
			[71, -29],
		],
		[
			[5749, 1664],
			[78, -17],
			[78, 14],
			[41, -69],
			[-55, 10],
			[-86, -5],
			[-88, 5],
			[-96, -7],
			[-72, 23],
			[-38, 50],
			[45, 22],
			[90, -17],
			[103, -9],
		],
		[
			[7915, 1783],
			[9, -55],
			[-13, -48],
			[-19, -45],
			[-84, -17],
			[-79, -24],
			[-93, 3],
			[35, 47],
			[-84, -16],
			[-79, -17],
			[-54, 36],
			[-4, 50],
			[78, 47],
			[0, 0],
			[48, 15],
			[82, -5],
			[21, 62],
			[4, 45],
			[-1, 98],
			[40, 57],
			[65, 19],
			[38, -45],
			[17, -45],
			[30, -55],
			[24, -53],
			[19, -54],
		],
		[
			[8613, 2610],
			[-30, -26],
			[-53, 19],
			[-58, -12],
			[-49, -28],
			[-51, -31],
			[-35, -36],
			[-10, -48],
			[4, -45],
			[34, -41],
			[-49, -28],
			[-67, -10],
			[-39, -40],
			[-41, -38],
			[-45, -53],
			[-11, -45],
			[25, -50],
			[38, -38],
			[58, -29],
			[54, -38],
			[29, -48],
			[16, -45],
			[20, -48],
			[34, -40],
			[21, -46],
			[9, -112],
			[21, -45],
			[6, -48],
			[22, -47],
			[-10, -65],
			[-39, -50],
			[-41, -40],
			[-95, -17],
			[-32, -43],
			[-43, -40],
			[-107, -46],
			[-94, -19],
			[-89, -26],
			[-96, -26],
			[-57, -50],
			[-114, -5],
			[-125, 5],
			[-113, -10],
			[-119, 0],
			[22, -47],
			[108, -22],
			[80, -33],
			[44, -43],
			[-79, -38],
			[-123, 12],
			[-101, -31],
			[-4, -50],
			[-3, -48],
			[83, -41],
			[16, -45],
			[90, -45],
			[150, -19],
			[128, -34],
			[101, -38],
			[130, -38],
			[176, -19],
			[174, -33],
			[121, -36],
			[132, -41],
			[69, -57],
			[35, -45],
			[86, 43],
			[117, 35],
			[124, 39],
			[147, 31],
			[127, 33],
			[176, 2],
			[174, -16],
			[143, -29],
			[46, 53],
			[98, 35],
			[180, 3],
			[140, 26],
			[133, 26],
			[148, 17],
			[157, 21],
			[110, 31],
			[-50, 43],
			[-31, 43],
			[0, 45],
			[-138, -4],
			[-145, -19],
			[-139, 0],
			[-20, 45],
			[10, 90],
			[32, 27],
			[101, 28],
			[120, 29],
			[86, 36],
			[86, 35],
			[64, 48],
			[97, 21],
			[96, 17],
			[49, 10],
			[110, 4],
			[104, 17],
			[87, 24],
			[87, 29],
			[77, 28],
			[99, 38],
			[63, 41],
			[66, 36],
			[21, 47],
			[-75, 29],
			[25, 50],
			[47, 38],
			[74, 24],
			[78, 29],
			[72, 38],
			[56, 47],
			[35, 58],
			[51, 33],
			[85, -7],
			[34, -41],
			[85, -5],
			[3, 46],
			[36, 47],
			[77, -11],
			[18, -46],
			[84, -7],
			[92, 22],
			[89, 14],
			[81, -7],
			[30, -50],
			[78, 40],
			[72, 22],
			[81, 16],
			[79, 17],
			[72, 29],
			[80, 19],
			[61, 26],
			[43, 43],
			[53, -31],
			[73, 16],
			[52, -57],
			[40, -43],
			[81, 24],
			[32, 48],
			[72, 33],
			[93, -7],
			[28, -45],
			[58, 45],
			[77, 14],
			[83, 5],
			[75, -2],
			[79, -15],
			[77, -7],
			[33, -40],
			[46, -36],
			[78, 22],
			[83, 4],
			[81, 0],
			[79, 3],
			[71, 16],
			[75, 15],
			[62, 33],
			[67, 21],
			[72, 12],
			[55, 34],
			[39, 67],
			[40, 40],
			[74, -19],
			[27, -43],
			[61, -29],
			[74, 10],
			[50, -43],
			[53, -31],
			[72, 29],
			[25, 52],
			[64, 22],
			[74, 40],
			[69, 17],
			[84, 24],
			[55, 26],
			[59, 28],
			[55, 27],
			[67, -15],
			[64, 43],
			[46, 34],
			[67, -3],
			[58, 29],
			[14, 43],
			[60, 33],
			[58, 24],
			[71, 19],
			[65, 10],
			[63, -8],
			[66, -11],
			[57, -34],
			[7, -52],
			[63, -41],
			[43, -33],
			[85, -14],
			[47, -34],
			[58, -33],
			[68, -7],
			[57, 23],
			[62, 51],
			[66, -27],
			[70, -14],
			[66, -14],
			[70, -10],
			[71, 0],
			[58, -126],
			[-3, -31],
			[-8, -55],
			[-68, -31],
			[-56, -45],
			[10, -48],
			[79, 2],
			[-9, -47],
			[-37, -46],
			[-33, -50],
			[54, -38],
			[82, -12],
			[82, 22],
			[39, 47],
			[24, 46],
			[39, 38],
			[44, 36],
			[18, 43],
			[38, 59],
			[44, 12],
			[81, 5],
			[71, 14],
			[72, 19],
			[35, 48],
			[21, 45],
			[48, 45],
			[70, 31],
			[60, 24],
			[38, 41],
			[41, 21],
			[51, 19],
			[71, -12],
			[64, 12],
			[69, 15],
			[78, -7],
			[52, 33],
			[36, 81],
			[26, -33],
			[34, -58],
			[59, -23],
			[68, -10],
			[69, 14],
			[72, -9],
			[67, -3],
			[44, 12],
			[60, -7],
			[54, -26],
			[64, 17],
			[76, 0],
			[66, 16],
			[73, -16],
			[48, 40],
			[36, 41],
			[48, 33],
			[89, 91],
			[46, -17],
			[54, -33],
			[48, -43],
			[90, -74],
			[69, -3],
			[66, 0],
			[76, 15],
			[77, 16],
			[58, 34],
			[49, 35],
			[79, 5],
			[53, 26],
			[55, -23],
			[36, -39],
			[50, -38],
			[78, 5],
			[49, -31],
			[85, -31],
			[89, -12],
			[73, 10],
			[56, 38],
			[47, 38],
			[64, 10],
			[64, -17],
			[74, -12],
			[66, 19],
			[64, 0],
			[63, -12],
			[65, -12],
			[64, 22],
			[77, 19],
			[72, 4],
			[80, 0],
			[66, 12],
			[64, 10],
			[19, 60],
			[3, 50],
			[44, -34],
			[13, -55],
			[24, -50],
			[29, -40],
			[59, -22],
			[81, 7],
			[93, 3],
			[64, 7],
			[93, 0],
			[67, 2],
			[93, -4],
			[79, -10],
			[50, -38],
			[-14, -45],
			[46, -36],
			[77, -29],
			[79, -31],
			[92, -21],
			[96, -19],
			[72, -19],
			[80, -3],
			[46, 41],
			[63, -33],
			[54, -39],
			[63, -28],
			[86, -12],
			[82, -14],
			[34, -48],
			[81, -29],
			[54, -43],
			[79, -19],
			[82, 3],
			[77, -7],
			[85, 2],
			[84, -10],
			[80, -16],
			[73, -29],
			[74, -24],
			[50, -36],
			[-8, -47],
			[-38, -43],
			[-32, -55],
			[-25, -43],
			[-33, -50],
			[-93, -19],
			[-42, -43],
			[-92, -26],
			[-32, -48],
			[-48, -45],
			[-52, -38],
			[-29, -50],
			[-18, -46],
			[-7, -54],
			[1, -46],
			[41, -47],
			[15, -46],
			[33, -43],
			[132, -16],
			[28, -53],
			[-128, -19],
			[-108, -26],
			[-135, -5],
			[-60, -69],
			[-12, -57],
			[-31, -45],
			[-37, -46],
			[94, -40],
			[36, -50],
			[62, -46],
			[86, -40],
			[98, -38],
			[107, -38],
			[163, -38],
			[36, -60],
			[204, -26],
			[14, -10],
			[53, -36],
			[196, 31],
			[163, -38],
			[122, -29],
			[-25541, -1],
			[63, 71],
			[128, -38],
			[8, 4],
			[75, 39],
			[10, -2],
			[8, -1],
			[103, -50],
			[89, 50],
			[17, 7],
			[208, 22],
			[68, -29],
			[33, -14],
			[107, -41],
			[201, -31],
			[160, -38],
			[274, -28],
			[204, 33],
			[302, -24],
			[171, -38],
			[187, 36],
			[198, 33],
			[15, 57],
			[-279, 5],
			[-230, 29],
			[-59, 47],
			[-191, 27],
			[13, 54],
			[26, 50],
			[27, 46],
			[-14, 50],
			[-118, 33],
			[-55, 43],
			[-109, 38],
			[172, -7],
			[164, 19],
			[103, -40],
			[126, 35],
			[117, 46],
			[57, 40],
			[-25, 50],
			[-92, 34],
			[-104, 35],
			[-146, 8],
			[-128, 16],
			[-137, 12],
			[-46, 45],
			[-92, 39],
			[-56, 43],
			[-22, 138],
			[35, -12],
			[64, -38],
			[117, 12],
			[112, 16],
			[59, -52],
			[112, 12],
			[95, 26],
			[89, 33],
			[80, 41],
			[107, 12],
			[-3, 45],
			[-25, 45],
			[21, 43],
			[92, 22],
			[42, -41],
			[108, 24],
			[82, 31],
			[102, 2],
			[95, 12],
			[96, 29],
			[77, 26],
			[86, 26],
			[55, -7],
			[49, -9],
			[106, 16],
			[94, -21],
			[98, 2],
			[93, 17],
			[96, -12],
			[105, -12],
			[99, 5],
			[103, -2],
			[105, -3],
			[98, 5],
			[72, 36],
			[86, 19],
			[89, -26],
			[85, 21],
			[76, 43],
			[46, -38],
			[25, -43],
			[46, -41],
			[74, 36],
			[84, -45],
			[96, -14],
			[82, -34],
			[100, 7],
			[91, 22],
			[107, -5],
			[96, -17],
			[97, -21],
			[37, 52],
			[-45, 41],
			[-35, 43],
			[-92, 9],
			[-40, 46],
			[-16, 45],
			[-25, 90],
			[55, -16],
			[93, -7],
			[91, 7],
			[84, -19],
			[72, -36],
			[31, -43],
			[96, -7],
			[91, 17],
			[98, 23],
			[87, 15],
			[72, -29],
			[95, 10],
			[61, 93],
			[57, -55],
			[82, -22],
			[89, 12],
			[58, -47],
			[94, -5],
			[86, -15],
			[84, -26],
			[56, 46],
			[28, 42],
			[71, -47],
			[97, 12],
			[72, -27],
			[49, -40],
			[94, 12],
			[74, 26],
			[72, 31],
			[87, 17],
			[100, 14],
			[90, 17],
			[69, 26],
			[42, 38],
			[17, 53],
			[-9, 50],
			[-22, 47],
			[-25, 48],
			[-22, 48],
			[-18, 43],
			[-4, 47],
			[7, 48],
			[33, 45],
			[28, 50],
			[11, 48],
			[-14, 52],
			[-8, 48],
			[34, 55],
			[39, 36],
			[46, 45],
			[49, 38],
			[57, 36],
			[28, 52],
			[39, 34],
			[44, 31],
			[68, 7],
			[45, 38],
			[50, 24],
			[58, 14],
			[51, 31],
			[41, 38],
			[55, 14],
			[42, -30],
			[-26, -41],
			[-73, -36],
		],
		[
			[17664, 4499],
			[46, -38],
			[67, -15],
			[2, -23],
			[-20, -56],
			[-108, -8],
			[-2, 65],
			[10, 50],
			[5, 25],
		],
		[
			[23090, 5452],
			[68, -42],
			[39, 17],
			[55, 23],
			[43, -8],
			[5, -144],
			[-24, -42],
			[-8, -98],
			[-25, 33],
			[-49, -85],
			[-15, 7],
			[-43, 4],
			[-44, 104],
			[-10, 80],
			[-41, 106],
			[2, 56],
			[47, -11],
		],
		[
			[22959, 8740],
			[26, -95],
			[46, 46],
			[23, -52],
			[34, -47],
			[-7, -54],
			[15, -105],
			[11, -60],
			[18, -15],
			[19, -104],
			[-7, -63],
			[23, -83],
			[77, -63],
			[50, -58],
			[48, -53],
			[-10, -30],
			[41, -76],
			[27, -132],
			[29, 27],
			[29, -53],
			[17, 19],
			[12, -129],
			[50, -74],
			[33, -47],
			[56, -98],
			[20, -98],
			[2, -69],
			[-5, -76],
			[34, -103],
			[-5, -108],
			[-12, -56],
			[-19, -109],
			[1, -69],
			[-14, -88],
			[-31, -110],
			[-52, -60],
			[-26, -94],
			[-24, -60],
			[-21, -105],
			[-27, -61],
			[-18, -91],
			[-10, -84],
			[4, -38],
			[-41, -43],
			[-79, -4],
			[-66, -50],
			[-32, -47],
			[-43, -52],
			[-59, 53],
			[-43, 22],
			[11, 63],
			[-39, -23],
			[-62, -88],
			[-62, 33],
			[-40, 19],
			[-40, 9],
			[-69, 35],
			[-46, 75],
			[-13, 93],
			[-17, 61],
			[-34, 50],
			[-69, 14],
			[24, 59],
			[-18, 91],
			[-34, -85],
			[-63, -22],
			[37, 67],
			[11, 70],
			[27, 60],
			[-6, 90],
			[-57, -104],
			[-45, -41],
			[-27, -97],
			[-55, 50],
			[2, 65],
			[-45, 88],
			[-37, 45],
			[13, 29],
			[-91, 73],
			[-50, 4],
			[-68, 59],
			[-127, -12],
			[-92, -43],
			[-80, -41],
			[-68, 8],
			[-75, -62],
			[-62, -28],
			[-14, -64],
			[-26, -49],
			[-60, -3],
			[-45, -11],
			[-62, 22],
			[-51, -13],
			[-49, -6],
			[-42, -65],
			[-21, 6],
			[-36, -35],
			[-34, -38],
			[-51, 5],
			[-48, 0],
			[-75, 77],
			[-38, 23],
			[1, 70],
			[35, 17],
			[12, 27],
			[-2, 44],
			[9, 85],
			[-8, 72],
			[-38, 123],
			[-12, 69],
			[4, 69],
			[-29, 80],
			[-2, 35],
			[-31, 49],
			[-9, 95],
			[-40, 96],
			[-10, 52],
			[31, -52],
			[-24, 113],
			[35, -36],
			[21, -47],
			[-1, 63],
			[-35, 95],
			[-7, 39],
			[-16, 36],
			[7, 70],
			[15, 30],
			[10, 61],
			[-8, 71],
			[29, 88],
			[6, -93],
			[30, 84],
			[57, 41],
			[35, 51],
			[54, 45],
			[32, 10],
			[20, -15],
			[56, 45],
			[43, 13],
			[11, 27],
			[18, 11],
			[40, -3],
			[74, 36],
			[39, 54],
			[18, 65],
			[42, 62],
			[3, 48],
			[2, 66],
			[49, 104],
			[30, -105],
			[30, 24],
			[-25, 57],
			[22, 59],
			[32, -26],
			[8, 93],
			[39, 60],
			[17, 48],
			[36, 20],
			[1, 34],
			[31, -14],
			[1, 31],
			[32, 17],
			[34, 16],
			[52, -55],
			[40, -72],
			[44, -1],
			[45, -12],
			[-15, 67],
			[34, 98],
			[32, 32],
			[-11, 30],
			[31, 69],
			[43, 43],
			[36, -14],
			[60, 23],
			[-1, 62],
			[-52, 40],
			[37, 18],
			[47, -30],
			[38, -50],
			[60, -32],
			[20, 13],
			[44, -38],
			[42, 35],
			[26, -10],
			[17, 23],
			[32, -60],
			[-19, -65],
			[-26, -49],
			[-25, -4],
			[8, -49],
			[-21, -61],
			[-25, -60],
			[5, -34],
			[57, -67],
			[54, -39],
			[37, -42],
			[51, -72],
			[20, 0],
			[37, -31],
			[11, -38],
			[68, -41],
			[47, 41],
			[14, 66],
			[14, 54],
			[9, 66],
			[21, 97],
			[-9, 59],
			[5, 35],
			[-8, 70],
			[9, 92],
			[13, 24],
			[-11, 41],
			[18, 65],
			[13, 66],
			[2, 35],
			[26, 46],
			[20, -60],
			[5, -76],
			[18, -15],
			[3, -51],
			[26, -62],
			[5, -69],
			[-3, -44],
		],
		[
			[13977, 16269],
			[-5, -50],
			[-40, 0],
			[14, -27],
			[-24, -78],
		],
		[
			[13922, 16114],
			[-13, -20],
			[-62, -3],
			[-36, -28],
			[-59, 9],
		],
		[
			[13752, 16072],
			[-101, 32],
			[-16, 42],
			[-70, -21],
			[-9, -23],
			[-43, 17],
		],
		[
			[13513, 16119],
			[-36, 3],
			[-32, 23],
			[11, 29],
			[-3, 22],
		],
		[
			[13453, 16196],
			[22, 7],
			[36, -34],
			[10, 32],
			[62, -5],
			[51, 22],
			[34, -4],
			[22, -25],
			[7, 21],
			[-10, 79],
			[25, 15],
			[25, 56],
		],
		[
			[13737, 16360],
			[53, -39],
			[40, 50],
			[25, 9],
			[55, -37],
			[33, 6],
			[33, -23],
		],
		[
			[13976, 16326],
			[-6, -15],
			[7, -42],
		],
		[
			[16047, 15127],
			[-49, 17],
			[-36, 56],
			[-11, 46],
		],
		[
			[16178, 15452],
			[42, 49],
			[37, -64],
			[36, -87],
			[33, -5],
			[22, -33],
			[-58, -10],
			[-12, -95],
			[-13, -42],
			[-26, -29],
			[2, -60],
		],
		[
			[16241, 15076],
			[-17, -6],
			[-45, 64],
			[25, 60],
			[-21, 36],
			[-27, -9],
			[-84, -90],
		],
		[
			[15964, 15432],
			[17, 20],
			[53, -35],
			[38, -7],
			[10, 14],
			[-35, 66],
			[18, 17],
		],
		[
			[16065, 15507],
			[20, -4],
			[49, -74],
			[31, -8],
			[13, 31],
		],
		[
			[14854, 9867],
			[-4, 147],
			[-18, 55],
		],
		[
			[14832, 10069],
			[43, -10],
			[22, 70],
			[38, -8],
		],
		[
			[14935, 10121],
			[4, -48],
			[15, -28],
			[1, -39],
			[-18, -26],
			[-27, -63],
			[-26, -44],
		],
		[
			[14884, 9873],
			[-30, -6],
		],
		[
			[13060, 16651],
			[65, 25],
			[45, -53],
			[39, -28],
		],
		[
			[13209, 16595],
			[-8, -82],
		],
		[
			[13201, 16513],
			[-18, -5],
			[-8, -68],
		],
		[
			[13175, 16440],
			[-62, 55],
			[-36, -9],
			[-50, 57],
			[-33, 49],
			[-33, 2],
			[-10, 43],
		],
		[
			[12951, 16637],
			[57, 24],
			[52, -10],
		],
		[
			[12963, 11176],
			[-58, -14],
		],
		[
			[12905, 11162],
			[-18, 84],
			[4, 279],
			[-15, 25],
			[-2, 60],
			[-25, 42],
			[-22, 36],
			[9, 64],
		],
		[
			[12836, 11752],
			[25, 14],
			[14, 53],
			[35, 12],
			[15, 36],
		],
		[
			[12925, 11867],
			[24, 36],
			[26, 0],
			[54, -70],
		],
		[
			[13029, 11833],
			[-3, -40],
			[16, -73],
			[-14, -49],
			[7, -32],
			[-34, -76],
			[-22, -37],
			[-13, -77],
			[2, -77],
			[-5, -196],
		],
		[
			[12572, 11587],
			[-49, 32],
			[-33, -5],
			[-25, -30],
			[-32, 25],
			[-12, 41],
			[-32, 26],
		],
		[
			[12389, 11676],
			[-5, 71],
			[20, 51],
			[-2, 41],
			[56, 101],
			[11, 84],
			[19, 29],
			[35, -16],
			[29, 25],
			[10, 31],
			[55, 55],
			[14, 38],
			[66, 50],
			[39, 17],
			[18, -23],
			[45, 1],
		],
		[
			[12799, 12231],
			[-6, -59],
			[10, -56],
			[40, -79],
			[2, -59],
			[82, -28],
			[-2, -83],
		],
		[
			[12836, 11752],
			[-62, 3],
		],
		[
			[12774, 11755],
			[-33, 10],
			[-23, -20],
			[-31, 9],
			[-123, -6],
			[-2, -69],
			[10, -92],
		],
		[
			[19348, 13096],
			[-1, -87],
			[-25, 18],
			[5, -98],
		],
		[
			[19327, 12929],
			[-20, 64],
			[-5, 61],
			[-13, 59],
			[-30, 71],
			[-65, 5],
			[6, -50],
			[-22, -68],
			[-30, 25],
			[-10, -23],
			[-20, 14],
			[-28, 11],
		],
		[
			[19090, 13098],
			[-11, 100],
			[-25, 91],
			[12, 74],
			[-43, 32],
			[16, 44],
			[44, 46],
			[-51, 64],
			[25, 83],
			[56, -53],
			[34, -6],
			[6, -84],
			[68, -17],
			[65, 2],
			[41, -21],
			[-32, -103],
			[-32, -7],
			[-22, -69],
			[39, -63],
			[11, 77],
			[20, 1],
			[37, -193],
		],
		[
			[14380, 15796],
			[21, -50],
			[27, 9],
			[55, -19],
			[104, -7],
			[35, 31],
			[84, 29],
			[51, -45],
			[42, -12],
		],
		[
			[14799, 15732],
			[-37, -51],
			[-26, -87],
			[23, -69],
		],
		[
			[14759, 15525],
			[-61, 16],
			[-72, -38],
		],
		[
			[14626, 15503],
			[-1, -61],
			[-65, -11],
			[-50, 42],
			[-56, -33],
			[-53, 3],
		],
		[
			[14401, 15443],
			[-5, 81],
			[-35, 39],
		],
		[
			[14361, 15563],
			[11, 17],
			[-7, 14],
			[11, 39],
			[28, 38],
			[-35, 53],
			[-6, 44],
			[17, 28],
		],
		[
			[7271, 13305],
			[-18, -6],
			[-18, 70],
			[-26, 35],
			[15, 77],
			[22, -5],
			[24, -101],
			[1, -70],
		],
		[
			[7251, 13648],
			[-78, -20],
			[-5, 45],
			[34, 10],
			[46, -3],
			[3, -32],
		],
		[
			[7309, 13649],
			[-13, -86],
			[-13, 15],
			[2, 64],
			[-32, 48],
			[0, 14],
			[56, -55],
		],
		[
			[14121, 15872],
			[26, 0],
		],
		[
			[14147, 15872],
			[-18, -53],
			[34, -47],
			[-10, -57],
			[-17, -6],
		],
		[
			[14136, 15709],
			[-13, -11],
			[-23, -28],
			[-11, -67],
		],
		[
			[14089, 15603],
			[-62, 46],
			[-27, 51],
			[-27, 27],
			[-33, 45],
			[-15, 38],
			[-35, 57],
			[15, 50],
			[25, -28],
			[16, 26],
			[33, 2],
			[61, -20],
			[49, 2],
			[32, -27],
		],
		[
			[14439, 16973],
			[68, -1],
			[78, 46],
			[16, 69],
			[58, 39],
			[-7, 54],
		],
		[
			[14652, 17180],
			[44, 21],
			[76, 47],
		],
		[
			[14772, 17248],
			[75, -31],
			[10, -30],
			[37, 14],
			[69, -29],
			[7, -57],
			[-15, -33],
			[44, -79],
			[29, -22],
			[-4, -22],
			[48, -22],
			[20, -32],
			[-27, -27],
		],
		[
			[15065, 16878],
			[-57, 4],
			[-14, -11],
		],
		[
			[14994, 16871],
			[17, -40],
		],
		[
			[15011, 16831],
			[17, -78],
		],
		[
			[15028, 16753],
			[-61, -8],
			[-22, -26],
			[-4, -61],
			[-29, 11],
			[-64, -6],
			[-18, 29],
			[-27, -21],
			[-27, 17],
			[-55, 3],
			[-80, 29],
			[-71, 9],
			[-55, -2],
			[-39, -33],
			[-34, -5],
		],
		[
			[14442, 16689],
			[-1, 54],
			[-22, 57],
			[42, 24],
			[1, 49],
			[-20, 46],
			[-3, 54],
		],
		[
			[6447, 12581],
			[0, 18],
			[8, 5],
			[13, -14],
			[25, 73],
			[14, 2],
		],
		[
			[6507, 12665],
			[0, -18],
			[14, 0],
			[-2, -33],
			[-11, -53],
			[6, -19],
			[-7, -43],
			[4, -12],
			[-8, -62],
			[-14, -32],
			[-13, -4],
			[-14, -42],
		],
		[
			[6462, 12347],
			[-21, 0],
			[6, 137],
			[0, 97],
		],
		[
			[8176, 14345],
			[1, 0],
			[0, 0],
			[1, 1],
			[0, 1],
			[1, 1],
			[0, 1],
			[0, 0],
			[1, 0],
			[0, 1],
			[0, 1],
			[0, 0],
			[1, -2],
			[1, -1],
			[1, 1],
			[1, 1],
			[0, 1],
			[-1, 0],
			[0, 0],
			[0, -1],
			[-1, 0],
			[0, 2],
			[0, 0],
			[-1, -1],
			[0, 0],
			[0, 1],
			[0, 0],
			[1, 1],
			[1, 1],
			[1, 1],
			[0, -2],
			[1, -1],
			[0, -1],
			[-1, 0],
			[1, -1],
			[0, -1],
			[-2, -1],
			[-1, -1],
			[-1, -1],
			[-1, -1],
			[-2, -1],
			[0, -1],
			[-1, -1],
			[-1, -2],
			[-1, 0],
			[-1, -2],
			[-1, 0],
			[0, -1],
			[-1, 0],
			[0, 0],
			[-1, 1],
			[0, 0],
			[-1, -1],
			[-1, 2],
			[-1, 3],
			[1, 1],
			[0, 1],
			[0, 0],
			[1, 1],
			[0, -1],
			[1, 1],
			[1, 2],
			[0, 0],
			[-1, -1],
			[-1, -2],
			[0, -1],
			[0, 0],
			[-1, -1],
			[0, -1],
			[1, -1],
			[0, -1],
			[0, -1],
			[2, 0],
			[0, 1],
			[0, 1],
			[1, 0],
			[1, 1],
			[0, 0],
			[2, 1],
			[-1, 1],
			[-1, 1],
			[-1, 1],
			[1, 0],
			[1, -1],
			[0, 0],
			[1, 1],
		],
		[
			[8011, 7649],
			[-51, -17],
			[-28, 168],
			[-38, 136],
			[22, 118],
			[-37, 51],
			[-10, 88],
			[-35, 83],
		],
		[
			[7834, 8276],
			[45, 131],
			[-30, 102],
			[16, 41],
			[-13, 45],
			[28, 61],
			[1, 104],
			[4, 85],
			[15, 41],
			[-61, 196],
		],
		[
			[7839, 9082],
			[53, -10],
			[36, 3],
			[16, 36],
			[62, 50],
			[37, 45],
			[93, 21],
			[-7, -91],
			[8, -47],
			[-5, -82],
			[77, -109],
			[79, -20],
			[28, -45],
			[48, -24],
			[29, -36],
			[45, 2],
			[41, -36],
			[3, -71],
			[14, -35],
			[1, -53],
			[-21, -2],
			[28, -141],
			[136, -5],
			[-11, -71],
			[8, -48],
			[39, -34],
			[17, -75],
			[-13, -96],
			[-20, -54],
			[7, -69],
			[-22, -25],
		],
		[
			[8645, 7960],
			[-1, 37],
			[-66, 63],
			[-66, 1],
			[-124, -35],
			[-34, -107],
			[-2, -66],
			[-28, -145],
		],
		[
			[8896, 7283],
			[14, 70],
			[10, 72],
			[0, 67],
			[-26, 22],
			[-26, -19],
			[-27, 5],
			[-8, 47],
			[-7, 111],
			[-13, 37],
			[-48, 33],
			[-29, -24],
			[-75, 23],
			[5, 165],
			[-21, 68],
		],
		[
			[7839, 9082],
			[-40, -21],
			[-33, 14],
			[5, 185],
			[-58, -72],
			[-63, 3],
			[-26, 65],
			[-48, 7],
			[15, 53],
			[-39, 74],
			[-30, 109],
			[19, 22],
			[0, 52],
			[43, 35],
			[-7, 66],
			[18, 42],
			[5, 57],
			[81, 83],
			[59, 23],
			[9, 18],
			[64, -5],
		],
		[
			[7813, 9892],
			[32, 333],
			[2, 53],
			[-12, 70],
			[-31, 44],
			[0, 88],
			[40, 20],
			[14, -12],
			[3, 46],
			[-42, 13],
			[-1, 76],
			[139, -3],
			[23, 42],
			[20, -38],
			[14, -72],
			[13, 15],
		],
		[
			[8027, 10567],
			[39, -64],
			[55, 7],
			[14, 38],
			[53, 28],
			[29, 20],
			[8, 52],
			[51, 34],
			[-4, 26],
			[-60, 10],
			[-10, 77],
			[3, 81],
			[-32, 32],
			[14, 11],
			[52, -15],
			[57, -31],
			[20, 29],
			[51, 19],
			[79, 45],
			[26, 47],
			[-9, 34],
		],
		[
			[8463, 11047],
			[37, 5],
			[16, -28],
			[-9, -53],
			[25, -18],
			[16, -57],
			[-20, -43],
			[-11, -103],
			[18, -62],
			[5, -56],
			[44, -57],
			[35, -6],
			[7, 24],
			[23, 5],
			[32, 21],
			[23, 32],
			[39, -10],
			[18, 5],
		],
		[
			[8761, 10646],
			[38, -10],
			[7, 24],
			[-12, 25],
			[7, 35],
			[28, -11],
			[34, 12],
			[41, -25],
		],
		[
			[8904, 10696],
			[31, -25],
			[21, 33],
			[16, -6],
			[10, -34],
			[34, 9],
			[27, 46],
			[22, 90],
			[42, 111],
		],
		[
			[9107, 10920],
			[24, 6],
			[18, -67],
			[39, -213],
			[38, -20],
			[2, -84],
			[-53, -100],
			[22, -37],
			[125, -19],
			[3, -122],
			[54, 80],
			[89, -44],
			[118, -74],
			[35, -72],
			[-12, -67],
			[83, 38],
			[138, -65],
			[106, 5],
			[105, -101],
			[90, -136],
			[55, -35],
			[61, -5],
			[25, -38],
			[24, -155],
			[12, -74],
			[-28, -201],
			[-36, -79],
			[-100, -170],
			[-45, -137],
			[-53, -106],
			[-18, -2],
			[-20, -90],
			[5, -227],
			[-19, -188],
			[-8, -80],
			[-22, -48],
			[-13, -163],
			[-72, -159],
			[-12, -125],
			[-57, -53],
			[-17, -73],
			[-77, 0],
			[-112, -46],
			[-50, -54],
			[-79, -36],
			[-84, -97],
			[-60, -121],
			[-10, -90],
			[12, -68],
			[-13, -122],
			[-17, -60],
			[-49, -67],
			[-79, -214],
			[-62, -96],
			[-49, -57],
			[-32, -116],
			[-47, -70],
		],
		[
			[8985, 6306],
			[-19, 69],
			[31, 58],
			[-41, 83],
			[-56, 67],
			[-73, 78],
			[-26, -4],
			[-71, 95],
			[-46, -13],
		],
		[
			[20876, 10965],
			[28, 46],
			[61, 66],
		],
		[
			[20965, 11077],
			[-4, -60],
			[-4, -77],
			[-34, 3],
			[-14, -41],
			[-33, 63],
		],
		[
			[19279, 13793],
			[29, -39],
			[-5, -75],
			[-58, -3],
			[-60, 8],
			[-44, -19],
			[-65, 46],
			[-1, 24],
		],
		[
			[19075, 13735],
			[47, 91],
			[38, 31],
			[51, -28],
			[37, -3],
			[31, -33],
		],
		[
			[14861, 7727],
			[-100, -90],
			[-64, -90],
			[-24, -81],
			[-21, -46],
			[-39, -10],
			[-12, -58],
			[-7, -38],
			[-46, -28],
			[-58, 6],
			[-33, 34],
			[-30, 14],
			[-35, -28],
			[-17, -58],
			[-34, -37],
			[-35, -54],
			[-51, -12],
			[-16, 42],
			[6, 75],
			[-42, 115],
			[-19, 18],
		],
		[
			[14184, 7401],
			[0, 355],
			[70, 5],
			[2, 433],
			[53, 4],
			[110, 43],
			[27, -50],
			[45, 47],
			[21, 0],
			[40, 28],
		],
		[
			[14552, 8266],
			[13, -9],
		],
		[
			[14565, 8257],
			[28, -97],
			[14, -22],
			[22, -71],
			[80, -133],
			[31, -13],
			[0, -43],
			[21, -77],
			[55, -19],
			[45, -55],
		],
		[
			[13857, 11317],
			[58, 9],
			[13, 32],
			[12, -3],
			[18, -27],
			[89, 46],
			[30, 48],
			[37, 42],
			[-7, 43],
			[20, 11],
			[69, -7],
			[67, 56],
			[51, 133],
			[36, 49],
			[45, 21],
		],
		[
			[14395, 11770],
			[8, -52],
			[41, -76],
			[0, -50],
			[-11, -50],
			[4, -38],
			[25, -35],
		],
		[
			[14462, 11469],
			[54, -53],
		],
		[
			[14516, 11416],
			[39, -50],
			[0, -39],
			[48, -64],
			[30, -52],
			[17, -73],
			[54, -48],
			[11, -39],
		],
		[
			[14715, 11051],
			[-23, -13],
			[-46, 3],
			[-53, 13],
			[-27, -11],
			[-10, -29],
			[-23, -4],
			[-28, 26],
			[-79, -61],
			[-33, 12],
			[-9, -9],
			[-22, -73],
			[-53, 23],
			[-52, 12],
			[-45, 45],
			[-58, 42],
			[-38, -40],
			[-28, -61],
			[-6, -85],
		],
		[
			[14082, 10841],
			[-46, 7],
			[-48, 20],
			[-42, -64],
			[-37, -114],
		],
		[
			[13909, 10690],
			[-8, 36],
			[-3, 55],
			[-32, 39],
			[-27, 63],
			[-6, 44],
			[-33, 63],
			[6, 36],
			[-7, 52],
			[5, 94],
			[17, 22],
			[36, 123],
		],
		[
			[8255, 16077],
			[51, -16],
			[66, 3],
			[-35, -50],
			[-26, -7],
			[-90, 51],
			[-18, 41],
			[27, 37],
			[25, -59],
		],
		[
			[8387, 16388],
			[-35, -2],
			[-92, 38],
			[-66, 58],
			[25, 10],
			[93, -31],
			[73, -51],
			[2, -22],
		],
		[
			[4008, 16316],
			[-35, -17],
			[-117, 55],
			[-21, 43],
			[-64, 43],
			[-12, 35],
			[-73, 21],
			[-28, 67],
			[6, 28],
			[75, -27],
			[43, -18],
			[67, -13],
			[24, -42],
			[35, -58],
			[71, -50],
			[29, -67],
		],
		[
			[8789, 16581],
			[-47, -107],
			[47, 41],
			[47, -26],
			[-25, -42],
			[63, -34],
			[33, 30],
			[71, -37],
			[-22, -89],
			[50, 20],
			[9, -64],
			[22, -76],
			[-30, -107],
			[-32, -4],
			[-47, 23],
			[15, 99],
			[-19, 16],
			[-83, -106],
			[-42, 4],
			[50, 57],
			[-68, 30],
			[-76, -7],
			[-138, 3],
			[-11, 36],
			[44, 43],
			[-30, 33],
			[59, 74],
			[73, 193],
			[44, 70],
			[62, 42],
			[33, -6],
			[-14, -33],
			[-38, -76],
		],
		[
			[3356, 16988],
			[68, 10],
			[-22, -138],
			[62, -98],
			[-28, 1],
			[-43, 55],
			[-26, 56],
			[-36, 38],
			[-13, 54],
			[4, 38],
			[34, -16],
		],
		[
			[7148, 17976],
			[-28, -64],
			[-31, 11],
			[-19, 36],
			[3, 8],
			[28, 37],
			[29, -3],
			[18, -25],
		],
		[
			[6961, 18043],
			[-83, -67],
			[-50, 3],
			[-16, 33],
			[53, 56],
			[98, -1],
			[-2, -24],
		],
		[
			[6730, 18402],
			[13, -54],
			[36, 19],
			[41, -32],
			[78, -42],
			[81, -37],
			[7, -58],
			[52, 9],
			[50, -40],
			[-62, -38],
			[-111, 29],
			[-40, 55],
			[-70, -65],
			[-101, -63],
			[-24, 71],
			[-97, -12],
			[62, 61],
			[9, 95],
			[24, 112],
			[52, -10],
		],
		[
			[7389, 18583],
			[-79, -6],
			[-18, 60],
			[30, 68],
			[65, 17],
			[56, -34],
			[0, -52],
			[-8, -17],
			[-46, -36],
		],
		[
			[5985, 18822],
			[-44, -43],
			[-95, 37],
			[-58, -14],
			[-97, 55],
			[62, 38],
			[50, 53],
			[75, -35],
			[43, -22],
			[21, -23],
			[43, -46],
		],
		[
			[8009, 15905],
			[-47, 69],
			[0, 166],
			[-31, 35],
			[-48, -20],
			[-23, 32],
			[-55, -92],
			[-21, -95],
			[-25, -55],
			[-31, -19],
			[-22, -6],
			[-7, -30],
			[-131, 0],
			[-108, -1],
			[-32, -23],
			[-75, -87],
			[-9, -10],
			[-23, -47],
			[-65, 0],
			[-69, 0],
			[-32, -20],
			[11, -24],
			[6, -37],
			[-1, -12],
			[-93, -61],
			[-73, -19],
			[-82, -65],
			[-18, 0],
			[-24, 19],
			[-8, 18],
			[1, 13],
			[16, 42],
			[33, 67],
			[21, 72],
			[-14, 106],
			[-15, 110],
			[-74, 57],
			[9, 22],
			[-11, 15],
			[-19, 0],
			[-15, 19],
			[-3, 29],
			[-14, -13],
			[-19, 4],
			[4, 12],
			[-16, 12],
			[-7, 32],
			[-55, 39],
			[-58, 40],
			[-69, 47],
			[-67, 45],
			[-63, -35],
			[-23, -1],
			[-88, 32],
			[-57, -16],
			[-69, 37],
			[-72, 20],
			[-50, 7],
			[-22, 21],
			[-13, 67],
			[-24, -1],
			[0, -47],
			[-147, 0],
			[-242, 0],
			[-242, 0],
			[-213, 0],
			[-212, 0],
			[-210, 0],
			[-216, 0],
			[-70, 0],
			[-210, 0],
			[-202, 0],
		],
		[
			[4056, 16375],
			[-10, 1],
			[-137, 119],
			[-51, 53],
			[-128, 50],
			[-40, 108],
			[10, 74],
			[-90, 52],
			[-13, 98],
			[-86, 89],
			[-1, 62],
			[39, 59],
			[-2, 77],
		],
		[
			[3547, 17217],
			[-120, 77],
			[-73, 139],
		],
		[
			[3354, 17433],
			[-44, 87],
			[-65, 55],
		],
		[
			[3245, 17575],
			[-48, 50],
			[-38, 63],
			[-71, -40],
			[-69, -68],
			[-63, 80],
		],
		[
			[2956, 17660],
			[-49, 54],
			[-70, 33],
			[-69, 4],
			[0, 692],
			[0, 452],
			[133, -29],
			[111, -59],
			[74, -11],
			[63, 51],
			[86, 38],
			[105, -15],
			[106, 53],
			[116, 31],
			[49, -51],
			[53, 29],
			[16, 57],
			[49, -13],
			[120, -109],
			[95, 82],
			[9, -92],
			[87, 20],
			[27, 35],
			[86, -7],
			[109, -51],
			[166, -44],
			[97, -21],
			[70, 8],
			[95, -62],
			[-99, -60],
			[128, -26],
			[191, 14],
			[61, 21],
			[76, -73],
			[77, 62],
			[-73, 52],
			[46, 41],
			[87, 6],
			[56, 12],
			[58, -29],
			[71, -66],
			[79, 10],
			[125, -55],
			[111, 19],
			[103, -3],
			[-8, 76],
			[63, 21],
			[110, -41],
			[0, -115],
			[45, 97],
			[57, -3],
			[32, 122],
			[-76, 75],
			[-83, 49],
			[6, 134],
			[84, 89],
			[93, -20],
			[72, -54],
			[96, -137],
			[-63, -59],
			[132, -25],
			[0, -124],
			[95, 95],
			[85, -78],
			[-21, -91],
			[68, -82],
			[74, 88],
			[52, 105],
			[4, 134],
			[101, -10],
			[105, -18],
			[95, -60],
			[4, -60],
			[-53, -65],
			[50, -65],
			[-9, -59],
			[-138, -85],
			[-99, -19],
			[-74, 36],
			[-21, -61],
			[-68, -102],
			[-21, -54],
			[-82, -82],
			[-102, -8],
			[-56, -51],
			[-4, -79],
			[-83, -16],
			[-87, -98],
			[-77, -137],
			[-27, -96],
			[-4, -141],
			[104, -21],
			[32, -114],
			[33, -92],
			[100, 24],
			[131, -52],
			[71, -47],
			[51, -57],
			[89, -34],
			[75, -51],
			[117, -7],
			[78, -12],
			[-12, -105],
			[22, -122],
			[51, -136],
			[106, -116],
			[55, 40],
			[38, 125],
			[-37, 192],
			[-50, 64],
			[114, 57],
			[80, 85],
			[39, 85],
			[-6, 81],
			[-48, 104],
			[-86, 91],
			[84, 128],
			[-31, 110],
			[-24, 190],
			[50, 28],
			[121, -33],
			[73, -12],
			[59, 32],
			[66, -41],
			[87, -71],
			[22, -47],
			[126, -9],
			[-2, -103],
			[24, -153],
			[65, -19],
			[51, -72],
			[103, 68],
			[68, 134],
			[47, 56],
			[55, -108],
			[92, -155],
			[79, -146],
			[-29, -77],
			[95, -68],
			[64, -70],
			[113, -31],
			[45, -39],
			[28, -103],
			[56, -16],
			[28, -46],
			[5, -137],
			[-51, -46],
			[-51, -42],
			[-117, -44],
			[-89, -99],
			[-120, -20],
			[-152, 25],
			[-107, 1],
			[-73, -8],
			[-59, -87],
			[-91, -54],
			[-102, -161],
			[-82, -113],
			[60, 20],
			[114, 160],
			[149, 102],
			[106, 12],
			[63, -60],
			[-67, -82],
			[23, -131],
			[23, -92],
			[92, -60],
			[117, 17],
			[71, 137],
			[5, -88],
			[46, -44],
			[-88, -80],
			[-157, -72],
			[-70, -50],
			[-80, -87],
			[-54, 9],
			[-2, 103],
			[123, 100],
			[-114, -4],
			[-78, -15],
		],
		[
			[4671, 19310],
			[-35, -57],
			[158, 37],
			[99, -62],
			[80, 62],
			[65, -40],
			[58, -119],
			[35, 50],
			[-50, 125],
			[62, 18],
			[71, -20],
			[79, -49],
			[45, -118],
			[22, -86],
			[119, -60],
			[128, -58],
			[-8, -53],
			[-116, -10],
			[45, -47],
			[-24, -45],
			[-128, 19],
			[-122, 33],
			[-83, -7],
			[-133, -41],
			[-180, -19],
			[-126, -11],
			[-38, 57],
			[-97, 33],
			[-63, -13],
			[-88, 96],
			[47, 13],
			[110, 21],
			[100, -6],
			[93, 22],
			[-138, 28],
			[-151, -10],
			[-101, 3],
			[-37, 45],
			[164, 48],
			[-109, -1],
			[-124, 32],
			[59, 91],
			[50, 48],
			[190, 74],
			[72, -23],
		],
		[
			[5357, 19346],
			[-62, -80],
			[-111, 85],
			[24, 17],
			[95, 5],
			[54, -27],
		],
		[
			[7356, 19307],
			[6, -33],
			[-76, 3],
			[-76, 3],
			[-78, -16],
			[-20, 7],
			[-78, 65],
			[3, 43],
			[34, 8],
			[162, -13],
			[123, -67],
		],
		[
			[6630, 19314],
			[56, -76],
			[66, 98],
			[180, 50],
			[121, -125],
			[-10, -80],
			[140, 35],
			[67, 49],
			[158, -62],
			[97, -58],
			[10, -53],
			[131, 27],
			[74, -77],
			[172, -48],
			[61, -49],
			[67, -114],
			[-130, -57],
			[167, -79],
			[113, -27],
			[102, -112],
			[112, -8],
			[-22, -85],
			[-125, -141],
			[-87, 52],
			[-112, 117],
			[-92, -16],
			[-9, -69],
			[75, -71],
			[96, -56],
			[29, -32],
			[47, -121],
			[-25, -87],
			[-89, 33],
			[-178, 97],
			[100, -105],
			[74, -73],
			[12, -43],
			[-193, 49],
			[-152, 71],
			[-86, 59],
			[25, 34],
			[-106, 63],
			[-104, 59],
			[2, -36],
			[-206, -19],
			[-60, 42],
			[47, 89],
			[133, 3],
			[146, 15],
			[-23, 44],
			[24, 60],
			[92, 119],
			[-19, 54],
			[-28, 41],
			[-108, 59],
			[-144, 42],
			[45, 30],
			[-75, 76],
			[-62, 7],
			[-56, 41],
			[-38, -36],
			[-129, -15],
			[-258, 27],
			[-150, 36],
			[-115, 18],
			[-59, 43],
			[74, 55],
			[-101, 1],
			[-22, 123],
			[54, 109],
			[73, 49],
			[183, 33],
			[-52, -79],
		],
		[
			[5651, 19398],
			[85, -26],
			[127, 15],
			[18, -35],
			[-66, -58],
			[107, -53],
			[-13, -109],
			[-116, -47],
			[-68, 10],
			[-49, 47],
			[-177, 93],
			[2, 39],
			[145, -15],
			[-79, 80],
			[84, 59],
		],
		[
			[6159, 19267],
			[-76, -91],
			[-81, 5],
			[-44, 107],
			[1, 60],
			[37, 52],
			[71, 33],
			[148, -4],
			[135, -30],
			[-106, -108],
			[-85, -24],
		],
		[
			[4225, 19098],
			[-187, -58],
			[-37, 53],
			[-164, 64],
			[30, 52],
			[49, 89],
			[62, 80],
			[-69, 74],
			[239, 19],
			[102, -25],
			[181, -7],
			[69, -35],
			[76, -51],
			[-89, -31],
			[-174, -85],
			[-88, -86],
			[0, -53],
		],
		[
			[6130, 19536],
			[-39, -47],
			[-103, 9],
			[-86, 32],
			[38, 54],
			[102, 33],
			[62, -43],
			[26, -38],
		],
		[
			[5783, 19748],
			[54, -57],
			[3, -62],
			[-33, -91],
			[-117, -12],
			[-76, 19],
			[1, 71],
			[-116, -9],
			[-4, 94],
			[76, -4],
			[107, 42],
			[100, -7],
			[5, 16],
		],
		[
			[5094, 19684],
			[28, -43],
			[63, 21],
			[74, -6],
			[13, -59],
			[-43, -58],
			[-241, -19],
			[-179, -53],
			[-108, -2],
			[-9, 39],
			[148, 54],
			[-321, -14],
			[-99, 21],
			[97, 119],
			[67, 34],
			[199, -41],
			[126, -72],
			[124, -9],
			[-101, 116],
			[65, 45],
			[73, -15],
			[24, -58],
		],
		[
			[6054, 19794],
			[79, -40],
			[139, 1],
			[62, -40],
			[-17, -46],
			[82, -28],
			[45, -28],
			[96, -6],
			[103, -10],
			[113, 26],
			[144, 11],
			[116, -9],
			[76, -46],
			[16, -50],
			[-45, -32],
			[-105, -27],
			[-91, 15],
			[-204, -18],
			[-146, -3],
			[-114, 15],
			[-189, 40],
			[-24, 66],
			[-9, 61],
			[-71, 53],
			[-147, 15],
			[-82, 37],
			[27, 50],
			[146, -7],
		],
		[
			[4527, 19860],
			[-9, -93],
			[-55, -43],
			[-66, -6],
			[-132, -52],
			[-114, -18],
			[-96, 26],
			[0, 0],
			[120, 91],
			[146, 79],
			[109, -2],
			[97, 18],
		],
		[
			[6114, 19845],
			[-33, -4],
			[-133, 8],
			[-18, 34],
			[142, -2],
			[50, -22],
			[-8, -14],
		],
		[
			[4954, 19866],
			[-132, -35],
			[-106, 40],
			[58, 38],
			[103, 13],
			[100, -19],
			[-23, -37],
		],
		[
			[4991, 19976],
			[-86, -23],
			[-118, 0],
			[1, 17],
			[73, 37],
			[38, -6],
			[92, -25],
		],
		[
			[5973, 19910],
			[-105, -25],
			[-58, 28],
			[-31, 46],
			[-5, 50],
			[92, -5],
			[41, -8],
			[85, -42],
			[-19, -44],
		],
		[
			[5672, 19943],
			[28, -51],
			[-116, 14],
			[-117, 39],
			[-158, 5],
			[69, 36],
			[-86, 29],
			[-5, 47],
			[139, -17],
			[192, -44],
			[54, -58],
		],
		[
			[6598, 20105],
			[85, -39],
			[-97, -36],
			[-131, -92],
			[-126, -9],
			[-147, 16],
			[-76, 50],
			[1, 44],
			[56, 32],
			[-130, -1],
			[-78, 41],
			[-45, 55],
			[49, 54],
			[50, 37],
			[72, 8],
			[-31, 28],
			[165, 7],
			[91, -65],
			[119, -26],
			[117, -24],
			[56, -80],
		],
		[
			[7912, 20524],
			[190, -9],
			[152, -16],
			[130, -33],
			[-3, -32],
			[-174, -53],
			[-171, -25],
			[-64, -27],
			[154, 1],
			[-167, -74],
			[-116, -34],
			[-121, -100],
			[-147, -20],
			[-45, -25],
			[-215, -13],
			[98, -15],
			[-49, -22],
			[59, -60],
			[-68, -41],
			[-109, -35],
			[-34, -48],
			[-99, -36],
			[10, -27],
			[121, 4],
			[2, -29],
			[-190, -73],
			[-185, 33],
			[-209, -19],
			[-105, 15],
			[-135, 6],
			[-9, 59],
			[132, 27],
			[-35, 88],
			[43, 9],
			[190, -53],
			[-97, 78],
			[-115, 23],
			[57, 48],
			[126, 29],
			[20, 42],
			[-100, 47],
			[-30, 63],
			[194, -5],
			[56, -13],
			[111, 44],
			[-160, 14],
			[-248, -8],
			[-126, 42],
			[-59, 49],
			[-83, 36],
			[-15, 41],
			[105, 23],
			[83, 4],
			[139, 20],
			[105, 45],
			[88, -6],
			[76, -34],
			[54, 65],
			[94, 20],
			[127, 13],
			[217, 5],
			[38, -13],
			[204, 21],
			[154, -8],
			[154, -8],
		],
		[
			[13513, 16119],
			[-5, -50],
			[-31, -20],
			[-53, 15],
			[-15, -49],
			[-34, -4],
			[-12, 19],
			[-40, -41],
			[-34, -6],
			[-31, 26],
		],
		[
			[13258, 16009],
			[-24, 54],
			[-34, -19],
			[1, 55],
			[52, 68],
			[-2, 31],
			[32, -11],
			[19, 21],
		],
		[
			[13302, 16208],
			[61, -1],
			[14, 26],
			[76, -37],
		],
		[
			[8021, 3736],
			[-23, -49],
			[-61, -38],
			[-35, 4],
			[-42, 10],
			[-52, 36],
			[-74, 18],
			[-89, 68],
			[-73, 65],
			[-97, 137],
			[58, -26],
			[100, -81],
			[94, -44],
			[36, 56],
			[23, 83],
			[66, 51],
			[50, -15],
		],
		[
			[7907, 4052],
			[-63, 1],
			[-35, -30],
			[-64, -44],
			[-11, -113],
			[-30, -3],
			[-80, 39],
			[-81, 85],
			[0, 0],
			[-89, 70],
			[-22, 77],
			[20, 71],
			[-35, 81],
			[-10, 207],
			[31, 117],
			[75, 94],
			[-108, 36],
			[67, 107],
			[25, 202],
			[78, -43],
			[38, 252],
			[-48, 33],
			[-22, -152],
			[-45, 17],
			[22, 174],
			[24, 225],
			[33, 84],
			[-20, 118],
			[-6, 137],
			[30, 4],
			[43, 197],
			[49, 194],
			[30, 182],
			[-16, 182],
			[21, 100],
			[-8, 150],
			[41, 149],
			[13, 235],
			[23, 253],
			[22, 272],
			[-5, 199],
			[-15, 171],
		],
		[
			[7779, 8182],
			[36, 31],
			[19, 63],
		],
		[
			[20602, 12687],
			[-61, -59],
			[-59, 38],
			[-2, 105],
			[35, 55],
			[78, 34],
			[41, -3],
			[16, -47],
			[-32, -53],
			[-16, -70],
		],
		[
			[21954, 16429],
			[84, -87],
		],
		[
			[22038, 16342],
			[29, -114],
			[108, 0],
			[61, 48],
		],
		[
			[22236, 16276],
			[118, 36],
		],
		[
			[22354, 16312],
			[-38, -110],
			[-27, -44],
			[-24, -133],
		],
		[
			[22265, 16025],
			[-48, -119],
			[-86, 22],
		],
		[
			[22131, 15928],
			[-61, -43],
			[19, -104],
		],
		[
			[22089, 15781],
			[-11, -144],
			[-36, -3],
		],
		[
			[22042, 15634],
			[0, -62],
		],
		[
			[22042, 15572],
			[-45, 72],
			[-29, -68],
			[-109, -53],
			[11, -64],
			[-61, 4],
			[-34, 38],
			[-49, -86],
			[-78, -65],
			[-58, -78],
		],
		[
			[21590, 15272],
			[-99, -36],
			[-52, -56],
			[-77, -34],
			[38, 57],
			[-15, 47],
			[56, 82],
			[-37, 64],
			[-62, -43],
			[-80, -85],
			[-44, -78],
			[-69, -6],
			[-37, -57],
			[38, -82],
			[58, -20],
			[2, -55],
			[56, -35],
			[80, 86],
			[63, -47],
			[46, -3],
			[11, -64],
			[-100, -34],
			[-33, -66],
			[-69, -61],
			[-37, -85],
			[77, -67],
			[28, -119],
			[43, -112],
			[48, -93],
			[-1, -91],
			[-45, -33],
			[17, -65],
			[42, -37],
			[-11, -99],
			[-18, -97],
			[-40, -11],
			[-51, -131],
			[-58, -160],
			[-66, -145],
			[-97, -113],
			[-99, -102],
			[-80, -14],
			[-43, -54],
			[-25, 39],
			[-40, -60],
			[-99, -61],
			[-75, -19],
			[-25, -128],
			[-39, -7],
			[-19, 88],
			[17, 47],
			[-95, 39],
			[-33, -20],
		],
		[
			[20440, 13036],
			[-72, 32],
			[-34, 49],
			[12, 70],
			[-65, 23],
			[-35, 45],
			[-60, -65],
			[-69, -14],
			[-57, 1],
			[-38, -30],
		],
		[
			[20022, 13147],
			[-36, -18],
			[10, -139],
			[-38, 4],
			[-6, 28],
		],
		[
			[19952, 13022],
			[-2, 51],
			[-52, -36],
			[-31, 23],
			[-53, 45],
			[21, 101],
			[-45, 24],
			[-17, 112],
			[-75, -20],
			[9, 144],
			[67, 102],
			[3, 100],
			[-2, 93],
			[-31, 29],
			[-24, 72],
			[-41, -9],
		],
		[
			[19679, 13853],
			[-77, 18],
			[24, 51],
			[-33, 75],
			[-51, -51],
			[-59, 30],
			[-82, -77],
			[-65, -91],
			[-57, -15],
		],
		[
			[19075, 13735],
			[-6, 96],
			[-44, -25],
		],
		[
			[19025, 13806],
			[-82, 12],
			[-81, 27],
			[-57, 54],
			[-55, 24],
			[-24, 58],
			[-40, 18],
			[-72, 79],
			[-57, 37],
			[-29, -29],
		],
		[
			[18528, 14086],
			[-99, 85],
			[-69, 77],
			[-20, 135],
			[51, -17],
			[2, 62],
			[-28, 63],
			[7, 99],
			[-76, 142],
		],
		[
			[18296, 14732],
			[-117, 50],
			[-21, 93],
			[-52, 57],
		],
		[
			[18093, 14967],
			[-11, 69],
			[3, 47],
			[-43, 28],
			[-24, -12],
			[-18, 112],
		],
		[
			[18000, 15211],
			[21, 28],
			[-10, 29],
			[68, 57],
			[49, 24],
			[75, -16],
			[27, 77],
			[91, 15],
			[25, 48],
			[112, 66],
			[10, 27],
		],
		[
			[18468, 15566],
			[-6, 70],
			[49, 31],
			[-64, 212],
			[140, 48],
			[37, 27],
			[51, 218],
			[141, -40],
			[39, 55],
			[3, 122],
			[59, 12],
			[54, 81],
		],
		[
			[18971, 16402],
			[28, 10],
		],
		[
			[18999, 16412],
			[19, -85],
			[59, -65],
			[102, -46],
			[49, -98],
			[-28, -142],
			[26, -52],
			[84, -21],
			[96, -17],
			[85, -76],
			[44, -14],
			[33, -112],
			[41, -72],
			[79, 3],
			[146, -27],
			[94, 17],
			[70, -19],
			[105, -73],
			[86, 0],
			[32, -38],
			[82, 65],
			[115, 42],
			[106, 5],
			[83, 43],
			[51, 65],
			[50, 41],
			[-12, 40],
			[-22, 47],
			[37, 78],
			[40, -11],
			[73, -24],
			[70, 64],
			[109, 47],
			[52, 81],
			[50, 34],
			[103, 16],
			[56, -13],
			[7, 43],
			[-64, 85],
			[-57, 39],
			[-54, -45],
			[-70, 19],
			[-41, -16],
			[-18, 50],
			[50, 122],
			[35, 91],
		],
		[
			[21052, 16483],
			[85, -45],
			[100, 76],
		],
		[
			[21237, 16514],
			[-1, 54],
			[64, 129],
			[40, 39],
			[-1, 67],
		],
		[
			[21339, 16803],
			[-39, 29],
			[59, 61],
			[88, 21],
		],
		[
			[21447, 16914],
			[94, 4],
			[106, -36],
		],
		[
			[21647, 16882],
			[62, -45],
			[44, -123],
			[27, -52],
			[25, -75],
		],
		[
			[21805, 16587],
			[26, -119],
			[123, -39],
		],
		[
			[12570, 11022],
			[-32, -1],
			[-50, 24],
			[-45, -2],
			[-85, -21],
			[-49, -35],
			[-70, -45],
			[-14, 3],
		],
		[
			[12225, 10945],
			[6, 101],
			[6, 15],
			[-2, 48],
			[-30, 51],
			[-22, 8],
			[-21, 33],
			[15, 54],
			[-7, 59],
			[4, 35],
		],
		[
			[12174, 11349],
			[11, 1],
			[4, 53],
			[-5, 23],
			[6, 17],
			[27, 15],
			[-18, 97],
			[-16, 50],
			[6, 42],
			[14, 9],
		],
		[
			[12203, 11656],
			[9, 11],
			[20, -18],
			[54, -1],
			[13, 35],
			[13, -2],
			[20, 14],
			[11, -52],
			[17, 15],
			[29, 18],
		],
		[
			[12572, 11587],
			[19, -173],
			[-30, -102],
			[-19, -137],
			[31, -105],
			[-3, -48],
		],
		[
			[13700, 10690],
			[-8, 7],
			[-42, -16],
			[-44, 17],
			[-33, -8],
		],
		[
			[13573, 10690],
			[-116, 2],
		],
		[
			[13457, 10692],
			[11, 96],
			[-28, 81],
			[-33, 20],
			[-14, 55],
			[-18, 17],
			[1, 34],
		],
		[
			[13376, 10995],
			[18, 86],
			[34, 117],
			[20, 2],
			[42, 71],
			[27, 2],
			[40, -50],
			[49, 41],
			[7, 50],
			[16, 49],
			[11, 62],
			[37, 50],
			[15, 85],
			[15, 27],
			[10, 63],
			[19, 78],
			[59, 94],
			[4, 41],
			[8, 22],
			[-28, 48],
		],
		[
			[13779, 11933],
			[2, 39],
			[20, 7],
		],
		[
			[13801, 11979],
			[28, -78],
			[5, -81],
		],
		[
			[13834, 11820],
			[-3, -81],
			[39, -110],
			[-40, 1],
			[-20, -9],
			[-32, 13],
			[-15, -58],
			[42, -71],
			[30, -20],
			[10, -51],
			[23, -84],
			[-11, -33],
		],
		[
			[13909, 10690],
			[-5, -65],
			[-57, 28],
			[-57, 32],
			[-90, 5],
		],
		[
			[14985, 10683],
			[-23, -44],
			[-28, -32],
			[-27, -63],
			[-15, -57],
		],
		[
			[14892, 10487],
			[-4, -98],
			[-16, -46],
		],
		[
			[14872, 10343],
			[-1, -92],
		],
		[
			[14871, 10251],
			[-20, -34],
			[-3, -72],
			[-9, -9],
			[-7, -67],
		],
		[
			[14854, 9867],
			[13, -112],
			[-7, -63],
		],
		[
			[14860, 9692],
			[14, -71],
			[41, -68],
			[39, -153],
		],
		[
			[14954, 9400],
			[-28, 12],
			[-96, -20],
			[-19, -15],
			[-20, -77],
			[16, -54],
			[-12, -144],
			[-9, -122],
			[19, -22],
			[50, -47],
			[19, 22],
			[6, -131],
			[-54, 1],
			[-30, 67],
			[-26, 51],
			[-54, 17],
			[-16, 64],
			[-43, -38],
			[-57, 17],
			[-24, 55],
			[-45, 11],
			[-33, -3],
			[-4, 38],
			[-25, 3],
		],
		[
			[13647, 9672],
			[-10, 38],
		],
		[
			[13695, 9833],
			[18, -13],
			[25, 47],
			[38, -1],
			[5, -35],
			[26, -21],
			[42, 76],
			[41, 59],
			[18, 39],
			[-2, 100],
			[31, 119],
			[32, 62],
			[47, 59],
			[8, 39],
			[2, 44],
			[11, 43],
			[-3, 69],
			[9, 107],
			[13, 76],
			[22, 65],
			[4, 74],
		],
		[
			[14715, 11051],
			[43, -100],
			[32, -15],
			[19, 20],
			[33, -8],
			[39, 26],
		],
		[
			[14881, 10974],
			[17, -52],
			[62, -81],
			[-4, -142],
			[29, -16],
		],
		[
			[13618, 9802],
			[-58, 128],
		],
		[
			[13560, 9930],
			[54, 68],
			[-27, 80],
			[24, 31],
			[48, 15],
			[6, 53],
			[38, -58],
			[62, -5],
			[22, 57],
			[9, 81],
			[-8, 95],
			[-33, 72],
			[31, 141],
			[-18, 24],
			[-53, -10],
			[-20, 63],
			[5, 53],
		],
		[
			[7424, 10396],
			[-30, 29],
			[-35, 40],
			[-20, -19],
			[-60, 17],
			[-18, 52],
			[-13, -2],
			[-71, 69],
		],
		[
			[7177, 10582],
			[-10, 38],
			[27, 9],
			[-3, 61],
			[16, 44],
			[36, 9],
			[29, 76],
			[28, 64],
			[-27, 29],
			[14, 70],
			[-16, 112],
			[15, 32],
			[-11, 102],
			[-29, 65],
		],
		[
			[7246, 11293],
			[9, 59],
			[23, -8],
			[13, 36],
			[-16, 71],
			[9, 18],
		],
		[
			[7284, 11469],
			[36, -4],
			[54, 85],
			[29, 13],
			[0, 40],
			[14, 103],
			[40, 57],
			[45, 2],
			[6, 25],
			[55, -10],
			[56, 62],
			[28, 27],
			[34, 58],
			[25, -7],
			[19, -32],
			[-14, -41],
		],
		[
			[7711, 11847],
			[-46, -20],
			[-18, -61],
			[-27, -35],
			[-21, -45],
			[-8, -87],
			[-20, -71],
			[37, -8],
			[9, -56],
			[15, -27],
			[6, -49],
			[-9, -45],
			[3, -25],
			[17, -11],
			[17, -42],
			[92, 12],
			[41, -16],
			[50, -104],
			[28, 13],
			[52, -7],
			[40, 14],
			[25, -21],
			[-13, -66],
			[-16, -40],
			[-5, -88],
			[14, -80],
			[20, -37],
			[3, -27],
			[-36, -60],
			[26, -27],
			[18, -43],
			[22, -121],
		],
		[
			[7813, 9892],
			[-36, 64],
			[-21, 3],
			[46, 124],
			[-54, 57],
			[-43, -11],
			[-26, 21],
			[-39, -32],
			[-52, 16],
			[-42, 127],
			[-33, 31],
			[-23, 58],
			[-47, 57],
			[-19, -11],
		],
		[
			[6885, 11415],
			[-38, 27],
			[-15, 26],
			[9, 21],
			[-3, 27],
			[-20, 29],
			[-28, 24],
			[-24, 15],
			[-5, 36],
			[-18, 22],
			[4, -36],
			[-14, -29],
			[-16, 34],
			[-23, 12],
			[-10, 24],
			[1, 37],
			[9, 39],
			[-20, 17],
			[16, 23],
		],
		[
			[6690, 11763],
			[11, 16],
			[47, -32],
			[16, 16],
			[23, -10],
			[12, -26],
			[20, -8],
			[17, 26],
		],
		[
			[6836, 11745],
			[18, -66],
			[28, -49],
			[33, -52],
		],
		[
			[6915, 11578],
			[-27, -11],
			[0, -49],
			[15, -18],
			[-11, -14],
			[3, -22],
			[-6, -25],
			[-4, -24],
		],
		[
			[6935, 13235],
			[61, -8],
			[56, -2],
			[67, -41],
			[28, -45],
			[66, 14],
			[25, -28],
			[60, -76],
			[44, -55],
			[24, 2],
			[42, -25],
			[-5, -34],
			[52, -5],
			[54, -50],
			[-8, -28],
			[-48, -16],
			[-47, -6],
			[-49, 10],
			[-102, -12],
			[48, 68],
			[-29, 31],
			[-46, 8],
			[-25, 36],
			[-16, 69],
			[-40, -5],
			[-67, 33],
			[-21, 25],
			[-92, 19],
			[-25, 24],
			[26, 30],
			[-69, 7],
			[-51, -64],
			[-30, -1],
			[-10, -30],
			[-35, -13],
			[-30, 11],
			[37, 38],
			[16, 44],
			[32, 27],
			[36, 23],
			[54, 12],
			[17, 13],
		],
		[
			[15095, 14689],
			[5, 1],
			[10, 29],
			[51, -1],
			[65, 36],
			[-48, -52],
			[5, -23],
		],
		[
			[15183, 14679],
			[-7, 5],
			[-14, -10],
			[-11, 3],
			[-3, -5],
			[-2, 13],
			[-5, 7],
			[-13, 1],
			[-20, -10],
			[-13, 6],
		],
		[
			[15183, 14679],
			[2, -9],
			[-72, -50],
			[-35, 16],
			[-17, 49],
			[34, 4],
		],
		[
			[13737, 16360],
			[-40, 53],
			[-36, 29],
			[-8, 51],
			[-12, 36],
			[52, 27],
			[26, 30],
			[51, 24],
			[18, 23],
			[18, -14],
			[32, 13],
		],
		[
			[13838, 16632],
			[34, -40],
			[53, -10],
			[-5, -34],
			[39, -25],
			[10, 32],
			[49, -14],
			[7, -38],
			[53, -7],
			[32, -60],
		],
		[
			[14110, 16436],
			[-21, 0],
			[-11, -22],
			[-16, -6],
			[-5, -27],
			[-13, -6],
			[-2, -11],
			[-25, -13],
			[-31, 2],
			[-10, -27],
		],
		[
			[13477, 17103],
			[1, -47],
			[72, -28],
			[-1, -43],
			[72, 23],
			[40, 33],
			[80, -48],
			[33, -39],
		],
		[
			[13774, 16954],
			[17, -62],
			[-20, -32],
			[26, -44],
			[18, -65],
			[-6, -42],
			[29, -77],
		],
		[
			[13302, 16208],
			[9, 86],
			[36, 84],
			[-102, 22],
			[-34, 32],
		],
		[
			[13211, 16432],
			[4, 53],
			[-14, 28],
		],
		[
			[13209, 16595],
			[-12, 127],
			[43, 0],
			[18, 46],
			[18, 112],
			[-14, 41],
		],
		[
			[13262, 16921],
			[14, 25],
			[60, 7],
			[13, -27],
			[48, 60],
			[-16, 46],
			[-3, 69],
		],
		[
			[13378, 17101],
			[53, -16],
			[46, 18],
		],
		[
			[15829, 11959],
			[17, -37],
			[-2, -51],
			[-40, -29],
			[30, -33],
		],
		[
			[15834, 11809],
			[-26, -65],
		],
		[
			[15808, 11744],
			[-16, 21],
			[-17, -8],
			[-40, 2],
			[-1, 37],
			[-5, 33],
			[24, 57],
			[25, 54],
		],
		[
			[15778, 11940],
			[30, -10],
			[21, 29],
		],
		[
			[13673, 17179],
			[-43, -98],
			[-74, 69],
			[-10, 50],
			[104, 40],
			[23, -61],
		],
		[
			[13378, 17101],
			[-29, 67],
			[-2, 125],
			[11, 32],
			[21, 37],
			[62, 8],
			[25, 33],
			[57, 34],
			[-2, -62],
			[-21, -40],
			[8, -34],
			[39, -18],
			[-18, -46],
			[-21, 13],
			[-51, -88],
			[20, -59],
		],
		[
			[7684, 12813],
			[9, 20],
			[55, 0],
			[42, -31],
			[19, 3],
			[13, -43],
			[39, 2],
			[-3, -36],
			[32, -5],
			[35, -44],
			[-27, -50],
			[-33, 27],
			[-33, -6],
			[-23, 6],
			[-13, -22],
			[-27, -7],
			[-11, 29],
			[-24, -17],
			[-28, -84],
			[-18, 20],
			[-4, 35],
		],
		[
			[7684, 12610],
			[2, 33],
			[-19, 36],
			[18, 21],
			[5, 46],
			[-6, 67],
		],
		[
			[13624, 13270],
			[-243, -232],
			[-206, -239],
			[-100, -54],
		],
		[
			[13075, 12745],
			[-78, -12],
			[-1, 77],
			[-33, 20],
			[-44, 35],
			[-17, 57],
			[-239, 265],
			[-240, 266],
		],
		[
			[12423, 13453],
			[-267, 294],
		],
		[
			[12156, 13747],
			[2, 24],
			[0, 8],
		],
		[
			[12158, 13779],
			[-1, 144],
			[115, 90],
			[70, 18],
			[59, 33],
			[27, 61],
			[83, 48],
			[3, 90],
			[41, 11],
			[32, 45],
			[93, 20],
			[13, 48],
			[-19, 25],
			[-25, 129],
			[-4, 74],
			[-26, 78],
		],
		[
			[12619, 14693],
			[68, 66],
			[76, 21],
			[45, 51],
			[69, 37],
			[120, 21],
			[117, 10],
			[36, -18],
			[67, 48],
			[76, 1],
			[29, -28],
			[48, 7],
		],
		[
			[13370, 14909],
			[-14, -62],
			[11, -116],
			[-17, -101],
			[-44, -68],
			[7, -91],
			[58, -73],
			[0, -29],
			[44, -49],
			[30, -219],
		],
		[
			[13445, 14101],
			[23, -107],
			[4, -57],
			[-12, -99],
			[5, -55],
			[-9, -67],
			[6, -76],
			[-28, -51],
			[42, -89],
			[2, -52],
			[26, -68],
			[33, 23],
			[56, -57],
			[31, -76],
		],
		[
			[7074, 10000],
			[38, 91],
			[-15, 53],
			[-27, -56],
			[-43, 53],
			[15, 34],
			[-12, 111],
			[24, 18],
			[13, 76],
			[27, 78],
			[-5, 50],
			[39, 26],
			[49, 48],
		],
		[
			[7424, 10396],
			[10, -92],
			[-22, -80],
			[-77, -127],
			[-86, -48],
			[-43, -106],
			[-14, -82],
			[-40, -50],
			[-30, 62],
			[-28, 13],
			[-30, -10],
			[-1, 45],
			[20, 29],
			[-9, 50],
		],
		[
			[15388, 13091],
			[-281, 0],
			[-275, 0],
			[-286, 0],
		],
		[
			[14546, 13091],
			[0, 448],
			[0, 432],
			[-21, 98],
			[18, 75],
			[-11, 53],
			[26, 58],
		],
		[
			[14558, 14255],
			[95, 2],
			[68, -32],
			[70, -36],
			[33, -19],
			[55, 38],
			[29, 35],
			[63, 10],
			[50, -15],
			[19, -60],
			[17, 39],
			[57, -28],
			[55, -7],
			[35, 30],
			[47, -209],
			[-20, -49],
			[-16, -91],
			[-19, -64],
			[-16, -21],
			[-24, 39],
			[-32, 55],
			[-51, 174],
			[-7, -11],
			[29, -129],
			[44, -122],
			[54, -189],
			[26, -66],
			[23, -69],
			[63, -135],
			[-14, -21],
			[2, -79],
			[83, -109],
			[12, -25],
		],
		[
			[15778, 11940],
			[-25, 40],
			[-29, 71],
		],
		[
			[15724, 12051],
			[-31, 39],
			[-19, 42],
		],
		[
			[15674, 12132],
			[-61, 49],
			[-49, 1],
		],
		[
			[15564, 12182],
			[-17, 26],
			[-42, -29],
			[-43, 55],
			[-22, -91],
			[-83, 26],
		],
		[
			[15357, 12169],
			[-7, 49],
			[30, 178],
			[7, 81],
		],
		[
			[15387, 12477],
			[23, 38],
			[52, 20],
			[36, 69],
		],
		[
			[15498, 12604],
			[41, -141],
			[20, -112],
			[39, -59],
			[97, -115],
			[39, -69],
			[38, -70],
			[23, -42],
			[34, -37],
		],
		[
			[12131, 15509],
			[4, 87],
			[-29, 53],
			[100, 88],
			[87, -22],
			[95, 0],
			[76, -20],
			[59, 6],
			[115, -4],
		],
		[
			[12638, 15697],
			[28, -47],
			[130, -56],
			[26, 27],
			[80, -55],
			[82, 15],
		],
		[
			[12984, 15581],
			[4, -70],
			[-67, -81],
			[-91, -26],
			[-6, -41],
			[-44, -67],
			[-27, -99],
			[27, -70],
			[-41, -54],
			[-15, -79],
			[-54, -25],
			[-50, -93],
			[-90, -2],
			[-68, 2],
			[-44, -43],
			[-27, -46],
			[-35, 11],
			[-26, 41],
			[-20, 70],
			[-66, 18],
		],
		[
			[12244, 14927],
			[-6, 41],
			[26, 45],
			[10, 33],
			[-25, 37],
			[20, 80],
			[-29, 72],
			[31, 10],
			[3, 58],
			[11, 18],
			[1, 95],
			[33, 33],
			[-20, 61],
			[-41, 4],
			[-12, -15],
			[-42, -1],
			[-18, 60],
			[-29, -18],
			[-26, -31],
		],
		[
			[14498, 17445],
			[8, 72],
			[-26, -15],
			[-45, 43],
			[-6, 70],
			[89, 34],
			[90, 17],
			[77, -20],
			[73, 4],
			[11, -22],
		],
		[
			[14769, 17628],
			[-51, -70],
			[21, -113],
		],
		[
			[14739, 17445],
			[-30, -39],
		],
		[
			[14709, 17406],
			[-59, 1],
			[-61, 45],
			[-31, 15],
			[-60, -22],
		],
		[
			[15564, 12182],
			[49, -1],
			[61, -49],
		],
		[
			[15674, 12132],
			[19, -42],
			[31, -39],
		],
		[
			[15808, 11744],
			[-16, -43],
			[27, -67],
		],
		[
			[15819, 11634],
			[26, -59],
			[27, -43],
		],
		[
			[15872, 11532],
			[232, -145],
			[60, 1],
		],
		[
			[16164, 11388],
			[-201, -365],
			[-92, -5],
			[-64, -86],
			[-45, -2],
			[-20, -39],
		],
		[
			[15742, 10891],
			[-48, 0],
			[-29, 41],
			[-64, -51],
			[-21, -50],
			[-48, 9],
			[-15, 14],
			[-17, -3],
			[-23, 1],
			[-89, 104],
			[-50, 0],
			[-24, 40],
			[0, 68],
			[-37, 20],
		],
		[
			[15277, 11084],
			[-42, 133],
			[-32, 28],
			[-13, 49],
			[-36, 59],
			[-43, 9],
			[24, 69],
			[38, 3],
			[10, 37],
		],
		[
			[15183, 11471],
			[-1, 109],
		],
		[
			[15182, 11580],
			[21, 128],
			[34, 34],
			[7, 49],
			[31, 93],
			[42, 61],
			[29, 119],
			[11, 105],
		],
		[
			[14801, 18816],
			[-10, -85],
			[109, -81],
			[-66, -92],
			[83, -138],
			[-48, -104],
			[64, -91],
			[-29, -79],
			[105, -84],
			[-27, -62],
			[-66, -70],
		],
		[
			[14916, 17930],
			[-152, -155],
			[-128, -10],
			[-125, -44],
			[-116, -26],
			[-41, 66],
			[-69, 40],
			[16, 120],
			[-34, 110],
			[34, 71],
			[64, 76],
			[162, 132],
			[48, 25],
			[-8, 52],
			[-98, 57],
		],
		[
			[14469, 18444],
			[-24, 48],
			[-2, 187],
			[-111, 83],
			[-95, 59],
		],
		[
			[14237, 18821],
			[43, 32],
			[79, -64],
			[93, 6],
			[76, -29],
			[67, 54],
			[35, 89],
			[110, 41],
			[91, -48],
			[-30, -86],
		],
		[
			[25430, 8305],
			[24, -35],
			[-12, -64],
			[-44, -16],
			[-39, 15],
			[-7, 53],
			[28, 42],
			[32, -15],
			[18, 20],
		],
		[
			[25500, 8371],
			[-45, -26],
			[-10, 45],
			[36, 25],
			[22, 7],
			[42, 38],
			[0, -60],
			[-45, -29],
		],
		[
			[6, 8407],
			[-6, -7],
			[0, 60],
			[15, 5],
			[-9, -58],
		],
		[
			[8430, 4107],
			[85, 73],
			[60, -31],
			[43, 49],
			[57, -55],
			[-22, -42],
			[-95, -37],
			[-32, 43],
			[-61, -55],
			[-35, 55],
		],
		[
			[13451, 15542],
			[-24, -94],
			[-32, 25],
			[-16, 82],
			[14, 45],
			[46, 47],
			[12, -105],
		],
		[
			[13175, 16440],
			[16, -11],
			[20, 3],
		],
		[
			[13258, 16009],
			[-3, -34],
			[21, -46],
			[-25, -37],
			[19, -94],
			[38, -15],
			[-8, -53],
		],
		[
			[13300, 15730],
			[-64, -69],
			[-140, 33],
			[-104, -39],
			[-8, -74],
		],
		[
			[12638, 15697],
			[36, 73],
			[14, 242],
			[-73, 128],
			[-53, 61],
			[-108, 47],
			[-7, 89],
			[92, 26],
			[119, -31],
			[-23, 138],
			[67, -52],
			[165, 94],
			[22, 100],
			[62, 25],
		],
		[
			[13560, 9930],
			[-73, 123],
			[-47, 101],
			[-43, 125],
			[2, 41],
			[16, 39],
			[17, 88],
			[14, 90],
		],
		[
			[13446, 10537],
			[24, 7],
			[103, -1],
			[0, 147],
		],
		[
			[12631, 17203],
			[145, -244],
			[54, -92],
			[66, -39],
			[-3, -85],
			[-65, -56],
			[49, -20],
			[-9, -38],
			[-211, -67],
			[-94, 24],
			[-49, -63],
			[-68, 15],
			[-37, -33],
			[-47, -9],
			[67, 71],
			[21, 50],
			[25, 0],
			[-2, 29],
			[78, -5],
			[35, 54],
			[1, 25],
			[-33, 23],
			[6, 173],
			[-41, 141],
			[99, 102],
			[-8, 24],
			[21, 20],
		],
		[
			[12333, 16968],
			[-54, 25],
			[-44, -2],
			[15, 65],
			[-15, 65],
		],
		[
			[12235, 17121],
			[60, 5],
			[76, -75],
			[-38, -83],
		],
		[
			[15721, 15467],
			[11, 52],
			[-18, 83],
			[-41, 45],
			[-39, 14],
			[-26, 37],
		],
		[
			[15608, 15698],
			[8, 15],
		],
		[
			[15616, 15713],
			[60, -21],
			[105, -20],
			[96, -58],
			[13, -23],
			[43, 19],
		],
		[
			[15933, 15610],
			[66, -25],
		],
		[
			[15999, 15585],
			[22, -50],
			[44, -28],
		],
		[
			[15865, 15413],
			[-68, 60],
			[-76, -6],
		],
		[
			[12473, 16778],
			[-39, 64],
			[14, 80],
			[105, -10],
			[6, 0],
			[-7, -169],
			[15, -12],
			[16, -11],
			[0, -26],
			[-54, -23],
			[-110, 18],
			[-20, 51],
			[74, 38],
		],
		[
			[12557, 17551],
			[-77, -136],
			[75, 21],
			[83, -8],
			[-22, -96],
			[-62, -105],
			[72, -8],
			[3, -15],
			[-19, -20],
			[7, -26],
			[-99, -100],
			[-91, 20],
			[-15, 35],
			[24, 51],
			[-22, 33],
			[-38, -52],
			[-3, 110],
			[-39, 68],
			[25, 125],
			[53, 101],
			[64, -10],
			[81, 12],
		],
		[
			[12848, 11136],
			[-112, -72],
			[-39, -41],
			[-64, -36],
			[-63, 35],
		],
		[
			[12774, 11755],
			[-5, -38],
			[30, -63],
			[-1, -88],
			[7, -96],
			[18, -44],
			[-16, -110],
			[6, -60],
			[19, -78],
			[16, -42],
		],
		[
			[12174, 11349],
			[-20, 4],
			[-15, -49],
			[-20, 0],
			[-14, 26],
			[5, 49],
			[-30, 74],
			[-18, -13],
			[-15, -3],
		],
		[
			[12047, 11437],
			[-20, -7],
			[1, 45],
			[-12, 32],
			[3, 35],
			[-16, 51],
			[-19, 44],
			[-57, 0],
			[-17, -23],
			[-19, -3],
			[-12, -26],
			[-9, -34],
			[-37, -53],
		],
		[
			[11833, 11498],
			[-32, 72],
			[-27, 47],
			[-18, 16],
			[-18, 24],
			[-8, 54],
			[-10, 27],
			[-21, 20],
		],
		[
			[11699, 11758],
			[31, 59],
			[22, -2],
			[18, 20],
			[16, 0],
			[11, 16],
			[-6, 41],
			[8, 12],
			[1, 42],
		],
		[
			[11800, 11946],
			[35, -2],
			[51, -29],
			[15, 2],
			[6, 14],
			[38, -10],
			[10, 7],
		],
		[
			[11955, 11928],
			[5, -44],
			[11, 0],
			[18, 16],
			[12, -4],
			[20, -31],
			[30, -10],
			[20, 27],
			[23, 16],
			[17, 17],
			[14, -3],
			[16, -27],
			[8, -34],
			[29, -50],
			[-14, -32],
			[-3, -39],
			[15, 12],
			[9, -15],
			[-4, -36],
			[22, -35],
		],
		[
			[11577, 12014],
			[10, 54],
		],
		[
			[11587, 12068],
			[77, 4],
			[16, 29],
			[22, 2],
			[28, -30],
			[22, -1],
			[24, 21],
			[14, -36],
			[-31, -27],
			[-30, 2],
			[-31, 26],
			[-26, -28],
			[-13, -1],
			[-17, -17],
			[-65, 2],
		],
		[
			[11699, 11758],
			[-38, 50],
			[-30, 8],
			[-16, 35],
			[0, 18],
			[-21, 26],
			[-5, 26],
		],
		[
			[11589, 11921],
			[38, 20],
			[23, -4],
			[19, 14],
			[131, -5],
		],
		[
			[13446, 10537],
			[-13, 19],
			[24, 136],
		],
		[
			[14454, 14758],
			[39, -41],
			[55, 7],
			[53, -9],
			[-2, -21],
			[39, 15],
			[-9, -36],
			[-102, -10],
			[1, 20],
			[-87, 23],
			[13, 52],
		],
		[
			[14621, 15381],
			[-43, 3],
			[-37, 12],
			[-86, -32],
			[49, -68],
			[-36, -20],
			[-39, 0],
			[-38, 62],
			[-13, -26],
			[16, -73],
			[35, -57],
			[-26, -27],
			[39, -56],
			[35, -35],
			[1, -69],
			[-65, 32],
			[21, -62],
			[-45, -12],
			[26, -108],
			[-47, -1],
			[-58, 53],
			[-26, 97],
			[-13, 81],
			[-28, 56],
			[-36, 69],
			[-5, 35],
		],
		[
			[14264, 15383],
			[46, 11],
			[28, 26],
			[38, -2],
			[12, 21],
			[13, 4],
		],
		[
			[14626, 15503],
			[34, -32],
			[-22, -77],
			[-17, -13],
		],
		[
			[9454, 20466],
			[238, 73],
			[249, -6],
			[91, 45],
			[251, 12],
			[566, -15],
			[444, -97],
			[-131, -47],
			[-271, -5],
			[-382, -12],
			[36, -22],
			[251, 14],
			[214, -42],
			[137, 37],
			[59, -43],
			[-78, -71],
			[181, 45],
			[345, 47],
			[212, -23],
			[40, -52],
			[-289, -87],
			[-40, -28],
			[-227, -21],
			[164, -6],
			[-83, -88],
			[-57, -79],
			[2, -136],
			[86, -79],
			[-111, -5],
			[-117, -39],
			[131, -64],
			[17, -103],
			[-76, -12],
			[92, -104],
			[-158, -9],
			[82, -50],
			[-23, -43],
			[-100, -18],
			[-99, -1],
			[89, -82],
			[1, -54],
			[-140, 50],
			[-37, -32],
			[96, -31],
			[93, -74],
			[27, -98],
			[-127, -24],
			[-54, 47],
			[-88, 70],
			[24, -82],
			[-82, -64],
			[187, -6],
			[98, -6],
			[-191, -106],
			[-192, -96],
			[-208, -42],
			[-78, -1],
			[-74, -46],
			[-98, -129],
			[-153, -85],
			[-49, -5],
			[-95, -30],
			[-102, -28],
			[-60, -76],
			[-1, -85],
			[-36, -80],
			[-116, -97],
			[29, -95],
			[-32, -101],
			[-37, -119],
			[-100, -7],
			[-104, 99],
			[-142, 1],
			[-69, 67],
			[-47, 118],
			[-123, 152],
			[-36, 79],
			[-10, 109],
			[-98, 113],
			[25, 89],
			[-47, 43],
			[70, 142],
			[107, 46],
			[28, 50],
			[15, 95],
			[-81, -43],
			[-39, -18],
			[-64, -17],
			[-87, 40],
			[-4, 82],
			[27, 65],
			[66, 2],
			[145, -33],
			[-122, 78],
			[-64, 41],
			[-70, -17],
			[-59, 30],
			[79, 114],
			[-43, 45],
			[-57, 84],
			[-85, 129],
			[-90, 47],
			[0, 51],
			[-190, 71],
			[-151, 9],
			[-189, -5],
			[-173, -9],
			[-83, 39],
			[-123, 77],
			[186, 38],
			[143, 6],
			[-304, 32],
			[-160, 50],
			[10, 47],
			[269, 58],
			[260, 59],
			[27, 44],
			[-191, 44],
			[62, 48],
			[245, 85],
			[103, 13],
			[-29, 55],
			[168, 32],
			[218, 19],
			[218, 1],
			[78, -38],
			[188, 67],
			[169, -45],
			[100, -10],
			[147, -39],
			[-168, 65],
			[9, 52],
		],
		[
			[6379, 12085],
			[-36, 22],
			[-44, 2],
			[-33, 24],
			[-38, 50],
		],
		[
			[6228, 12183],
			[2, 36],
			[8, 28],
			[-10, 23],
			[34, 99],
			[91, 0],
			[2, 42],
			[-11, 7],
			[-8, 27],
			[-27, 28],
			[-26, 40],
			[32, 1],
			[0, 68],
			[66, 0],
			[66, -1],
		],
		[
			[6462, 12347],
			[23, -22],
			[6, 18],
			[21, -15],
		],
		[
			[6512, 12328],
			[-32, -47],
			[-34, -34],
			[-5, -23],
			[6, -24],
			[-15, -31],
		],
		[
			[6432, 12169],
			[-16, -7],
			[3, -15],
			[-13, -13],
			[-24, -31],
			[-3, -18],
		],
		[
			[8904, 10696],
			[18, 52],
			[6, 55],
			[12, 52],
			[-28, 72],
		],
		[
			[8912, 10927],
			[-5, 83],
			[37, 105],
		],
		[
			[8944, 11115],
			[24, -14],
			[52, -28],
			[75, -103],
			[12, -50],
		],
		[
			[8532, 11432],
			[47, -44],
			[44, -80],
			[2, -62],
			[26, -3],
			[38, -60],
			[28, -42],
		],
		[
			[8717, 11141],
			[-11, -109],
			[-43, -32],
			[4, -29],
			[-13, -63],
			[31, -88],
			[23, 0],
			[9, -69],
			[44, -105],
		],
		[
			[8463, 11047],
			[-48, 92],
			[19, 34],
			[-1, 56],
			[43, 20],
			[18, 22],
			[-24, 46],
			[6, 44],
			[56, 71],
		],
		[
			[6577, 11994],
			[-13, 38],
			[-21, 11],
		],
		[
			[6543, 12043],
			[5, 48],
			[-10, 14],
			[-14, 8],
			[-32, -14],
			[-2, 16],
			[-22, 20],
			[-15, 24],
			[-21, 10],
		],
		[
			[6512, 12328],
			[8, -5],
			[15, 21],
			[20, 2],
			[7, -10],
			[11, 6],
			[33, -11],
			[33, 3],
			[23, 14],
			[8, 14],
			[23, -7],
			[17, -8],
			[18, 3],
			[14, 10],
			[33, -16],
			[11, -3],
			[22, -23],
			[20, -27],
			[26, -19],
			[19, -33],
		],
		[
			[6873, 12239],
			[-25, 2],
			[-10, -16],
			[-24, -16],
			[-18, 0],
			[-16, -16],
			[-14, 6],
			[-12, 18],
			[-8, -3],
			[-9, -29],
			[-7, 1],
			[-1, -25],
			[-24, -34],
			[-14, -14],
			[-7, -15],
			[-21, 24],
			[-15, -32],
			[-15, 1],
			[-16, -3],
			[1, -60],
			[-10, -1],
			[-9, -28],
			[-22, -5],
		],
		[
			[14109, 15999],
			[17, -47],
		],
		[
			[14126, 15952],
			[22, -34],
		],
		[
			[14148, 15918],
			[-27, -46],
		],
		[
			[14089, 15603],
			[-7, -21],
			[-67, 45],
			[-41, 44],
			[-65, 36],
			[-60, 90],
			[15, 9],
			[-33, 51],
			[-1, 41],
			[-46, 19],
			[-21, -52],
			[-21, 40],
			[1, 43],
			[3, 2],
		],
		[
			[13746, 15950],
			[49, -5],
			[13, 21],
			[24, -20],
			[28, -2],
			[0, 34],
			[25, 12],
			[6, 49],
			[57, 33],
		],
		[
			[13948, 16072],
			[22, -15],
			[54, -52],
			[58, -24],
			[27, 18],
		],
		[
			[7684, 12610],
			[-47, 20],
			[-33, -8],
			[-44, 9],
			[-33, -23],
			[-38, 38],
			[6, 39],
			[66, -17],
			[53, -10],
			[26, 27],
			[-33, 53],
			[1, 47],
			[-45, 19],
			[16, 33],
			[43, -5],
			[62, -19],
		],
		[
			[13977, 16269],
			[36, -31],
			[27, -14],
			[59, 15],
			[6, 25],
			[28, 3],
			[35, 19],
			[7, -8],
			[34, 16],
			[16, 28],
			[24, 8],
			[76, -37],
			[15, 12],
		],
		[
			[14340, 16305],
			[39, -33],
			[5, -33],
		],
		[
			[14384, 16239],
			[-43, -25],
			[-34, -83],
			[-43, -82],
			[-57, -23],
		],
		[
			[14207, 16026],
			[-44, 5],
		],
		[
			[14163, 16031],
			[-54, -32],
		],
		[
			[13948, 16072],
			[-14, 41],
			[-12, 1],
		],
		[
			[21338, 9169],
			[-30, -3],
			[-94, 86],
			[66, 24],
			[38, -37],
			[25, -37],
			[-5, -33],
		],
		[
			[21640, 9333],
			[7, -24],
			[2, -37],
		],
		[
			[21649, 9272],
			[-47, -91],
			[-60, -27],
			[-9, 15],
			[6, 41],
			[31, 74],
			[70, 49],
		],
		[
			[21138, 9430],
			[26, -33],
			[44, 10],
			[18, -52],
			[-83, -24],
			[-49, -16],
			[-38, 1],
			[25, 70],
			[38, 1],
			[19, 43],
		],
		[
			[21494, 9430],
			[-11, -68],
			[-106, -34],
			[-95, 15],
			[0, 44],
			[56, 25],
			[45, -36],
			[47, 9],
			[64, 45],
		],
		[
			[20480, 9590],
			[136, -12],
			[16, 50],
			[131, -59],
			[26, -78],
			[107, -23],
			[87, -72],
			[-81, -46],
			[-78, 49],
			[-64, -4],
			[-74, 9],
			[-66, 22],
			[-83, 47],
			[-52, 12],
			[-29, -15],
			[-130, 50],
			[-12, 52],
			[-65, 9],
			[49, 116],
			[86, -7],
			[57, -48],
			[30, -9],
			[9, -43],
		],
		[
			[22332, 9658],
			[-36, -82],
			[-7, 91],
			[13, 44],
			[14, 41],
			[17, -36],
			[-1, -58],
		],
		[
			[21802, 9994],
			[-27, -41],
			[-49, 23],
			[-14, 52],
			[72, 6],
			[18, -40],
		],
		[
			[22031, 10038],
			[25, -93],
			[-60, 50],
			[-59, 10],
			[-40, -8],
			[-49, 5],
			[17, 67],
			[87, 5],
			[79, -36],
		],
		[
			[22778, 10098],
			[1, -396],
			[1, -397],
		],
		[
			[22780, 9305],
			[-63, 100],
			[-72, 25],
			[-18, -35],
			[-90, -4],
			[31, 99],
			[44, 34],
			[-18, 132],
			[-34, 102],
			[-138, 103],
			[-58, 11],
			[-107, 112],
			[-21, -59],
			[-27, -11],
			[-16, 45],
			[-1, 53],
			[-54, 59],
			[77, 44],
			[50, -2],
			[-6, 32],
			[-104, 0],
			[-28, 73],
			[-63, 22],
			[-30, 60],
			[96, 30],
			[36, 40],
			[114, -50],
			[11, -46],
			[20, -196],
			[73, -73],
			[60, 129],
			[81, 73],
			[63, 0],
			[61, -42],
			[52, -44],
			[77, -23],
		],
		[
			[21659, 10587],
			[-57, -120],
			[-53, -24],
			[-68, 24],
			[-119, -6],
			[-62, -18],
			[-10, -92],
			[64, -108],
			[38, 55],
			[133, 42],
			[-6, -56],
			[-31, 17],
			[-31, -71],
			[-62, -47],
			[67, -156],
			[-13, -42],
			[64, -140],
			[-1, -80],
			[-38, -36],
			[-28, 43],
			[34, 99],
			[-69, -47],
			[-18, 34],
			[9, 47],
			[-51, 71],
			[5, 119],
			[-47, -37],
			[6, -142],
			[3, -174],
			[-45, -18],
			[-30, 36],
			[20, 112],
			[-11, 117],
			[-30, 1],
			[-22, 84],
			[29, 79],
			[10, 97],
			[36, 183],
			[15, 50],
			[60, 91],
			[56, -36],
			[89, -17],
			[82, 5],
			[70, 88],
			[12, -27],
		],
		[
			[21904, 10552],
			[-4, -106],
			[-36, 12],
			[-11, -74],
			[29, -64],
			[-20, -15],
			[-28, 77],
			[-21, 156],
			[14, 97],
			[23, 44],
			[5, -66],
			[42, -11],
			[7, -50],
		],
		[
			[20554, 10659],
			[12, -82],
			[48, -68],
			[46, 24],
			[45, -9],
			[42, 62],
			[34, 11],
			[67, -34],
			[58, 26],
			[36, 169],
			[28, 42],
			[24, 138],
			[82, 0],
			[61, -20],
		],
		[
			[21137, 10918],
			[-40, -110],
			[52, -115],
			[-12, -56],
			[79, -113],
			[-84, -14],
			[-23, -83],
			[3, -110],
			[-69, -84],
			[-1, -121],
			[-28, -186],
			[-10, 44],
			[-81, -55],
			[-28, 74],
			[-51, 7],
			[-35, 39],
			[-84, -44],
			[-26, 59],
			[-47, -7],
			[-58, 15],
			[-11, 163],
			[-35, 33],
			[-35, 105],
			[-9, 106],
			[8, 113],
			[42, 81],
		],
		[
			[20281, 9703],
			[-78, -3],
			[-60, 102],
			[-91, 99],
			[-31, 74],
			[-53, 99],
			[-36, 91],
			[-54, 170],
			[-62, 102],
			[-21, 104],
			[-26, 95],
			[-64, 77],
			[-37, 104],
			[-53, 68],
			[-74, 134],
			[-7, 62],
			[46, -5],
			[110, -23],
			[63, -119],
			[54, -83],
			[40, -50],
			[67, -131],
			[72, -2],
			[60, -83],
			[41, -102],
			[54, -56],
			[-29, -99],
			[41, -42],
			[25, -4],
			[12, -84],
			[25, -68],
			[52, -11],
			[35, -77],
			[-18, -151],
			[-3, -188],
		],
		[
			[18528, 14086],
			[-45, -55],
			[-28, -114],
			[69, -46],
			[67, -59],
			[93, -69],
			[97, -15],
			[41, -62],
			[55, -12],
			[85, -28],
			[59, 2],
			[8, 48],
			[-9, 77],
			[5, 53],
		],
		[
			[19679, 13853],
			[5, -47],
			[-25, -22],
			[6, -75],
			[-51, 22],
			[-92, -84],
			[3, -69],
			[-40, -102],
			[-3, -60],
			[-32, -100],
			[-55, 28],
			[-3, -126],
			[-16, -42],
			[7, -51],
			[-35, -29],
		],
		[
			[19090, 13098],
			[-10, -45],
			[-48, 2],
			[-88, -26],
			[4, -91],
			[-38, -72],
			[-102, -82],
			[-79, -143],
			[-54, -77],
			[-70, -79],
			[0, -56],
			[-36, -30],
			[-64, -44],
			[-33, -6],
			[-21, -93],
			[15, -158],
			[3, -101],
			[-30, -116],
			[0, -207],
			[-37, -5],
			[-32, -93],
			[22, -40],
			[-65, -35],
			[-24, -83],
			[-28, -35],
			[-68, 114],
			[-32, 170],
			[-28, 123],
			[-25, 58],
			[-37, 117],
			[-18, 152],
			[-12, 76],
			[-65, 167],
			[-29, 235],
			[-21, 156],
			[0, 148],
			[-14, 113],
			[-103, -72],
			[-50, 14],
			[-93, 148],
			[34, 44],
			[-21, 47],
			[-83, 104],
		],
		[
			[17610, 13297],
			[47, 81],
			[157, -1],
			[-14, 105],
			[-40, 62],
			[-8, 93],
			[-47, 55],
			[78, 127],
			[83, -9],
			[74, 128],
			[44, 123],
			[69, 122],
			[-1, 87],
			[61, 70],
			[-58, 60],
			[-24, 83],
			[-25, 106],
			[34, 53],
			[108, -30],
			[79, 18],
			[69, 102],
		],
		[
			[12333, 16968],
			[11, -87],
			[-53, -109],
			[-126, -72],
			[-100, 18],
			[57, 128],
			[-37, 123],
			[97, 95],
			[53, 57],
		],
		[
			[16599, 14940],
			[62, 23],
			[51, 70],
			[47, -4],
			[31, 23],
			[51, -11],
			[78, -62],
			[57, -13],
			[81, -108],
			[53, -4],
			[6, -103],
		],
		[
			[17092, 14043],
			[35, -64],
			[29, -73],
			[68, -54],
			[2, -107],
			[33, -20],
			[6, -56],
			[-102, -62],
			[-27, -142],
		],
		[
			[17136, 13465],
			[-133, 37],
			[-78, 28],
			[-80, 16],
			[-30, 149],
			[-34, 21],
			[-54, -21],
			[-72, -59],
			[-87, 40],
			[-71, 94],
			[-69, 34],
			[-47, 116],
			[-52, 162],
			[-39, -20],
			[-45, 41],
			[-26, -48],
		],
		[
			[16219, 14055],
			[-39, 64],
			[-1, 65],
			[-23, 0],
			[12, 88],
			[-37, 92],
			[-87, 67],
			[-49, 116],
			[17, 95],
			[35, 42],
			[-5, 71],
			[-47, 36],
		],
		[
			[15995, 14791],
			[-46, 145],
			[-38, 98],
		],
		[
			[15911, 15034],
			[14, 37],
			[-23, 140],
			[49, 35],
		],
		[
			[16241, 15076],
			[23, -90],
			[67, -25],
			[49, -61],
			[101, -21],
			[111, 32],
			[7, 29],
		],
		[
			[16219, 14055],
			[-42, 6],
		],
		[
			[16177, 14061],
			[-48, 10],
			[-52, -117],
		],
		[
			[16077, 13954],
			[-132, 10],
			[-200, 245],
			[-106, 85],
			[-85, 33],
		],
		[
			[15554, 14327],
			[-29, 148],
		],
		[
			[15525, 14475],
			[157, 127],
			[27, 147],
			[-7, 89],
			[39, 30],
			[37, 76],
		],
		[
			[15778, 14944],
			[30, 18],
			[83, -15],
			[24, -31],
			[34, 20],
		],
		[
			[15949, 14936],
			[46, -145],
		],
		[
			[11743, 18499],
			[-16, -79],
			[80, -83],
			[-92, -93],
			[-205, -83],
			[-61, -22],
			[-94, 18],
			[-198, 38],
			[70, 54],
			[-154, 60],
			[125, 23],
			[-3, 36],
			[-149, 28],
			[48, 79],
			[108, 18],
			[110, -82],
			[108, 66],
			[90, -34],
			[115, 65],
			[118, -9],
		],
		[
			[15307, 14394],
			[-12, -39],
		],
		[
			[15295, 14355],
			[-26, 17],
			[-15, -81],
			[18, -14],
			[-18, -16],
			[-3, -32],
			[33, 16],
		],
		[
			[15284, 14245],
			[2, -47],
			[-35, -195],
		],
		[
			[15251, 14003],
			[-47, 209],
			[21, 40],
			[-5, 7],
			[18, 57],
			[15, 92],
			[10, 31],
			[2, 1],
		],
		[
			[15265, 14440],
			[24, 0],
			[6, 21],
			[19, 2],
		],
		[
			[15314, 14463],
			[1, -50],
			[-9, -19],
			[1, 0],
		],
		[
			[13874, 15065],
			[-26, -95],
			[11, -38],
			[-15, -63],
			[-54, 46],
			[-36, 13],
			[-99, 62],
			[10, 63],
			[83, -12],
			[72, 14],
			[54, 10],
		],
		[
			[13426, 15428],
			[43, -87],
			[-10, -161],
			[-33, 8],
			[-29, -41],
			[-26, 33],
			[-3, 147],
			[-16, 69],
			[39, -6],
			[35, 38],
		],
		[
			[13752, 16072],
			[-8, -60],
			[17, -51],
		],
		[
			[13761, 15961],
			[-56, 17],
			[-58, -43],
			[4, -60],
			[-8, -35],
			[23, -62],
			[66, -61],
			[36, -101],
			[79, -98],
			[56, 1],
			[17, -27],
			[-20, -24],
			[64, -44],
			[52, -37],
			[60, -63],
			[8, -23],
			[-13, -44],
			[-40, 57],
			[-61, 20],
			[-30, -78],
			[51, -45],
			[-8, -64],
			[-30, -7],
			[-38, -105],
			[-30, -9],
			[1, 37],
			[14, 66],
			[16, 26],
			[-28, 70],
			[-22, 61],
			[-29, 16],
			[-21, 52],
			[-46, 22],
			[-30, 49],
			[-53, 8],
			[-55, 55],
			[-65, 79],
			[-49, 70],
			[-22, 120],
			[-35, 15],
			[-58, 40],
			[-32, -17],
			[-41, -56],
			[-30, -9],
		],
		[
			[7268, 12664],
			[48, -11],
			[38, -29],
			[11, -34],
			[-49, -2],
			[-22, -20],
			[-40, 19],
			[-40, 45],
			[8, 27],
			[30, 9],
			[16, -4],
		],
		[
			[15307, 14394],
			[79, -49],
			[139, 130],
		],
		[
			[15554, 14327],
			[-14, -18],
			[-142, -62],
			[71, -121],
			[-24, -21],
			[-11, -41],
			[-54, -16],
			[-17, -44],
			[-31, -38],
			[-79, 20],
		],
		[
			[15253, 13986],
			[-2, 17],
		],
		[
			[15284, 14245],
			[11, 36],
			[0, 74],
		],
		[
			[22326, 14569],
			[9, -42],
			[-40, -74],
			[-29, 39],
			[-36, -28],
			[-19, -71],
			[-46, 35],
			[0, 57],
			[40, 73],
			[40, -14],
			[29, 51],
			[52, -26],
		],
		[
			[22776, 14933],
			[-27, -97],
			[13, -61],
			[-37, -86],
			[-91, -57],
			[-125, -8],
			[-101, -139],
			[-48, 47],
			[-2, 91],
			[-124, -27],
			[-84, -57],
			[-83, -2],
			[72, -90],
			[-47, -207],
			[-46, -51],
			[-35, 48],
			[18, 109],
			[-45, 36],
			[-29, 83],
			[67, 37],
			[37, 77],
			[72, 63],
			[52, 83],
			[141, 36],
			[76, -25],
			[74, 217],
			[48, -58],
			[104, 121],
			[40, 47],
			[45, 149],
			[-13, 137],
			[30, 77],
			[76, 22],
			[38, -169],
			[-2, -98],
			[-65, -123],
			[1, -125],
		],
		[
			[22984, 15788],
			[50, -26],
			[50, 52],
			[16, -137],
			[-105, -33],
			[-62, -121],
			[-112, 83],
			[-39, -133],
			[-79, -2],
			[-9, 121],
			[35, 94],
			[76, 7],
			[20, 168],
			[21, 95],
			[84, -127],
			[54, -41],
		],
		[
			[17808, 15556],
			[-41, -22],
			[-93, -85],
			[-31, -87],
			[-27, -1],
			[-19, 58],
			[-91, 4],
			[-14, 99],
			[-35, 1],
			[6, 122],
			[-85, 89],
			[-122, -9],
			[-83, -18],
			[-68, 109],
			[-58, 46],
			[-110, 88],
			[-13, 10],
			[-183, -72],
			[3, -448],
		],
		[
			[16744, 15440],
			[-36, -6],
			[-50, 95],
			[-48, 34],
			[-81, -25],
			[-31, -41],
		],
		[
			[16498, 15497],
			[-4, 30],
			[17, 51],
			[-13, 42],
			[-82, 42],
			[-32, 109],
			[-40, 31],
			[-2, 39],
			[69, -11],
			[3, 89],
			[60, 19],
			[62, -18],
			[13, 119],
			[-13, 75],
			[-71, -6],
			[-60, 30],
			[-82, -53],
			[-66, -26],
		],
		[
			[16257, 16059],
			[-36, 20],
			[7, 62],
		],
		[
			[16228, 16141],
			[-45, 82],
			[-53, -4],
			[-60, 83],
		],
		[
			[16070, 16302],
			[41, 92],
			[-21, 25],
			[57, 133],
			[73, -70],
			[8, 89],
			[147, 132],
			[111, 3],
			[156, -84],
		],
		[
			[16642, 16622],
			[84, -49],
			[75, 51],
			[113, 2],
			[91, -63],
		],
		[
			[17005, 16563],
			[20, 36],
			[100, -5],
			[18, 58],
			[-115, 84],
			[68, 59],
			[-13, 33],
			[68, 32],
			[-52, 83],
		],
		[
			[17099, 16943],
			[33, 41],
			[265, 43],
		],
		[
			[17397, 17027],
			[35, 30],
			[178, 45],
		],
		[
			[17610, 17102],
			[63, 50],
			[128, -26],
			[22, -126],
			[74, 29],
			[92, -41],
			[-6, -66],
		],
		[
			[17983, 16922],
			[68, 7],
			[178, 114],
		],
		[
			[18229, 17043],
			[-26, -38],
			[90, -94],
			[159, -309],
			[38, 64],
			[97, -70],
			[102, 31],
			[39, -22],
			[35, -70],
			[49, -24],
			[30, -51],
			[92, 16],
			[37, -74],
		],
		[
			[18468, 15566],
			[-44, 18],
			[-36, 44],
			[-105, 13],
			[-118, 3],
			[-25, -13],
			[-101, 51],
			[-41, -25],
			[-11, -72],
			[-117, 42],
			[-46, -18],
			[-16, -53],
		],
		[
			[15723, 10210],
			[-49, -49],
			[-18, -51],
			[-27, -9],
			[-10, -85],
			[-22, -49],
			[-14, -81],
			[-29, -40],
		],
		[
			[15554, 9846],
			[-102, 121],
			[-4, 71],
			[-258, 248],
			[-12, 13],
		],
		[
			[15178, 10299],
			[0, 129],
			[20, 49],
			[35, 81],
			[26, 88],
			[-32, 140],
			[-8, 61],
			[-34, 84],
		],
		[
			[15185, 10931],
			[44, 73],
			[48, 80],
		],
		[
			[15742, 10891],
			[-62, -138],
			[1, -443],
			[42, -100],
		],
		[
			[18000, 15211],
			[-134, -18],
			[-87, 39],
			[-77, -9],
			[6, 70],
			[78, -20],
			[26, 37],
		],
		[
			[17812, 15310],
			[54, -12],
			[90, 88],
			[-84, 64],
			[-50, -30],
			[-53, 45],
			[60, 79],
			[-21, 12],
		],
		[
			[20052, 11897],
			[-17, 147],
			[45, 101],
			[92, 23],
			[67, -17],
		],
		[
			[20239, 12151],
			[58, -48],
			[32, 84],
			[63, -45],
		],
		[
			[20392, 12142],
			[17, -81],
			[-9, -146],
			[-119, -93],
			[31, -74],
			[-75, -9],
			[-61, -49],
		],
		[
			[20176, 11690],
			[-60, 18],
			[-28, 63],
			[-36, 126],
		],
		[
			[21880, 15112],
			[61, -144],
			[18, -79],
			[0, -140],
			[-26, -67],
			[-65, -23],
			[-56, -51],
			[-64, -10],
			[-8, 66],
			[13, 92],
			[-31, 126],
			[52, 21],
			[-48, 104],
		],
		[
			[21726, 15007],
			[4, 11],
			[32, -5],
			[27, 55],
			[51, 6],
			[30, 8],
			[10, 30],
		],
		[
			[14234, 15506],
			[-5, 44],
		],
		[
			[14229, 15550],
			[-17, 13],
			[-15, 32],
		],
		[
			[14197, 15595],
			[13, 28],
		],
		[
			[14210, 15623],
			[17, 8],
			[10, 41],
			[12, 7],
			[11, -18],
			[13, -7],
			[9, -20],
			[12, -5],
			[14, -23],
			[10, 1],
			[-8, -30],
			[-9, -14],
			[3, -9],
		],
		[
			[14304, 15554],
			[-16, -5],
			[-42, -19],
			[-3, -25],
			[-9, 1],
		],
		[
			[16177, 14061],
			[14, -54],
			[-6, -27],
			[23, -92],
		],
		[
			[16208, 13888],
			[-50, -3],
			[-18, 58],
			[-63, 11],
		],
		[
			[20239, 12151],
			[23, 55],
			[3, 103],
			[-58, 106],
			[-4, 120],
			[-54, 98],
			[-54, 9],
			[-14, -42],
			[-41, -4],
			[-22, 21],
			[-74, -72],
			[-2, 109],
			[17, 128],
			[-48, 6],
			[-4, 73],
			[-30, 37],
		],
		[
			[19877, 12898],
			[15, 45],
			[60, 79],
		],
		[
			[20022, 13147],
			[42, -96],
			[32, -110],
			[87, -1],
			[28, -106],
			[-46, -32],
			[-20, -44],
			[85, -73],
			[59, -143],
			[45, -108],
			[53, -84],
			[18, -86],
			[-13, -122],
		],
		[
			[15265, 14440],
			[25, 99],
			[36, 86],
			[1, 4],
		],
		[
			[15327, 14629],
			[32, -6],
			[11, -48],
			[-38, -46],
			[-18, -66],
		],
		[
			[12225, 10945],
			[-18, -1],
			[-73, 58],
			[-65, 93],
			[-60, 66],
			[-48, 79],
		],
		[
			[11961, 11240],
			[17, 39],
			[4, 35],
			[32, 66],
			[33, 57],
		],
		[
			[13826, 13196],
			[-50, -45],
			[-40, 66],
			[-112, 53],
		],
		[
			[13445, 14101],
			[35, 29],
			[6, 51],
			[-7, 50],
			[48, 47],
			[22, 39],
			[35, 35],
			[4, 94],
		],
		[
			[13588, 14446],
			[83, -42],
			[30, 10],
			[59, -20],
			[94, -54],
			[34, -109],
			[63, -23],
			[100, -51],
			[76, -61],
			[34, 32],
			[34, 56],
			[-16, 93],
			[22, 59],
			[51, 57],
			[49, 17],
			[96, -25],
			[24, -54],
			[27, -1],
			[22, -21],
			[71, -14],
			[17, -40],
		],
		[
			[14546, 13091],
			[0, -243],
			[-81, -1],
			[-1, -51],
		],
		[
			[14464, 12796],
			[-283, 233],
			[-283, 233],
			[-72, -66],
		],
		[
			[18576, 11330],
			[-11, -127],
			[-29, -35],
			[-62, -27],
			[-34, 96],
			[-12, 175],
			[32, 198],
			[49, -68],
			[33, -86],
			[34, -126],
		],
		[
			[14829, 6892],
			[24, -37],
			[-21, -59],
			[-12, -40],
			[-40, -19],
			[-13, -38],
			[-25, -13],
			[-54, 94],
			[38, 77],
			[39, 48],
			[33, 24],
			[31, -37],
		],
		[
			[14385, 17023],
			[-5, 32],
			[7, 33],
			[-31, 19],
			[-74, 21],
		],
		[
			[14282, 17128],
			[-15, 103],
		],
		[
			[14267, 17231],
			[81, 37],
			[119, -8],
			[70, 12],
			[10, -25],
			[37, -8],
			[68, -59],
		],
		[
			[14439, 16973],
			[-17, 37],
			[-37, 13],
		],
		[
			[14267, 17231],
			[2, 91],
			[35, 77],
			[67, 41],
			[56, -91],
			[57, 3],
			[14, 93],
		],
		[
			[14709, 17406],
			[34, -28],
			[6, -59],
			[23, -71],
		],
		[
			[12158, 13779],
			[-11, 0],
			[0, 0],
		],
		[
			[12147, 13779],
			[1, -65],
			[-43, -4],
			[-23, -28],
			[-33, 0],
			[-25, 16],
			[-60, -13],
			[-23, -95],
			[-22, -9],
			[-34, -153],
			[-98, -132],
			[-24, -167],
			[-29, -55],
			[-8, -44],
			[-160, -10],
			[-1, 1],
		],
		[
			[11565, 13021],
			[3, 56],
			[27, 33],
			[24, 63],
			[-5, 42],
			[24, 85],
			[40, 78],
			[24, 19],
			[19, 71],
			[1, 65],
			[26, 75],
			[47, 45],
			[45, 124],
			[1, 2],
			[36, 46],
			[66, 14],
			[56, 83],
			[36, 32],
			[59, 102],
			[-18, 151],
			[27, 105],
			[10, 64],
			[45, 82],
			[71, 56],
			[53, 50],
			[47, 126],
			[23, 75],
			[52, -1],
			[43, -52],
			[67, 9],
			[74, -27],
			[31, -1],
		],
		[
			[14661, 16281],
			[17, 18],
			[47, 12],
			[53, -38],
			[29, -5],
			[32, -33],
			[-5, -41],
			[26, -20],
			[10, -51],
			[25, -31],
			[-5, -18],
			[13, -12],
			[-19, -9],
			[-42, 4],
			[-7, 16],
			[-14, -9],
			[5, -22],
			[-20, -39],
			[-12, -42],
			[-18, -13],
		],
		[
			[14776, 15948],
			[-13, 56],
			[8, 52],
			[-3, 53],
			[-41, 72],
			[-22, 52],
			[-22, 36],
			[-22, 12],
		],
		[
			[16288, 8897],
			[19, -51],
			[17, -81],
			[12, -146],
			[18, -57],
			[-7, -58],
			[-12, -36],
			[-24, 71],
			[-14, -36],
			[14, -90],
			[-7, -51],
			[-19, -29],
			[-5, -103],
			[-28, -141],
			[-35, -168],
			[-43, -231],
			[-28, -169],
			[-32, -141],
			[-57, -29],
			[-62, -51],
			[-41, 31],
			[-57, 44],
			[-19, 64],
			[-5, 108],
			[-25, 97],
			[-6, 87],
			[12, 88],
			[33, 21],
			[0, 40],
			[34, 93],
			[7, 77],
			[-17, 58],
			[-13, 76],
			[-6, 113],
			[25, 68],
			[9, 77],
			[36, 4],
			[39, 25],
			[27, 22],
			[31, 2],
			[40, 69],
			[59, 75],
			[21, 61],
			[-10, 52],
			[30, -14],
			[39, 84],
			[2, 73],
			[23, 55],
			[25, -53],
		],
		[
			[6228, 12183],
			[-80, 131],
			[-37, 40],
			[-58, 31],
			[-39, -9],
			[-57, -45],
			[-36, -12],
			[-50, 32],
			[-53, 23],
			[-67, 56],
			[-53, 17],
			[-80, 56],
			[-60, 58],
			[-17, 33],
			[-40, 7],
			[-73, 39],
			[-29, 55],
			[-77, 69],
			[-35, 77],
			[-17, 59],
			[24, 12],
			[-8, 35],
			[17, 31],
			[0, 42],
			[-24, 55],
			[-6, 49],
			[-24, 61],
			[-63, 121],
			[-71, 95],
			[-35, 76],
			[-60, 49],
			[-13, 30],
			[10, 75],
			[-36, 29],
			[-42, 59],
			[-17, 85],
			[-39, 10],
			[-41, 64],
			[-33, 59],
			[-3, 38],
			[-38, 92],
			[-25, 93],
			[1, 46],
			[-52, 49],
			[-23, -6],
			[-41, 34],
			[-11, -49],
			[12, -59],
			[6, -91],
			[25, -50],
			[52, -84],
			[12, -29],
			[11, -8],
			[9, -42],
			[13, 1],
			[14, -78],
			[22, -31],
			[15, -43],
			[44, -62],
			[24, -113],
			[21, -53],
			[20, -57],
			[4, -65],
			[34, -4],
			[28, -55],
			[26, -54],
			[-2, -22],
			[-30, -45],
			[-12, 1],
			[-19, 74],
			[-46, 69],
			[-51, 59],
			[-37, 31],
			[3, 89],
			[-11, 66],
			[-34, 38],
			[-49, 54],
			[-9, -16],
			[-18, 32],
			[-44, 29],
			[-42, 71],
			[6, 9],
			[29, -7],
			[26, 46],
			[3, 55],
			[-55, 86],
			[-42, 34],
			[-26, 76],
			[-26, 80],
			[-33, 97],
			[-29, 109],
		],
		[
			[4461, 14372],
			[81, 10],
			[90, 13],
			[-7, -24],
			[108, -59],
			[161, -86],
			[142, 1],
			[56, 0],
			[0, 50],
			[123, 0],
			[26, -43],
			[36, -38],
			[42, -54],
			[24, -63],
			[17, -67],
			[37, -37],
			[59, -36],
			[45, 96],
			[58, 2],
			[50, -48],
			[35, -84],
			[25, -71],
			[42, -69],
			[15, -85],
			[20, -58],
			[56, -37],
			[50, -27],
		],
		[
			[5852, 13558],
			[28, 4],
			[-28, -107],
			[-12, -88],
			[-6, -163],
			[-6, -59],
			[12, -67],
			[22, -59],
			[14, -94],
			[47, -91],
			[17, -69],
			[28, -60],
			[75, -32],
			[29, -51],
			[62, 34],
			[55, 12],
			[53, 22],
			[44, 21],
			[45, 49],
			[17, 71],
			[6, 103],
			[12, 35],
			[49, 32],
			[75, 28],
			[62, -4],
			[43, 10],
			[17, -26],
			[-2, -58],
			[-38, -72],
			[-17, -75],
			[13, -21],
			[-10, -52],
			[-18, -95],
			[-18, 31],
			[-15, -2],
		],
		[
			[14304, 15554],
			[24, 7],
			[33, 2],
		],
		[
			[14264, 15383],
			[-29, 30],
			[-10, 52],
			[9, 41],
		],
		[
			[11909, 12193],
			[24, 22],
			[12, 71],
			[22, 3],
			[50, -34],
			[40, 24],
			[27, -8],
			[11, 27],
			[285, 2],
			[15, 85],
			[-12, 15],
			[-34, 525],
			[-34, 525],
			[108, 3],
		],
		[
			[13075, 12745],
			[1, -280],
			[-39, -82],
			[-6, -75],
			[-63, -19],
			[-97, -10],
			[-26, -44],
			[-46, -4],
		],
		[
			[11955, 11928],
			[4, 38],
			[-6, 47],
			[-27, 34],
			[-14, 70],
			[-3, 76],
		],
		[
			[13806, 14776],
			[-2, -4],
			[-7, 0],
			[-6, 6],
			[0, 13],
			[7, -2],
			[6, -9],
			[2, -4],
		],
		[
			[13788, 14797],
			[-4, -2],
			[-4, 4],
			[-1, 2],
			[6, 2],
			[2, -2],
			[2, -3],
			[-1, -1],
		],
		[
			[19766, 11623],
			[-7, 90],
			[22, 93],
			[-24, 72],
			[6, 133],
			[-29, 63],
			[-23, 145],
			[-13, 154],
			[-31, 101],
			[-47, -61],
			[-80, -87],
			[-40, 11],
			[-44, 28],
			[24, 151],
			[-14, 114],
			[-56, 140],
			[9, 44],
			[-42, 16],
			[-50, 99],
		],
		[
			[19877, 12898],
			[-41, -28],
			[-41, -53],
			[-51, -5],
			[-32, -132],
			[-30, -22],
			[34, -106],
			[45, -89],
			[30, -80],
			[-26, -106],
			[-25, -23],
			[17, -61],
			[47, -96],
			[8, -68],
			[-1, -57],
			[28, -111],
			[-39, -113],
			[-34, -125],
		],
		[
			[14173, 15608],
			[-31, -60],
			[5, -39],
			[-15, 9],
			[-20, 40],
			[-30, 24],
			[7, 21],
		],
		[
			[14136, 15709],
			[19, -21],
			[10, -17],
			[24, -13],
			[27, -25],
			[-6, -10],
		],
		[
			[18999, 16412],
			[75, 21],
			[135, 104],
			[108, 58],
		],
		[
			[19317, 16595],
			[62, -38],
			[74, -2],
		],
		[
			[19453, 16555],
			[47, -56],
		],
		[
			[19500, 16499],
			[71, -5],
			[103, -30],
			[69, 84],
		],
		[
			[19743, 16548],
			[-29, 72],
			[74, 126],
			[79, -50],
			[64, -14],
		],
		[
			[19931, 16682],
			[84, -32],
			[13, -91],
			[101, -51],
		],
		[
			[20129, 16508],
			[67, 23],
			[90, 15],
		],
		[
			[20286, 16546],
			[71, -16],
			[70, -58],
			[43, -62],
			[66, 1],
			[89, -20],
			[65, 30],
			[94, 20],
			[103, 86],
			[43, -13],
			[37, -41],
			[85, 10],
		],
		[
			[15225, 9013],
			[53, 10],
			[85, -34],
			[19, 15],
		],
		[
			[15382, 9004],
			[49, 3],
			[26, 37],
			[42, -2],
		],
		[
			[15499, 9042],
			[78, 47],
			[56, 70],
			[12, -54],
			[-3, -121],
			[9, -107],
			[2, -190],
			[13, -60],
			[-21, -87],
			[-28, -84],
			[-45, -76],
			[-65, -46],
			[-80, -59],
			[-80, -131],
			[-27, -22],
			[-50, -86],
			[-29, -28],
			[-6, -87],
			[34, -92],
			[14, -72],
			[0, -36],
			[13, 6],
			[-2, -119],
			[-12, -57],
			[17, -20],
			[-10, -51],
			[-30, -43],
			[-59, -41],
			[-85, -66],
			[-31, -45],
			[6, -52],
			[18, -8],
			[-6, -64],
		],
		[
			[15102, 7161],
			[-54, 1],
		],
		[
			[15048, 7162],
			[-6, 54],
			[-10, 55],
		],
		[
			[15032, 7271],
			[-6, 43],
			[12, 136],
			[-18, 86],
			[-34, 172],
		],
		[
			[14986, 7708],
			[75, 138],
			[18, 87],
			[11, 11],
			[8, 72],
			[-11, 36],
			[3, 91],
			[13, 84],
			[0, 154],
			[-37, 39],
			[-33, 9],
			[-16, 30],
			[-33, 26],
			[-59, -2],
			[-4, 45],
		],
		[
			[14921, 8528],
			[-7, 86],
			[215, 101],
		],
		[
			[15129, 8715],
			[41, -59],
			[20, 12],
			[28, -31],
			[4, -49],
			[-15, -57],
			[5, -85],
			[46, -75],
			[22, 84],
			[31, 26],
			[-6, 156],
			[-30, 88],
			[-26, 39],
			[-24, -2],
			[-20, 159],
			[20, 92],
		],
		[
			[11909, 12193],
			[-47, 83],
			[-43, 90],
			[-47, 32],
			[-34, 36],
			[-40, -2],
			[-34, -26],
			[-35, 10],
			[-25, -39],
		],
		[
			[11604, 12377],
			[-6, 66],
			[20, 60],
			[9, 114],
			[-8, 121],
			[-9, 60],
			[7, 61],
			[-18, 58],
			[-37, 52],
		],
		[
			[11562, 12969],
			[15, 41],
			[278, -1],
			[-13, 176],
			[17, 62],
			[66, 11],
			[-2, 311],
			[233, -6],
			[0, 184],
		],
		[
			[15129, 8715],
			[-37, 31],
			[22, 113],
			[22, 43],
			[-14, 100],
			[14, 99],
			[13, 33],
			[-18, 103],
			[-34, 55],
		],
		[
			[15097, 9292],
			[70, -23],
			[14, -34],
		],
		[
			[15181, 9235],
			[24, -57],
			[20, -165],
		],
		[
			[20020, 11171],
			[17, -11],
			[41, -73],
			[30, -82],
			[4, -82],
			[-7, -55],
			[7, -42],
			[5, -72],
			[25, -34],
			[28, -107],
			[-2, -41],
			[-50, -8],
			[-67, 90],
			[-84, 96],
			[-8, 62],
			[-41, 82],
			[-10, 100],
			[-26, 67],
			[8, 88],
			[-16, 52],
		],
		[
			[19874, 11201],
			[13, 22],
			[58, -54],
			[5, -62],
			[47, 14],
			[23, 50],
		],
		[
			[20554, 10659],
			[52, -42],
			[55, 23],
			[14, 103],
			[30, 23],
			[85, 26],
			[51, 96],
			[35, 77],
		],
		[
			[20965, 11077],
			[54, 85],
			[36, 95],
			[29, 0],
			[36, -61],
			[4, -53],
			[46, -34],
			[59, -37],
			[-5, -47],
			[-47, -6],
			[12, -60],
			[-52, -41],
		],
		[
			[13932, 6938],
			[-52, 92],
			[-28, 89],
			[-16, 118],
			[-17, 88],
			[-24, 188],
			[-2, 145],
			[-9, 67],
			[-27, 50],
			[-37, 100],
			[-37, 146],
			[-16, 77],
			[-58, 118],
			[-4, 94],
		],
		[
			[14420, 8283],
			[58, 27],
			[46, -7],
			[28, -27],
			[0, -10],
		],
		[
			[14184, 7401],
			[0, -449],
			[-63, -62],
			[-38, -9],
			[-45, 23],
			[-32, 9],
			[-12, 52],
			[-28, 33],
			[-34, -60],
		],
		[
			[24536, 7850],
			[58, -75],
			[37, -56],
			[-27, -30],
			[-39, 33],
			[-51, 55],
			[-45, 65],
			[-47, 85],
			[-10, 42],
			[30, -2],
			[40, -42],
			[31, -41],
			[23, -34],
		],
		[
			[13826, 13196],
			[18, -189],
		],
		[
			[13844, 13007],
			[26, -32],
			[1, -39],
		],
		[
			[13871, 12936],
			[30, -41],
			[-15, -53],
			[-28, -247],
			[-4, -158],
		],
		[
			[13854, 12437],
			[-90, -115],
			[-31, -160],
		],
		[
			[13733, 12162],
			[30, -45],
			[0, -78],
			[45, -3],
			[-7, -57],
		],
		[
			[13779, 11933],
			[-13, -3],
			[-48, 134],
			[-17, 4],
			[-56, -68],
			[-55, 36],
			[-38, 7],
			[-20, -17],
			[-42, 4],
			[-42, -52],
			[-36, -3],
			[-86, 63],
			[-33, -30],
			[-37, 2],
			[-26, 46],
			[-71, 45],
			[-77, -14],
			[-18, -26],
			[-10, -70],
			[-20, -49],
			[-5, -109],
		],
		[
			[13376, 10995],
			[-74, -44],
			[-27, 7],
			[-27, -28],
			[-57, 3],
			[-38, 76],
			[-23, 88],
			[-51, 80],
			[-53, -1],
			[-63, 0],
		],
		[
			[6690, 11763],
			[-24, 39],
			[-33, 49],
			[-16, 41],
			[-30, 38],
			[-35, 55],
			[8, 19],
			[11, -19],
			[6, 9],
		],
		[
			[6873, 12239],
			[-7, -12],
			[-3, -27],
			[7, -45],
			[-16, -41],
			[-8, -49],
			[-2, -54],
			[4, -31],
			[1, -55],
			[-10, -12],
			[-7, -52],
			[5, -32],
			[-15, -31],
			[4, -33],
			[10, -20],
		],
		[
			[13060, 16651],
			[-52, 10],
			[36, 33],
			[62, 179],
			[98, 51],
			[58, -3],
		],
		[
			[14237, 18821],
			[-44, -5],
			[-10, -80],
			[-134, 20],
			[-18, -68],
			[-69, 0],
			[-46, -86],
			[-71, -135],
			[-111, -171],
			[26, -42],
			[-24, -48],
			[-71, 2],
			[-46, -114],
			[4, -161],
			[46, -62],
			[-24, -143],
			[-59, -84],
			[-31, -70],
		],
		[
			[13555, 17574],
			[-48, 75],
			[-140, -141],
			[-94, -28],
			[-98, 62],
			[-26, 131],
			[-22, 280],
			[65, 79],
			[187, 102],
			[141, 125],
			[129, 170],
			[171, 235],
			[119, 91],
			[195, 153],
			[155, 53],
			[117, -6],
			[108, 100],
			[130, -5],
			[127, 24],
			[222, -89],
			[-91, -32],
			[77, -77],
			[-120, -49],
			[-58, -11],
		],
		[
			[14527, 19885],
			[-159, -49],
			[-125, 28],
			[49, 31],
			[-43, 39],
			[147, 25],
			[29, -46],
			[102, -28],
		],
		[
			[14068, 20110],
			[233, -90],
			[-178, -48],
			[-40, -90],
			[-62, -23],
			[-34, -101],
			[-85, -4],
			[-153, 74],
			[64, 43],
			[-106, 35],
			[-138, 103],
			[-55, 95],
			[193, 44],
			[39, -43],
			[101, 2],
			[27, 42],
			[104, 4],
			[90, -43],
		],
		[
			[14578, 20196],
			[139, -43],
			[-105, -65],
			[-206, -14],
			[-209, 20],
			[-13, 33],
			[-101, 3],
			[-78, 55],
			[219, 34],
			[103, -29],
			[72, 37],
			[179, -31],
		],
		[
			[25050, 5437],
			[16, -51],
			[50, 50],
			[21, -52],
			[0, -51],
			[-27, -56],
			[-46, -90],
			[-36, -49],
			[26, -58],
			[-55, -2],
			[-60, -46],
			[-19, -79],
			[-41, -123],
			[-56, -55],
			[-35, -35],
			[-65, 3],
			[-46, 40],
			[-77, 9],
			[-12, 44],
			[38, 91],
			[89, 120],
			[46, 23],
			[51, 46],
			[61, 64],
			[42, 63],
			[32, 90],
			[27, 31],
			[10, 68],
			[50, 56],
			[16, -51],
		],
		[
			[25163, 6016],
			[51, -128],
			[2, 83],
			[32, -33],
			[10, -92],
			[57, -40],
			[48, -10],
			[41, 47],
			[36, -14],
			[-17, -108],
			[-22, -71],
			[-54, 2],
			[-19, -37],
			[6, -52],
			[-10, -23],
			[-27, -65],
			[-35, -83],
			[-55, -49],
			[-12, 32],
			[-30, 17],
			[41, 101],
			[-23, 66],
			[-76, 49],
			[2, 44],
			[51, 43],
			[12, 93],
			[-3, 79],
			[-29, 82],
			[2, 21],
			[-34, 50],
			[-56, 108],
			[-30, 86],
			[27, 9],
			[38, -67],
			[56, -32],
			[20, -108],
		],
		[
			[16541, 12440],
			[-23, 85],
			[-56, 201],
		],
		[
			[16462, 12726],
			[213, 121],
			[48, 244],
			[-33, 86],
		],
		[
			[16774, 13447],
			[32, -84],
			[40, -44],
			[52, -16],
			[42, -22],
			[32, -69],
			[19, -41],
			[25, -15],
			[0, -27],
			[-26, -73],
			[-11, -34],
			[-30, -39],
			[-26, -83],
			[-32, 6],
			[-15, -29],
			[-12, -62],
			[9, -81],
			[-7, -15],
			[-32, 1],
			[-45, -46],
			[-6, -59],
			[-17, -26],
			[-44, 1],
			[-28, -31],
			[1, -49],
			[-35, -33],
			[-39, 11],
			[-47, -41],
			[-33, -7],
		],
		[
			[16751, 13584],
			[21, 42],
			[9, -11],
			[-7, -50],
			[-9, -22],
		],
		[
			[17610, 13297],
			[-52, 30],
			[-21, 88],
			[-55, 92],
			[-131, -22],
			[-115, -3],
			[-100, -17],
		],
		[
			[7246, 11293],
			[-24, 35],
			[-15, 66],
			[18, 32],
			[-18, 9],
			[-13, 40],
			[-36, 34],
			[-31, -8],
			[-14, -42],
			[-29, -31],
			[-15, -4],
			[-7, -25],
			[34, -66],
			[-20, -16],
			[-10, -18],
			[-33, -6],
			[-12, 73],
			[-10, -21],
			[-23, 7],
			[-14, 49],
			[-29, 8],
			[-19, 14],
			[-30, 0],
			[-2, -26],
			[-9, 18],
		],
		[
			[6915, 11578],
			[26, -43],
			[-2, -26],
			[29, -6],
			[6, 10],
			[20, -30],
			[35, 9],
			[30, 31],
			[43, 24],
			[24, 37],
			[39, -7],
			[-2, -12],
			[39, -5],
			[32, -21],
			[23, -36],
			[27, -34],
		],
		[
			[7779, 8182],
			[-71, 70],
			[-6, 50],
			[-141, 122],
			[-127, 133],
			[-55, 75],
			[-29, 101],
			[11, 35],
			[-60, 160],
			[-70, 224],
			[-67, 242],
			[-29, 56],
			[-22, 89],
			[-55, 80],
			[-51, 49],
			[23, 54],
			[-34, 116],
			[22, 85],
			[56, 77],
		],
		[
			[21740, 11438],
			[7, -81],
			[4, -68],
			[-24, -111],
			[-26, 124],
			[-33, -62],
			[23, -90],
			[-21, -57],
			[-83, 71],
			[-20, 88],
			[22, 58],
			[-45, 57],
			[-23, -50],
			[-33, 5],
			[-53, -68],
			[-11, 35],
			[28, 103],
			[44, 34],
			[39, 46],
			[25, -55],
			[54, 33],
			[12, 55],
			[50, 3],
			[-4, 94],
			[57, -58],
			[6, -61],
			[5, -45],
		],
		[
			[21570, 11665],
			[-25, -40],
			[-23, -77],
			[-22, -36],
			[-44, 84],
			[15, 33],
			[18, 34],
			[8, 75],
			[39, 7],
			[-12, -82],
			[53, 118],
			[-7, -116],
		],
		[
			[21181, 11548],
			[-94, -116],
			[35, 85],
			[51, 76],
			[43, 84],
			[37, 121],
			[12, -100],
			[-46, -67],
			[-38, -83],
		],
		[
			[21421, 11861],
			[43, -38],
			[45, 1],
			[-1, -51],
			[-33, -52],
			[-45, -36],
			[-3, 56],
			[5, 62],
			[-11, 58],
		],
		[
			[21678, 11894],
			[20, -136],
			[-55, 33],
			[2, -41],
			[17, -75],
			[-34, -28],
			[-3, 86],
			[-21, 6],
			[-11, 74],
			[42, -10],
			[-1, 46],
			[-44, 93],
			[68, -3],
			[20, -45],
		],
		[
			[21396, 12004],
			[-19, -105],
			[-30, 61],
			[-37, 93],
			[61, -5],
			[25, -44],
		],
		[
			[21381, 12666],
			[44, -35],
			[22, 31],
			[6, -30],
			[-11, -51],
			[24, -87],
			[-19, -101],
			[-42, -41],
			[-11, -98],
			[16, -96],
			[38, -14],
			[31, 15],
			[89, -68],
			[-7, -66],
			[23, -29],
			[-7, -56],
			[-55, 59],
			[-27, 64],
			[-18, -44],
			[-45, 72],
			[-65, -18],
			[-35, 27],
			[4, 51],
			[22, 30],
			[-21, 29],
			[-9, -44],
			[-36, 70],
			[-10, 53],
			[-3, 116],
			[29, -40],
			[7, 190],
			[23, 111],
			[43, 0],
		],
		[
			[23833, 9585],
			[-19, -12],
			[-31, 46],
			[-31, 78],
			[-15, 92],
			[9, 12],
			[8, -36],
			[22, -28],
			[34, -77],
			[33, -41],
			[-10, -34],
		],
		[
			[23557, 9748],
			[-37, -10],
			[-11, -34],
			[-39, -30],
			[-37, -28],
			[-37, 0],
			[-59, 35],
			[-40, 34],
			[6, 38],
			[63, -18],
			[39, 10],
			[11, 58],
			[10, 3],
			[7, -65],
			[41, 10],
			[20, 41],
			[39, 44],
			[-8, 71],
			[43, 3],
			[14, -20],
			[-1, -68],
			[-24, -74],
		],
		[
			[22778, 10098],
			[123, -84],
			[131, -69],
			[49, -63],
			[39, -61],
			[11, -71],
			[118, -76],
			[18, -64],
			[-66, -13],
			[16, -81],
			[63, -80],
			[46, -129],
			[41, 4],
			[-3, -54],
			[55, -21],
			[-21, -23],
			[75, -51],
			[-8, -35],
			[-47, -8],
			[-17, 31],
			[-61, 14],
			[-72, 18],
			[-55, 78],
			[-40, 67],
			[-37, 106],
			[-93, 53],
			[-60, -34],
			[-43, -41],
			[9, -89],
			[-56, -42],
			[-40, 20],
			[-73, 5],
		],
		[
			[23639, 9867],
			[-22, -32],
			[-14, 71],
			[-16, 47],
			[-32, 40],
			[-41, 52],
			[-51, 36],
			[20, 29],
			[38, -34],
			[24, -26],
			[30, -30],
			[29, -51],
			[27, -39],
			[8, -63],
		],
		[
			[13774, 16954],
			[49, 36],
			[111, 56],
			[89, 41],
			[71, -20],
			[5, -30],
			[69, -2],
		],
		[
			[14168, 17035],
			[87, -13],
			[130, 1],
		],
		[
			[14442, 16689],
			[36, -106],
			[-8, -34],
			[-35, -14],
			[-65, -102],
			[19, -54],
			[-16, 7],
		],
		[
			[14373, 16386],
			[-67, 47],
			[-51, -18],
			[-34, 13],
			[-42, -26],
			[-36, 43],
			[-29, -17],
			[-4, 8],
		],
		[
			[8069, 12667],
			[36, -11],
			[13, -24],
			[-18, -31],
			[-53, 1],
			[-42, -4],
			[-4, 52],
			[10, 18],
			[58, -1],
		],
		[
			[22042, 15572],
			[10, -21],
			[-27, 7],
			[-30, -41],
			[-22, -42],
			[3, -87],
			[-37, -27],
			[-12, -21],
			[-27, -36],
			[-47, -20],
			[-31, -33],
			[-2, -53],
			[-8, -13],
			[28, -20],
			[40, -53],
		],
		[
			[21726, 15007],
			[-35, 23],
			[-8, -23],
			[-21, -10],
			[-3, 23],
			[-18, 11],
			[-19, 19],
			[19, 54],
			[17, 14],
			[-6, 22],
			[18, 66],
			[-5, 20],
			[-41, 13],
			[-34, 33],
		],
		[
			[12244, 14927],
			[-29, -31],
			[-37, 17],
			[-37, -13],
			[11, 95],
			[-7, 75],
			[-32, 11],
			[-16, 46],
			[5, 80],
			[28, 44],
			[5, 49],
			[15, 73],
			[-1, 52],
			[-14, 43],
			[-4, 41],
		],
		[
			[16378, 13426],
			[-5, 88],
			[19, 64],
			[20, 13],
			[21, -38],
			[1, -71],
			[-15, -72],
		],
		[
			[16419, 13410],
			[-20, -8],
			[-21, 24],
		],
		[
			[14384, 16239],
			[31, 26],
			[44, -13],
			[45, 0],
			[33, -30],
			[24, 18],
			[53, 12],
			[17, 29],
			[30, 0],
		],
		[
			[14776, 15948],
			[32, -22],
			[33, 19],
			[32, -21],
		],
		[
			[14873, 15924],
			[2, -31],
			[-35, -26],
			[-21, 11],
			[-20, -146],
		],
		[
			[14380, 15796],
			[-13, 21],
			[17, 20],
			[-18, 16],
			[-22, -28],
			[-41, 36],
			[-6, 50],
			[-43, 28],
			[-8, 39],
			[-39, 48],
		],
		[
			[22966, 16588],
			[71, -215],
			[-105, 40],
			[-44, -176],
			[69, -125],
			[-2, -85],
			[-53, 74],
			[-47, -95],
			[-13, 102],
			[8, 119],
			[-8, 131],
			[16, 92],
			[3, 163],
			[-41, 119],
			[6, 167],
			[66, 56],
			[-29, 56],
			[32, 17],
			[18, -80],
			[25, -118],
			[-2, -119],
			[30, -123],
		],
		[
			[14168, 17035],
			[16, 54],
			[98, 39],
		],
		[
			[354, 18515],
			[48, -31],
			[-17, 89],
			[193, -18],
			[139, -114],
			[-71, -53],
			[-116, -13],
			[-2, -119],
			[-28, -25],
			[-67, 4],
			[-54, 42],
			[-94, 35],
			[-16, 53],
			[-72, 20],
			[-81, -16],
			[-38, 43],
			[15, 45],
			[-85, -29],
			[32, -57],
			[-40, -52],
			[0, 485],
			[174, -93],
			[186, -121],
			[-6, -75],
		],
		[
			[25545, 19031],
			[-78, -6],
			[-12, 39],
			[90, 50],
			[0, -83],
		],
		[
			[93, 19039],
			[-93, -8],
			[0, 83],
			[9, 6],
			[60, -1],
			[103, -35],
			[-6, -16],
			[-73, -29],
		],
		[
			[22962, 19321],
			[-107, -1],
			[-146, 14],
			[-12, 6],
			[67, 48],
			[89, 11],
			[101, -46],
			[8, -32],
		],
		[
			[23468, 19549],
			[-82, -49],
			[-113, 11],
			[-132, 48],
			[17, 40],
			[132, -19],
			[178, -31],
		],
		[
			[23068, 19607],
			[-56, -91],
			[-262, 4],
			[-117, -29],
			[-141, 79],
			[38, 84],
			[94, 23],
			[187, -6],
			[257, -64],
		],
		[
			[16855, 19018],
			[-42, -11],
			[-232, 16],
			[-18, 54],
			[-129, 32],
			[-10, 66],
			[72, 26],
			[-2, 67],
			[141, 103],
			[-66, 15],
			[170, 107],
			[-19, 55],
			[159, 64],
			[234, 79],
			[236, 22],
			[122, 45],
			[138, 16],
			[49, -48],
			[-48, -38],
			[-251, -60],
			[-217, -58],
			[-220, -116],
			[-106, -118],
			[-111, -117],
			[14, -102],
			[136, -99],
		],
		[
			[22089, 15781],
			[-19, 104],
			[61, 43],
		],
		[
			[22131, 15928],
			[86, -22],
			[48, 119],
		],
		[
			[22265, 16025],
			[24, 133],
			[27, 44],
			[38, 110],
		],
		[
			[22236, 16276],
			[-61, -48],
			[-108, 0],
			[-29, 114],
		],
		[
			[21954, 16429],
			[-123, 39],
			[-26, 119],
		],
		[
			[21647, 16882],
			[-106, 36],
			[-94, -4],
		],
		[
			[21339, 16803],
			[1, -67],
			[-40, -39],
			[-64, -129],
			[1, -54],
		],
		[
			[20286, 16546],
			[-90, -15],
			[-67, -23],
		],
		[
			[20129, 16508],
			[-101, 51],
			[-13, 91],
			[-84, 32],
		],
		[
			[19743, 16548],
			[-69, -84],
			[-103, 30],
			[-71, 5],
		],
		[
			[19453, 16555],
			[-74, 2],
			[-62, 38],
		],
		[
			[18229, 17043],
			[-178, -114],
			[-68, -7],
		],
		[
			[17610, 17102],
			[-178, -45],
			[-35, -30],
		],
		[
			[17397, 17027],
			[-265, -43],
			[-33, -41],
		],
		[
			[17005, 16563],
			[-91, 63],
			[-113, -2],
			[-75, -51],
			[-84, 49],
		],
		[
			[16070, 16302],
			[60, -83],
			[53, 4],
			[45, -82],
		],
		[
			[16228, 16141],
			[-7, -62],
			[36, -20],
		],
		[
			[16257, 16059],
			[-33, -72],
			[-68, -20],
			[-71, -126],
			[64, -115],
			[-7, -82],
			[78, -143],
			[-42, -49],
		],
		[
			[16065, 15507],
			[-44, 28],
			[-22, 50],
		],
		[
			[15933, 15610],
			[-43, -19],
			[-13, 23],
			[-96, 58],
			[-105, 20],
			[-60, 21],
		],
		[
			[15608, 15698],
			[-91, 103],
			[-81, 46],
			[-61, 72],
			[52, 19],
			[58, 102],
			[-39, 48],
			[104, 50],
			[-2, 26],
			[-63, -19],
		],
		[
			[15485, 16145],
			[2, 54],
		],
		[
			[15487, 16199],
			[37, 34],
			[68, 8],
		],
		[
			[15592, 16241],
			[11, 41],
			[-15, 67],
			[29, 64],
		],
		[
			[15617, 16413],
			[-1, 35],
			[-105, 40],
		],
		[
			[15511, 16488],
			[-41, -1],
			[-44, 57],
			[-55, -20],
			[-90, 43],
		],
		[
			[15281, 16567],
			[2, 24],
			[-25, 53],
		],
		[
			[15258, 16644],
			[-57, 6],
			[-6, 38],
			[18, 24],
			[-45, 69],
			[-74, -12],
			[-22, 6],
		],
		[
			[15072, 16775],
			[-18, -27],
			[-26, 5],
			[-17, 78],
		],
		[
			[14994, 16871],
			[14, 11],
			[57, -4],
		],
		[
			[14739, 17445],
			[-21, 113],
			[51, 70],
		],
		[
			[14769, 17628],
			[-11, 22],
			[81, 67],
			[-75, 58],
			[152, 155],
		],
		[
			[14801, 18816],
			[58, 11],
			[120, 49],
			[74, 43],
			[116, -74],
			[194, -29],
			[269, -137],
			[54, -58],
			[5, -81],
			[-79, -64],
			[-116, -33],
			[-317, 93],
			[-52, -16],
			[116, -89],
			[4, -56],
			[5, -124],
			[91, -38],
			[56, -31],
			[9, 59],
			[-43, 52],
			[45, 46],
			[172, -76],
			[60, 30],
			[-48, 89],
			[165, 119],
			[66, -7],
			[66, -42],
			[41, 83],
			[-59, 73],
			[35, 73],
			[-52, 75],
			[198, -39],
			[41, -68],
			[-90, -15],
			[1, -68],
			[55, -41],
			[110, 26],
			[17, 78],
			[149, 58],
			[247, 104],
			[54, -6],
			[-70, -74],
			[88, -12],
			[51, 41],
			[133, 3],
			[105, 51],
			[81, -73],
			[80, 80],
			[-74, 71],
			[37, 40],
			[210, -37],
			[98, -38],
			[257, -139],
			[47, 64],
			[-72, 64],
			[-2, 26],
			[-85, 12],
			[23, 57],
			[-38, 95],
			[-2, 39],
			[131, 110],
			[47, 111],
			[52, 24],
			[188, -32],
			[15, -68],
			[-67, -99],
			[44, -38],
			[23, -85],
			[-16, -167],
			[78, -75],
			[-31, -81],
			[-139, -173],
			[82, -18],
			[28, 44],
			[78, 31],
			[19, 61],
			[61, 58],
			[-41, 69],
			[33, 80],
			[-78, 10],
			[-17, 68],
			[57, 122],
			[-92, 99],
			[127, 82],
			[-17, 87],
			[36, 2],
			[37, -67],
			[-28, -117],
			[76, -23],
			[-33, 88],
			[119, 48],
			[147, 6],
			[132, -69],
			[-63, 101],
			[-8, 130],
			[124, 24],
			[170, -5],
			[154, 16],
			[-57, 64],
			[82, 79],
			[81, 4],
			[138, 60],
			[188, 16],
			[23, 34],
			[187, 11],
			[58, -27],
			[159, 64],
			[130, -2],
			[20, 53],
			[68, 52],
			[167, 50],
			[122, -40],
			[-97, -30],
			[161, -19],
			[19, -60],
			[65, 30],
			[207, -2],
			[160, -59],
			[57, -46],
			[-17, -63],
			[-79, -36],
			[-186, -67],
			[-54, -36],
			[88, -17],
			[105, -31],
			[64, 23],
			[36, -78],
			[32, 31],
			[113, 20],
			[228, -20],
			[17, -57],
			[297, -18],
			[4, 92],
			[150, -21],
			[114, 1],
			[114, -64],
			[33, -78],
			[-42, -51],
			[89, -96],
			[112, -49],
			[68, 127],
			[114, -54],
			[121, 32],
			[137, -37],
			[52, 34],
			[116, -17],
			[-51, 113],
			[94, 53],
			[641, -79],
			[60, -73],
			[186, -92],
			[286, 23],
			[142, -21],
			[59, -50],
			[-9, -89],
			[88, -34],
			[95, 25],
			[125, 3],
			[134, -24],
			[135, 13],
			[123, -108],
			[88, 39],
			[-57, 78],
			[32, 54],
			[226, -34],
			[148, 7],
			[204, -58],
			[99, -53],
			[0, -485],
			[-1, 0],
			[-91, -54],
			[-92, 9],
			[64, -65],
			[43, -100],
			[32, -33],
			[9, -50],
			[-19, -32],
			[-132, 26],
			[-198, -91],
			[-63, -14],
			[-109, -86],
			[-103, -75],
			[-26, -55],
			[-102, 84],
			[-184, -95],
			[-33, 45],
			[-68, -52],
			[-95, 17],
			[-23, -80],
			[-85, -118],
			[3, -49],
			[80, -28],
			[-9, -177],
			[-66, -4],
			[-30, -102],
			[29, -52],
			[-124, -62],
			[-25, -139],
			[-105, -30],
			[-22, -124],
			[-102, -113],
			[-26, 84],
			[-31, 177],
			[-39, 271],
			[34, 168],
			[60, 73],
			[4, 57],
			[110, 27],
			[127, 153],
			[122, 125],
			[127, 97],
			[57, 172],
			[-86, -10],
			[-43, -101],
			[-180, -133],
			[-58, 149],
			[-183, -41],
			[-177, -204],
			[58, -74],
			[-158, -32],
			[-110, -13],
			[5, 88],
			[-110, 19],
			[-88, -60],
			[-217, 21],
			[-233, -36],
			[-230, -238],
			[-272, -287],
			[112, -15],
			[35, -76],
			[68, -27],
			[46, 61],
			[78, -8],
			[102, -134],
			[3, -104],
			[-56, -121],
			[-6, -145],
			[-32, -195],
			[-107, -176],
			[-24, -84],
			[-96, -142],
			[-96, -140],
			[-45, -72],
			[-95, -71],
			[-45, -2],
			[-44, 59],
			[-96, -89],
			[-11, -40],
			[-10, 21],
			[0, 62],
		],
		[
			[20228, 19941],
			[-400, -47],
			[130, 159],
			[58, 14],
			[54, -8],
			[180, -69],
			[-22, -49],
		],
		[
			[16401, 20213],
			[-95, -16],
			[-64, -9],
			[-10, -20],
			[-83, -20],
			[-77, 29],
			[41, 38],
			[-158, 3],
			[138, 22],
			[108, 2],
			[15, -33],
			[40, 29],
			[67, 20],
			[105, -26],
			[-27, -19],
		],
		[
			[19864, 20010],
			[-155, -15],
			[-197, 35],
			[-118, 47],
			[-55, 87],
			[-96, 24],
			[184, 83],
			[153, 28],
			[138, -62],
			[164, -117],
			[-18, -110],
		],
		[
			[14931, 10276],
			[28, -68],
			[-4, -72],
		],
		[
			[14955, 10136],
			[-20, -15],
		],
		[
			[14871, 10251],
			[18, -12],
			[42, 37],
		],
		[
			[12147, 13779],
			[11, 0],
		],
		[
			[11562, 12969],
			[3, 52],
		],
		[
			[15808, 12403],
			[-9, 52],
			[-22, 37],
			[-5, 48],
			[-37, 44],
			[-37, 102],
			[-21, 99],
			[-49, 84],
			[-31, 20],
			[-47, 116],
			[-8, 84],
			[3, 72],
			[-41, 135],
			[-33, 48],
			[-39, 25],
			[-23, 70],
			[4, 27],
			[-20, 63],
			[-21, 27],
			[-27, 91],
			[-44, 98],
			[-36, 83],
			[-35, 0],
			[11, 67],
			[3, 42],
			[9, 49],
		],
		[
			[16208, 13888],
			[28, -105],
			[35, -28],
			[12, -43],
			[48, -51],
			[5, -50],
			[-8, -40],
			[9, -41],
			[21, -34],
			[9, -40],
			[11, -30],
		],
		[
			[16419, 13410],
			[13, -46],
		],
		[
			[16462, 12726],
			[-204, -47],
			[-66, -55],
			[-51, -127],
			[-33, -21],
			[-18, 41],
			[-27, -6],
			[-69, 12],
			[-13, 12],
			[-82, -3],
			[-19, -11],
			[-29, 32],
			[-19, -60],
			[7, -51],
			[-31, -39],
		],
		[
			[15182, 11566],
			[-9, 2],
			[1, 61],
			[-9, 42],
			[-36, 48],
			[-9, 87],
			[9, 90],
			[-33, 8],
			[-5, -27],
			[-43, -6],
			[17, -35],
			[7, -74],
			[-39, -66],
			[-36, -88],
			[-36, -13],
			[-60, 71],
			[-27, -25],
			[-7, -35],
			[-37, -23],
			[-2, -25],
			[-71, 0],
			[-9, 25],
			[-52, 4],
			[-25, -21],
			[-20, 11],
			[-36, 71],
			[-12, 33],
			[-52, -17],
			[-19, -56],
			[-18, -109],
			[-25, -23],
			[-22, -13],
		],
		[
			[14467, 11463],
			[-5, 6],
		],
		[
			[14395, 11770],
			[1, 29],
			[-26, 36],
			[-1, 71],
			[-15, 47],
			[-25, -7],
			[7, 45],
			[19, 50],
			[-8, 51],
			[23, 37],
			[-15, 28],
			[19, 75],
			[32, 90],
			[61, -8],
			[-3, 482],
		],
		[
			[15388, 13091],
			[23, -120],
			[-15, -22],
			[10, -125],
			[26, -145],
			[27, -30],
			[39, -45],
		],
		[
			[15387, 12477],
			[-7, -81],
			[-30, -178],
			[7, -49],
		],
		[
			[15182, 11580],
			[0, -14],
		],
		[
			[15182, 11566],
			[1, -95],
		],
		[
			[15185, 10931],
			[-43, -55],
			[-50, 0],
			[-57, -29],
			[-45, 28],
			[-30, -34],
		],
		[
			[14960, 10841],
			[-62, 81],
			[-17, 52],
		],
		[
			[14516, 11416],
			[-49, 47],
		],
		[
			[11587, 12068],
			[-30, 95],
			[-35, 43],
			[31, 23],
			[34, 86],
			[17, 62],
		],
		[
			[11589, 11921],
			[-12, 93],
		],
		[
			[24276, 9139],
			[20, -42],
			[-50, 1],
			[-27, 75],
			[43, -29],
			[14, -5],
		],
		[
			[24186, 9213],
			[-27, -2],
			[-44, 12],
			[-15, 19],
			[5, 48],
			[47, -19],
			[23, -26],
			[11, -32],
		],
		[
			[24245, 9247],
			[-11, -23],
			[-52, 106],
			[-15, 72],
			[24, 0],
			[26, -97],
			[28, -58],
		],
		[
			[24117, 9400],
			[3, -24],
			[-56, 51],
			[-38, 44],
			[-27, 41],
			[10, 12],
			[33, -29],
			[58, -56],
			[17, -39],
		],
		[
			[23951, 9521],
			[-14, -7],
			[-31, 27],
			[-29, 50],
			[4, 21],
			[42, -52],
			[28, -39],
		],
		[
			[11961, 11240],
			[-19, 9],
			[-51, 49],
			[-37, 65],
			[-13, 45],
			[-8, 90],
		],
		[
			[6543, 12043],
			[-8, -29],
			[-41, 2],
			[-26, 12],
			[-29, 24],
			[-39, 7],
			[-21, 26],
		],
		[
			[16164, 11388],
			[-60, -1],
			[-232, 145],
		],
		[
			[15872, 11532],
			[-27, 43],
			[-26, 59],
		],
		[
			[15834, 11809],
			[23, -23],
			[14, -50],
			[32, -51],
			[35, 0],
			[67, 31],
			[77, 14],
			[63, 38],
			[35, 8],
			[25, 22],
			[41, 5],
			[-1, -2],
		],
		[
			[16245, 11801],
			[0, -51],
			[0, -122],
			[0, -64],
			[-32, -74],
			[-49, -102],
		],
		[
			[16245, 11801],
			[1, 2],
			[22, 2],
			[33, 18],
			[38, 12],
			[33, 42],
			[27, 0],
			[2, -33],
			[-7, -71],
			[1, -64],
			[-15, -44],
			[-20, -132],
			[-35, -135],
			[-43, -156],
			[-61, -178],
			[-61, -136],
			[-83, -166],
			[-71, -99],
			[-106, -120],
			[-67, -93],
			[-77, -147],
			[-17, -65],
			[-16, -28],
		],
		[
			[14147, 15872],
			[-26, 0],
			[27, 46],
		],
		[
			[14126, 15952],
			[-17, 47],
			[54, 32],
		],
		[
			[8717, 11141],
			[85, -24],
			[8, 22],
			[57, 8],
			[77, -32],
		],
		[
			[8912, 10927],
			[28, -72],
			[-12, -53],
			[-6, -55],
			[-18, -51],
		],
		[
			[14373, 16386],
			[-19, -32],
			[-14, -49],
		],
		[
			[13746, 15950],
			[15, 11],
		],
		[
			[14469, 18444],
			[-122, -34],
			[-69, -85],
			[11, -75],
			[-113, -97],
			[-137, -105],
			[-52, -171],
			[51, -86],
			[68, -67],
			[-66, -138],
			[-73, -28],
			[-27, -204],
			[-41, -114],
			[-86, 11],
			[-40, -96],
			[-82, -6],
			[-23, 115],
			[-59, 138],
			[-54, 172],
		],
		[
			[13983, 17396],
			[11, -8],
			[-56, -139],
			[-4, 46],
			[49, 101],
		],
		[
			[14146, 17465],
			[-39, -37],
			[1, -25],
			[12, -1],
			[-3, -8],
			[-18, -8],
			[1, -13],
			[-17, -9],
			[-11, -24],
			[-15, -5],
			[6, 27],
			[-8, 19],
			[6, 16],
			[-5, 18],
			[41, 47],
			[26, 1],
			[5, 6],
			[19, 1],
			[-1, -5],
		],
		[
			[14252, 18179],
			[15, 0],
			[-6, -13],
			[-11, -17],
			[-9, 1],
			[9, 15],
			[-2, 8],
			[4, 6],
		],
		[
			[15048, 7162],
			[-14, -54],
			[-42, -13],
			[-42, 66],
			[-1, 42],
			[20, 46],
			[6, 35],
			[21, 9],
			[36, -22],
		],
		[
			[15327, 14629],
			[-7, 93],
			[18, 50],
		],
		[
			[15338, 14772],
			[19, 27],
			[19, 26],
			[3, 68],
			[24, -23],
			[78, 34],
			[38, -23],
			[58, 0],
			[82, 46],
			[38, -2],
			[81, 19],
		],
		[
			[13733, 12162],
			[31, 160],
			[90, 115],
		],
		[
			[13871, 12936],
			[-1, 39],
			[-26, 32],
		],
		[
			[13834, 11820],
			[-5, 81],
			[-28, 78],
		],
		[
			[12905, 11162],
			[-57, -26],
		],
		[
			[20052, 11897],
			[-64, 56],
			[-61, -2],
			[11, 95],
			[-63, -1],
			[-5, -133],
			[-39, -178],
			[-23, -108],
			[5, -88],
			[46, -3],
			[29, -111],
			[13, -106],
			[40, -69],
			[43, -15],
			[36, -63],
		],
		[
			[19874, 11201],
			[-28, 47],
			[-12, 60],
			[-37, 68],
			[-35, 58],
			[-11, -71],
			[-14, 67],
			[8, 76],
			[21, 117],
		],
		[
			[17586, 14933],
			[39, 123],
			[-15, 91],
			[-52, 29],
			[18, 53],
			[60, -5],
			[33, 67],
			[23, 78],
			[95, 28],
			[-15, -56],
			[10, -34],
			[30, 3],
		],
		[
			[16599, 14940],
			[-14, 86],
			[11, 127],
			[-56, 41],
			[19, 84],
			[-47, 7],
			[15, 102],
			[67, -30],
			[63, 39],
			[-52, 73],
			[-20, 70],
			[-58, -31],
			[-7, -89],
			[-22, 78],
		],
		[
			[16744, 15440],
			[80, 1],
			[-12, 62],
			[61, 42],
			[60, 70],
			[95, -64],
			[8, -97],
			[27, -25],
			[77, 6],
			[24, -23],
			[34, -125],
			[82, -84],
			[46, -57],
			[74, -60],
			[95, -52],
			[-2, -74],
		],
		[
			[21640, 9333],
			[8, 28],
			[61, 28],
			[50, 4],
			[22, 15],
			[27, -15],
			[-26, -33],
			[-74, -53],
			[-59, -35],
		],
		[
			[8396, 11723],
			[41, 16],
			[14, -4],
			[-2, -91],
			[-60, -13],
			[-12, 11],
			[20, 33],
			[-1, 48],
		],
		[
			[13370, 14909],
			[77, 49],
			[50, -14],
			[-2, -62],
			[60, 45],
			[5, -24],
			[-35, -59],
			[-1, -56],
			[25, -31],
			[-10, -105],
			[-46, -61],
			[13, -66],
			[37, -3],
			[18, -57],
			[27, -19],
		],
		[
			[15911, 15034],
			[38, -98],
		],
		[
			[15338, 14772],
			[-26, 55],
			[26, 46],
			[-43, -10],
			[-59, 28],
			[-49, -70],
			[-108, -14],
			[-57, 65],
			[-77, 4],
			[-16, -50],
			[-49, -15],
			[-69, 65],
			[-77, -2],
			[-42, 121],
			[-52, 68],
			[35, 94],
			[-45, 58],
			[78, 117],
			[110, 4],
			[29, 93],
			[136, -16],
			[85, 79],
			[83, 34],
			[117, 3],
			[124, -86],
			[102, -47],
			[82, 19],
			[61, -11],
			[84, 63],
		],
		[
			[14759, 15525],
			[9, -47],
			[61, -39],
			[-12, -30],
			[-85, -7],
			[-30, -37],
			[-59, -66],
			[-23, 57],
			[1, 25],
		],
		[
			[21414, 13382],
			[-43, -195],
			[-30, -100],
			[-38, 103],
			[-8, 90],
			[42, 120],
			[57, 92],
			[32, -37],
			[-12, -73],
		],
		[
			[15554, 9846],
			[-33, -150],
			[5, -69],
			[45, -45],
			[2, -31],
			[-19, -74],
			[4, -37],
			[-5, -58],
			[25, -76],
			[29, -120],
			[26, -27],
			[-56, -70],
			[-78, -47],
		],
		[
			[15499, 9042],
			[-42, 2],
			[-26, -37],
			[-49, -3],
		],
		[
			[15225, 9013],
			[-20, 165],
			[-24, 57],
		],
		[
			[15181, 9235],
			[-14, 34],
			[-70, 23],
		],
		[
			[15097, 9292],
			[-40, 36],
			[-45, 21],
			[-29, 20],
		],
		[
			[14983, 9369],
			[-29, 31],
			[-39, 153],
			[-41, 68],
			[-14, 71],
		],
		[
			[14884, 9873],
			[26, 44],
			[27, 63],
			[18, 26],
			[-1, 39],
			[-15, 28],
			[-4, 48],
			[20, 15],
		],
		[
			[14931, 10276],
			[25, 15],
			[78, -2],
			[144, 10],
		],
		[
			[14872, 10343],
			[16, 46],
			[4, 98],
		],
		[
			[14985, 10683],
			[-29, 16],
			[4, 142],
		],
		[
			[15028, 16753],
			[26, -5],
			[18, 27],
		],
		[
			[15258, 16644],
			[25, -53],
			[-2, -24],
		],
		[
			[15511, 16488],
			[105, -40],
			[1, -35],
		],
		[
			[15617, 16413],
			[-29, -64],
			[15, -67],
			[-11, -41],
		],
		[
			[15592, 16241],
			[-68, -8],
			[-37, -34],
		],
		[
			[15485, 16145],
			[-57, -10],
			[-47, -40],
			[-67, -6],
			[-61, -45],
			[5, -76],
			[34, -29],
			[73, 7],
			[-14, -43],
			[-78, -22],
			[-96, -70],
			[-40, 25],
			[16, 57],
			[-78, 36],
			[13, 23],
			[68, 40],
			[-21, 28],
			[-110, 31],
			[-5, 45],
			[-66, -15],
			[-26, -67],
			[-55, -90],
		],
		[
			[8985, 6306],
			[-31, -76],
			[-80, -68],
			[-52, 25],
			[-38, -13],
			[-66, 52],
			[-48, -4],
			[-43, 67],
		],
		[
			[1735, 12736],
			[-10, -20],
			[-18, 17],
			[3, 34],
			[-12, 44],
			[3, 14],
			[13, 20],
			[-5, 24],
			[4, 11],
			[5, -2],
			[27, -21],
			[13, -10],
			[12, -17],
			[18, -42],
			[-2, -7],
			[-28, -26],
			[-23, -19],
		],
		[
			[1697, 12926],
			[-23, -9],
			[-13, 26],
			[-8, 10],
			[0, 7],
			[7, 11],
			[25, -12],
			[18, -19],
			[-6, -14],
		],
		[
			[1649, 12991],
			[-2, -14],
			[-38, 4],
			[5, 15],
			[35, -5],
		],
		[
			[1586, 13008],
			[-4, -7],
			[-5, 2],
			[-25, 4],
			[-9, 28],
			[-3, 5],
			[19, 16],
			[6, -7],
			[21, -41],
		],
		[
			[1466, 13089],
			[-9, -12],
			[-24, 22],
			[4, 9],
			[11, 12],
			[16, -3],
			[2, -28],
		],
		[
			[8009, 15905],
			[12, -39],
			[-76, -59],
			[-73, -42],
			[-75, -36],
			[-37, -73],
			[-12, -27],
			[-1, -64],
			[23, -65],
			[30, -3],
			[-8, 44],
			[22, -27],
			[-6, -34],
			[-48, -20],
			[-34, 2],
			[-53, -21],
			[-30, -6],
			[-42, -6],
			[-59, -35],
			[104, 23],
			[21, -23],
			[-99, -37],
			[-45, 0],
			[2, 15],
			[-22, -34],
			[21, -5],
			[-15, -88],
			[-52, -93],
			[-5, 31],
			[-16, 6],
			[-23, 31],
			[15, -66],
			[18, -22],
			[1, -46],
			[-23, -47],
			[-40, -97],
			[-7, 5],
			[22, 83],
			[-36, 46],
			[-8, 101],
			[-14, -52],
			[15, -78],
			[-47, 19],
			[49, -39],
			[3, -116],
			[21, -8],
			[7, -42],
			[10, -122],
			[-45, -90],
			[-74, -36],
			[-46, -71],
			[-36, -8],
			[-36, -45],
			[-10, -41],
			[-78, -79],
			[-40, -58],
			[-33, -72],
			[-11, -86],
			[13, -85],
			[23, -104],
			[32, -86],
			[0, -52],
			[34, -142],
			[-2, -82],
			[-4, -47],
			[-17, -74],
			[-21, -16],
			[-35, 15],
			[-12, 54],
			[-27, 28],
			[-37, 104],
			[-33, 93],
			[-11, 48],
			[15, 81],
			[-20, 67],
			[-55, 101],
			[-28, 19],
			[-72, -55],
			[-12, 6],
			[-35, 57],
			[-44, 30],
			[-81, -16],
			[-62, 14],
			[-55, -9],
			[-29, -19],
			[13, -32],
			[-1, -49],
			[15, -24],
			[-14, -16],
			[-26, 18],
			[-27, -23],
			[-51, 3],
			[-53, 65],
			[-62, -15],
			[-52, 28],
			[-44, -9],
			[-60, -28],
			[-64, -90],
			[-71, -53],
			[-38, -58],
			[-17, -55],
			[0, -84],
			[3, -58],
			[14, -41],
			[-28, -4],
		],
		[
			[4461, 14372],
			[-12, 63],
			[-46, 70],
			[-33, 14],
			[-7, 35],
			[-40, 6],
			[-26, 33],
			[-66, 12],
			[-18, 20],
			[-8, 66],
			[-69, 123],
			[-59, 169],
			[2, 28],
			[-31, 40],
			[-55, 102],
			[-10, 99],
			[-38, 67],
			[16, 100],
			[-2, 105],
			[-23, 93],
			[28, 115],
			[8, 110],
			[9, 110],
			[-13, 164],
			[-22, 104],
			[-21, 56],
			[8, 24],
			[103, -41],
			[38, -115],
			[17, 32],
			[-11, 100],
			[-24, 99],
		],
		[
			[1915, 17363],
			[-70, -47],
			[-37, 32],
			[-11, 57],
			[65, 43],
			[38, 18],
			[47, -8],
			[30, -38],
			[-62, -57],
		],
		[
			[1023, 17703],
			[-43, -19],
			[-47, 22],
			[-43, 33],
			[70, 21],
			[57, -11],
			[6, -46],
		],
		[
			[587, 18174],
			[44, -23],
			[44, 12],
			[57, -32],
			[71, -16],
			[-6, -14],
			[-54, -25],
			[-54, 26],
			[-27, 22],
			[-63, -7],
			[-17, 11],
			[5, 46],
		],
		[
			[3245, 17575],
			[65, -55],
			[44, -87],
		],
		[
			[3547, 17217],
			[2, -77],
			[-39, -59],
			[-39, 46],
			[-63, 39],
			[-20, 106],
			[-91, 98],
			[-38, 115],
			[-69, 8],
			[-112, 3],
			[-84, 35],
			[-146, 126],
			[-68, 23],
			[-124, 44],
			[-99, -11],
			[-139, 56],
			[-84, 52],
			[-79, -26],
			[14, -84],
			[-39, -8],
			[-82, -25],
			[-62, -41],
			[-79, -26],
			[-10, 72],
			[32, 119],
			[75, 37],
			[-19, 31],
			[-91, -68],
			[-48, -81],
			[-102, -87],
			[51, -59],
			[-67, -87],
			[-76, -51],
			[-71, -37],
			[-17, -54],
			[-111, -63],
			[-23, -57],
			[-83, -52],
			[-48, 10],
			[-67, -34],
			[-72, -42],
			[-59, -40],
			[-121, -35],
			[-12, 20],
			[78, 57],
			[70, 38],
			[75, 66],
			[88, 14],
			[35, 50],
			[99, 73],
			[15, 24],
			[53, 43],
			[12, 92],
			[36, 72],
			[-82, -37],
			[-23, 21],
			[-38, -44],
			[-46, 62],
			[-20, -44],
			[-26, 61],
			[-71, -49],
			[-44, 0],
			[-6, 72],
			[13, 45],
			[-46, 43],
			[-92, -23],
			[-60, 57],
			[-48, 29],
			[-1, 69],
			[-54, 52],
			[27, 70],
			[58, 68],
			[25, 62],
			[58, 9],
			[49, -19],
			[57, 58],
			[51, -10],
			[54, 38],
			[-13, 55],
			[-40, 22],
			[53, 47],
			[-44, -1],
			[-75, -27],
			[-22, -27],
			[-55, 27],
			[-101, -13],
			[-104, 29],
			[-30, 49],
			[-89, 70],
			[99, 51],
			[159, 60],
			[58, 0],
			[-10, -61],
			[150, 5],
			[-57, 75],
			[-88, 46],
			[-50, 61],
			[-68, 52],
			[-98, 38],
			[40, 64],
			[126, 4],
			[89, 56],
			[17, 59],
			[73, 58],
			[69, 14],
			[134, 54],
			[66, -9],
			[109, 65],
			[107, -25],
			[51, -55],
			[32, 23],
			[120, -7],
			[-4, -28],
			[108, -21],
			[73, 13],
			[149, -39],
			[137, -11],
			[54, -16],
			[95, 20],
			[107, -37],
			[77, -17],
			[0, -452],
			[0, -692],
			[69, -4],
			[70, -33],
			[49, -54],
		],
		[
			[7711, 11847],
			[-2, -29],
			[-42, -14],
			[23, -55],
			[0, -64],
			[-32, -70],
			[27, -97],
			[31, 8],
			[16, 88],
			[-22, 43],
			[-4, 92],
			[88, 49],
			[-9, 58],
			[24, 38],
			[26, -85],
			[50, -2],
			[46, -68],
			[3, -41],
			[63, -1],
			[76, 13],
			[41, -55],
			[54, -15],
			[40, 38],
			[1, 31],
			[87, 7],
			[86, 2],
			[-61, -36],
			[25, -57],
			[56, -9],
			[54, -60],
			[11, -98],
			[37, 3],
			[28, -29],
		],
		[
			[20440, 13036],
			[-95, -104],
			[-59, -115],
			[-16, -84],
			[54, -128],
			[67, -159],
			[64, -75],
			[43, -98],
			[33, -225],
			[-10, -214],
			[-59, -80],
			[-81, -79],
			[-58, -101],
			[-89, -113],
			[-25, 78],
			[20, 82],
			[-53, 69],
		],
		[
			[24682, 8411],
			[-23, -16],
			[-24, 54],
			[3, 32],
			[44, -70],
		],
		[
			[24630, 8598],
			[12, -98],
			[-19, 15],
			[-15, -7],
			[-10, 34],
			[-2, 93],
			[34, -37],
		],
		[
			[16541, 12440],
			[-51, -33],
			[-14, -54],
			[-2, -41],
			[-70, -51],
			[-114, -57],
			[-63, -86],
			[-32, -7],
			[-21, 7],
			[-41, -50],
			[-46, -23],
			[-59, -7],
			[-18, -7],
			[-16, -32],
			[-18, -9],
			[-11, -31],
			[-35, 3],
			[-23, -16],
			[-49, 6],
			[-18, 71],
			[2, 66],
			[-12, 36],
			[-14, 90],
			[-20, 50],
			[14, 6],
			[-7, 56],
			[8, 23],
			[-3, 53],
		],
		[
			[14861, 7727],
			[29, -1],
			[34, -21],
			[24, 15],
			[38, -12],
		],
		[
			[15102, 7161],
			[-18, -88],
			[-8, -101],
			[-18, -55],
			[-49, -62],
			[-14, -17],
			[-30, -62],
			[-20, -63],
			[-40, -87],
			[-80, -125],
			[-50, -73],
			[-54, -56],
			[-74, -47],
			[-36, -6],
			[-9, -34],
			[-43, 18],
			[-35, -23],
			[-77, 23],
			[-43, -15],
			[-30, 7],
			[-73, -48],
			[-60, -19],
			[-44, -46],
			[-33, -3],
			[-30, 43],
			[-24, 2],
			[-30, 55],
			[-3, -17],
			[-10, 32],
			[0, 72],
			[-23, 81],
			[23, 22],
			[-2, 94],
			[-46, 114],
			[-36, 103],
			[0, 0],
			[-51, 158],
		],
		[
			[14921, 8528],
			[-54, -17],
			[-40, -48],
			[-9, -42],
			[-25, -10],
			[-62, -100],
			[-39, -79],
			[-24, -3],
			[-23, 14],
			[-80, 14],
		],
		[
			[14954, 9400],
			[29, -31],
		],
	],
	transform: { scale: [0.014092777451556078, 0.008220212141816416], translate: [-180, -85.609038] },
	objects: {
		map: {
			type: "GeometryCollection",
			geometries: [
				{ arcs: [[0, 1, 2, 3, 4, 5]], type: "Polygon", properties: { name: "Afghanistan" }, id: "AFG" },
				{ arcs: [[[6, 7, 8, 9]], [[10, 11, 12]]], type: "MultiPolygon", properties: { name: "Angola" }, id: "AGO" },
				{ arcs: [[13, 14, 15, 16, 17]], type: "Polygon", properties: { name: "Albania" }, id: "ALB" },
				{ arcs: [[18, 19, 20, 21, 22]], type: "Polygon", properties: { name: "United Arab Emirates" }, id: "ARE" },
				{ arcs: [[[23, 24]], [[25, 26, 27, 28, 29, 30]]], type: "MultiPolygon", properties: { name: "Argentina" }, id: "ARG" },
				{ arcs: [[31, 32, 33, 34, 35]], type: "Polygon", properties: { name: "Armenia" }, id: "ARM" },
				{
					arcs: [[[36]], [[37]], [[38]], [[39]], [[40]], [[41]], [[42]], [[43]]],
					type: "MultiPolygon",
					properties: { name: "Antarctica" },
					id: "ATA",
				},
				{ arcs: [[44]], type: "Polygon", properties: { name: "French Southern and Antarctic Lands" }, id: "ATF" },
				{ arcs: [[[45]], [[46]]], type: "MultiPolygon", properties: { name: "Australia" }, id: "AUS" },
				{ arcs: [[47, 48, 49, 50, 51, 52, 53]], type: "Polygon", properties: { name: "Austria" }, id: "AUT" },
				{ arcs: [[[54, -35]], [[55, 56, -33, 57, 58]]], type: "MultiPolygon", properties: { name: "Azerbaijan" }, id: "AZE" },
				{ arcs: [[59, 60, 61, 62]], type: "Polygon", properties: { name: "Burundi" }, id: "BDI" },
				{ arcs: [[63, 64, 65, 66, 67]], type: "Polygon", properties: { name: "Belgium" }, id: "BEL" },
				{ arcs: [[68, 69, 70, 71, 72]], type: "Polygon", properties: { name: "Benin" }, id: "BEN" },
				{ arcs: [[73, 74, 75, -71, 76, 77]], type: "Polygon", properties: { name: "Burkina Faso" }, id: "BFA" },
				{ arcs: [[78, 79, 80]], type: "Polygon", properties: { name: "Bangladesh" }, id: "BGD" },
				{ arcs: [[81, 82, 83, 84, 85, 86]], type: "Polygon", properties: { name: "Bulgaria" }, id: "BGR" },
				{ arcs: [[[87]], [[88]], [[89]]], type: "MultiPolygon", properties: { name: "The Bahamas" }, id: "BHS" },
				{ arcs: [[90, 91, 92, 93]], type: "Polygon", properties: { name: "Bosnia and Herzegovina" }, id: "BIH" },
				{ arcs: [[94, 95, 96, 97, 98, 99, 100, 101]], type: "Polygon", properties: { name: "Belarus" }, id: "BLR" },
				{ arcs: [[102, 103, 104]], type: "Polygon", properties: { name: "Belize" }, id: "BLZ" },
				{ arcs: [[105]], type: "Polygon", properties: { name: "Bermuda" }, id: "BMU" },
				{ arcs: [[106, 107, 108, 109, -31]], type: "Polygon", properties: { name: "Bolivia" }, id: "BOL" },
				{
					arcs: [[-27, 110, -109, 111, 112, 113, 114, 115, 116, 117, 118]],
					type: "Polygon",
					properties: { name: "Brazil" },
					id: "BRA",
				},
				{ arcs: [[119, 120]], type: "Polygon", properties: { name: "Brunei" }, id: "BRN" },
				{ arcs: [[121, 122]], type: "Polygon", properties: { name: "Bhutan" }, id: "BTN" },
				{ arcs: [[123, 124, 125, 126]], type: "Polygon", properties: { name: "Botswana" }, id: "BWA" },
				{
					arcs: [[127, 128, 129, 130, 131, 132, 133]],
					type: "Polygon",
					properties: { name: "Central African Republic" },
					id: "CAF",
				},
				{
					arcs: [
						[[134]],
						[[135]],
						[[136]],
						[[137]],
						[[138]],
						[[139]],
						[[140]],
						[[141]],
						[[142]],
						[[143]],
						[[144, 145, 146, 147, 148, 149]],
						[[150]],
						[[151]],
						[[152]],
						[[153]],
						[[154]],
						[[155]],
						[[156]],
						[[157]],
						[[158]],
						[[159]],
						[[160]],
						[[161]],
						[[162]],
						[[163]],
						[[164]],
						[[165]],
						[[166]],
						[[167]],
						[[168]],
					],
					type: "MultiPolygon",
					properties: { name: "Canada" },
					id: "CAN",
				},
				{ arcs: [[-51, 169, 170, 171]], type: "Polygon", properties: { name: "Switzerland" }, id: "CHE" },
				{ arcs: [[[-24, 172]], [[-30, 173, 174, -107]]], type: "MultiPolygon", properties: { name: "Chile" }, id: "CHL" },
				{
					arcs: [
						[[175]],
						[
							[
								176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, -123, 190, 191, 192, 193, -4, 194,
								195, 196, 197, 198, 199, 200, 201, 202, 203, 204,
							],
						],
					],
					type: "MultiPolygon",
					properties: { name: "China" },
					id: "CHN",
				},
				{ arcs: [[205, 206, 207, 208, -74, 209]], type: "Polygon", properties: { name: "Ivory Coast" }, id: "CIV" },
				{ arcs: [[210, 211, 212, 213, 214, 215, 216, -134, 217]], type: "Polygon", properties: { name: "Cameroon" }, id: "CMR" },
				{
					arcs: [[218, 219, 220, 221, -60, 222, 223, 224, -10, 225, -13, 226, -132, 227, 228]],
					type: "Polygon",
					properties: { name: "Democratic Republic of the Congo" },
					id: "COD",
				},
				{ arcs: [[-12, 229, 230, -218, -133, -227]], type: "Polygon", properties: { name: "Republic of the Congo" }, id: "COG" },
				{ arcs: [[231, 232, 233, 234, 235, -113, 236]], type: "Polygon", properties: { name: "Colombia" }, id: "COL" },
				{ arcs: [[237, 238, 239, 240]], type: "Polygon", properties: { name: "Costa Rica" }, id: "CRI" },
				{ arcs: [[241]], type: "Polygon", properties: { name: "Cuba" }, id: "CUB" },
				{ arcs: [[242, 243]], type: "Polygon", properties: { name: "Northern Cyprus" }, id: "-99" },
				{ arcs: [[244, -244]], type: "Polygon", properties: { name: "Cyprus" }, id: "CYP" },
				{ arcs: [[-53, 245, 246, 247]], type: "Polygon", properties: { name: "Czech Republic" }, id: "CZE" },
				{
					arcs: [[248, 249, -246, -52, -172, 250, 251, -65, 252, 253, 254]],
					type: "Polygon",
					properties: { name: "Germany" },
					id: "DEU",
				},
				{ arcs: [[255, 256, 257, 258]], type: "Polygon", properties: { name: "Djibouti" }, id: "DJI" },
				{ arcs: [[[259]], [[-255, 260]]], type: "MultiPolygon", properties: { name: "Denmark" }, id: "DNK" },
				{ arcs: [[261, 262]], type: "Polygon", properties: { name: "Dominican Republic" }, id: "DOM" },
				{ arcs: [[263, 264, 265, 266, 267, 268, 269, 270]], type: "Polygon", properties: { name: "Algeria" }, id: "DZA" },
				{ arcs: [[271, -232, 272]], type: "Polygon", properties: { name: "Ecuador" }, id: "ECU" },
				{ arcs: [[273, 274, 275]], type: "Polygon", properties: { name: "Egypt" }, id: "EGY" },
				{ arcs: [[276, 277, 278, 279, 280, 281, 282, -259]], type: "Polygon", properties: { name: "Eritrea" }, id: "ERI" },
				{ arcs: [[283, 284, 285, 286]], type: "Polygon", properties: { name: "Spain" }, id: "ESP" },
				{ arcs: [[287, 288, 289, 290]], type: "Polygon", properties: { name: "Estonia" }, id: "EST" },
				{
					arcs: [[291, 292, -277, -258, 293, 294, 295, 296, 297, 298, 299, 300, -280]],
					type: "Polygon",
					properties: { name: "Ethiopia" },
					id: "ETH",
				},
				{ arcs: [[301, 302, 303, 304]], type: "Polygon", properties: { name: "Finland" }, id: "FIN" },
				{ arcs: [[[305]], [[306]], [[307]]], type: "MultiPolygon", properties: { name: "Fiji" }, id: "FJI" },
				{ arcs: [[308]], type: "Polygon", properties: { name: "Falkland Islands" }, id: "FLK" },
				{
					arcs: [[[309]], [[310, -251, -171, 311, 312, -285, 313, -67]]],
					type: "MultiPolygon",
					properties: { name: "France" },
					id: "FRA",
				},
				{ arcs: [[314, 315, -211, -231]], type: "Polygon", properties: { name: "Gabon" }, id: "GAB" },
				{ arcs: [[316]], type: "Polygon", properties: { name: "England" }, id: "GB-ENG" },
				{ arcs: [[317, 318]], type: "Polygon", properties: { name: "Northern Ireland" }, id: "GB-NIR" },
				{ arcs: [[319, 320, 321, 322, 323, -58, -32, 324]], type: "Polygon", properties: { name: "Georgia" }, id: "GEO" },
				{ arcs: [[325]], type: "Polygon", properties: { name: "Wales" }, id: "GB-WLS" },
				{ arcs: [[326]], type: "Polygon", properties: { name: "Scotland" }, id: "GB-SCT" },
				{ arcs: [[327, -210, -78, 328]], type: "Polygon", properties: { name: "Ghana" }, id: "GHA" },
				{ arcs: [[329, 330, 331, 332, 333, 334, -208]], type: "Polygon", properties: { name: "Guinea" }, id: "GIN" },
				{ arcs: [[335, 336]], type: "Polygon", properties: { name: "Gambia" }, id: "GMB" },
				{ arcs: [[337, 338, -333]], type: "Polygon", properties: { name: "Guinea Bissau" }, id: "GNB" },
				{ arcs: [[339, -212, -316]], type: "Polygon", properties: { name: "Equatorial Guinea" }, id: "GNQ" },
				{ arcs: [[[340]], [[341, -14, 342, -85, 343]]], type: "MultiPolygon", properties: { name: "Greece" }, id: "GRC" },
				{ arcs: [[344]], type: "Polygon", properties: { name: "Greenland" }, id: "GRL" },
				{ arcs: [[345, 346, -105, 347, 348, 349]], type: "Polygon", properties: { name: "Guatemala" }, id: "GTM" },
				{ arcs: [[350, 351, 352, -117]], type: "Polygon", properties: { name: "French Guiana" }, id: "GUF" },
				{ arcs: [[353, 354, -115, 355]], type: "Polygon", properties: { name: "Guyana" }, id: "GUY" },
				{ arcs: [[356, 357, -349, 358, 359]], type: "Polygon", properties: { name: "Honduras" }, id: "HND" },
				{ arcs: [[360, 361, 362, -94, 363, 364, 365]], type: "Polygon", properties: { name: "Croatia" }, id: "HRV" },
				{ arcs: [[-263, 366]], type: "Polygon", properties: { name: "Haiti" }, id: "HTI" },
				{ arcs: [[-48, 367, 368, 369, 370, 371, -366, 372]], type: "Polygon", properties: { name: "Hungary" }, id: "HUN" },
				{
					arcs: [
						[[373]],
						[[374, 375]],
						[[376]],
						[[377]],
						[[378]],
						[[379]],
						[[380]],
						[[381]],
						[[382, 383]],
						[[384]],
						[[385]],
						[[386, 387]],
						[[388]],
					],
					type: "MultiPolygon",
					properties: { name: "Indonesia" },
					id: "IDN",
				},
				{ arcs: [[-193, 389, -191, -122, -190, 390, -81, 391, 392]], type: "Polygon", properties: { name: "India" }, id: "IND" },
				{ arcs: [[393, -318]], type: "Polygon", properties: { name: "Ireland" }, id: "IRL" },
				{
					arcs: [[394, -6, 395, 396, 397, 398, 399, -55, -34, -57, 400]],
					type: "Polygon",
					properties: { name: "Iran" },
					id: "IRN",
				},
				{ arcs: [[-398, 401, 402, 403, 404, 405, 406, 407]], type: "Polygon", properties: { name: "Iraq" }, id: "IRQ" },
				{ arcs: [[408]], type: "Polygon", properties: { name: "Iceland" }, id: "ISL" },
				{ arcs: [[409, 410, 411, 412, 413, 414]], type: "Polygon", properties: { name: "Israel" }, id: "ISR" },
				{ arcs: [[[415]], [[416]], [[417, 418, -312, -170, -50]]], type: "MultiPolygon", properties: { name: "Italy" }, id: "ITA" },
				{ arcs: [[419]], type: "Polygon", properties: { name: "Jamaica" }, id: "JAM" },
				{ arcs: [[-410, 420, -405, 421, 422, -412, 423]], type: "Polygon", properties: { name: "Jordan" }, id: "JOR" },
				{ arcs: [[[424]], [[425]], [[426]]], type: "MultiPolygon", properties: { name: "Japan" }, id: "JPN" },
				{
					arcs: [[427, 428, 429, 430, 431, 432, 433, 434, 435, 436, 437, 438, 439, -197, 440]],
					type: "Polygon",
					properties: { name: "Kazakhstan" },
					id: "KAZ",
				},
				{ arcs: [[441, 442, 443, 444, -298, 445]], type: "Polygon", properties: { name: "Kenya" }, id: "KEN" },
				{ arcs: [[-441, -196, 446, 447]], type: "Polygon", properties: { name: "Kyrgyzstan" }, id: "KGZ" },
				{ arcs: [[448, 449, 450, 451]], type: "Polygon", properties: { name: "Cambodia" }, id: "KHM" },
				{ arcs: [[452, 453]], type: "Polygon", properties: { name: "South Korea" }, id: "KOR" },
				{ arcs: [[454, 455, 456, 457, 458]], type: "Polygon", properties: { name: "Kosovo" }, id: "CS-KM" },
				{ arcs: [[459, 460, -403]], type: "Polygon", properties: { name: "Kuwait" }, id: "KWT" },
				{ arcs: [[461, 462, -188, 463, -450]], type: "Polygon", properties: { name: "Laos" }, id: "LAO" },
				{ arcs: [[-414, 464, 465]], type: "Polygon", properties: { name: "Lebanon" }, id: "LBN" },
				{ arcs: [[466, 467, -330, -207]], type: "Polygon", properties: { name: "Liberia" }, id: "LBR" },
				{ arcs: [[468, -271, 469, 470, -275, 471, 472]], type: "Polygon", properties: { name: "Libya" }, id: "LBY" },
				{ arcs: [[473]], type: "Polygon", properties: { name: "Sri Lanka" }, id: "LKA" },
				{ arcs: [[474]], type: "Polygon", properties: { name: "Lesotho" }, id: "LSO" },
				{ arcs: [[475, 476, 477, -95, 478]], type: "Polygon", properties: { name: "Lithuania" }, id: "LTU" },
				{ arcs: [[-252, -311, -66]], type: "Polygon", properties: { name: "Luxembourg" }, id: "LUX" },
				{ arcs: [[479, -291, 480, -96, -478]], type: "Polygon", properties: { name: "Latvia" }, id: "LVA" },
				{ arcs: [[-268, 481, 482, 483]], type: "Polygon", properties: { name: "Morocco" }, id: "MAR" },
				{ arcs: [[484, 485]], type: "Polygon", properties: { name: "Moldova" }, id: "MDA" },
				{ arcs: [[486]], type: "Polygon", properties: { name: "Madagascar" }, id: "MDG" },
				{ arcs: [[-103, -347, 487, 488, 489]], type: "Polygon", properties: { name: "Mexico" }, id: "MEX" },
				{ arcs: [[-459, 490, -86, -343, 491]], type: "Polygon", properties: { name: "Macedonia" }, id: "MKD" },
				{ arcs: [[492, -265, 493, -75, -209, -335, 494]], type: "Polygon", properties: { name: "Mali" }, id: "MLI" },
				{ arcs: [[[495]], [[496]]], type: "MultiPolygon", properties: { name: "Malta" }, id: "MLT" },
				{ arcs: [[497, -79, -391, -189, -463, 498]], type: "Polygon", properties: { name: "Myanmar" }, id: "MMR" },
				{ arcs: [[499, -93, 500, -457, -16]], type: "Polygon", properties: { name: "Montenegro" }, id: "MNE" },
				{ arcs: [[501, 502, 503, 504, 505, 506, 507, 508, -199]], type: "Polygon", properties: { name: "Mongolia" }, id: "MNG" },
				{ arcs: [[509, 510, 511, 512, 513, 514, 515, 516, 517]], type: "Polygon", properties: { name: "Mozambique" }, id: "MOZ" },
				{ arcs: [[518, 519, 520, -266, -493]], type: "Polygon", properties: { name: "Mauritania" }, id: "MRT" },
				{ arcs: [[-518, 521, 522, 523]], type: "Polygon", properties: { name: "Malawi" }, id: "MWI" },
				{ arcs: [[[524, 525]], [[-387, 526, -121, 527]]], type: "MultiPolygon", properties: { name: "Malaysia" }, id: "MYS" },
				{ arcs: [[528, -8, 529, -125, 530]], type: "Polygon", properties: { name: "Namibia" }, id: "NAM" },
				{ arcs: [[531]], type: "Polygon", properties: { name: "New Caledonia" }, id: "NCL" },
				{
					arcs: [[-76, -494, -264, -469, 532, 533, 534, 535, 536, -215, 537, -72]],
					type: "Polygon",
					properties: { name: "Niger" },
					id: "NER",
				},
				{ arcs: [[538, -73, -538, -214]], type: "Polygon", properties: { name: "Nigeria" }, id: "NGA" },
				{ arcs: [[539, -360, 540, -239]], type: "Polygon", properties: { name: "Nicaragua" }, id: "NIC" },
				{ arcs: [[-253, -64, 541]], type: "Polygon", properties: { name: "Netherlands" }, id: "NLD" },
				{ arcs: [[[-305, 542, 543]], [[544]], [[545]], [[546]]], type: "MultiPolygon", properties: { name: "Norway" }, id: "NOR" },
				{ arcs: [[-390, -192]], type: "Polygon", properties: { name: "Nepal" }, id: "NPL" },
				{ arcs: [[[547]], [[548]]], type: "MultiPolygon", properties: { name: "New Zealand" }, id: "NZL" },
				{ arcs: [[[549, 550, -22, 551]], [[-20, 552]]], type: "MultiPolygon", properties: { name: "Oman" }, id: "OMN" },
				{ arcs: [[-194, -393, 553, -396, -5]], type: "Polygon", properties: { name: "Pakistan" }, id: "PAK" },
				{ arcs: [[554, -241, 555, -234]], type: "Polygon", properties: { name: "Panama" }, id: "PAN" },
				{ arcs: [[-175, 556, -273, -237, -112, -108]], type: "Polygon", properties: { name: "Peru" }, id: "PER" },
				{
					arcs: [[[557]], [[558]], [[559]], [[560]], [[561]], [[562]], [[563]]],
					type: "MultiPolygon",
					properties: { name: "Philippines" },
					id: "PHL",
				},
				{
					arcs: [[[564]], [[565]], [[-383, 566]], [[567]]],
					type: "MultiPolygon",
					properties: { name: "Papua New Guinea" },
					id: "PNG",
				},
				{ arcs: [[-250, 568, 569, -479, -102, 570, 571, -247]], type: "Polygon", properties: { name: "Poland" }, id: "POL" },
				{ arcs: [[572]], type: "Polygon", properties: { name: "Puerto Rico" }, id: "PRI" },
				{ arcs: [[573, -454, 574, -185]], type: "Polygon", properties: { name: "North Korea" }, id: "PRK" },
				{ arcs: [[-287, 575]], type: "Polygon", properties: { name: "Portugal" }, id: "PRT" },
				{ arcs: [[-110, -111, -26]], type: "Polygon", properties: { name: "Paraguay" }, id: "PRY" },
				{ arcs: [[576, 577]], type: "Polygon", properties: { name: "Qatar" }, id: "QAT" },
				{ arcs: [[578, -486, 579, 580, -82, 581, -370]], type: "Polygon", properties: { name: "Romania" }, id: "ROU" },
				{
					arcs: [
						[[582]],
						[[-570, 583, -476]],
						[[584]],
						[[585]],
						[[586]],
						[[587]],
						[[588]],
						[[589]],
						[[590]],
						[
							[
								-183, 591, 592, 593, -179, 594, -177, 595, -204, 596, -202, 597, -200, -509, 598, 599, -506, 600, -504, 601,
								-502, -198, -440, 602, -438, 603, 604, -435, 605, -433, 606, 607, 608, -59, 609, -323, 610, -321, 611, 612,
								613, 614, 615, 616, 617, 618, 619, -99, 620, -97, -481, -290, 621, 622, -302, 623,
							],
						],
						[[624]],
						[[625]],
						[[626]],
					],
					type: "MultiPolygon",
					properties: { name: "Russia" },
					id: "RUS",
				},
				{ arcs: [[627, 628, -61, -222, 629]], type: "Polygon", properties: { name: "Rwanda" }, id: "RWA" },
				{ arcs: [[630, -267, -521, 631, -483]], type: "Polygon", properties: { name: "Western Sahara" }, id: "ESH" },
				{
					arcs: [[632, -422, -404, -461, 633, -578, 634, -23, -551, 635]],
					type: "Polygon",
					properties: { name: "Saudi Arabia" },
					id: "SAU",
				},
				{
					arcs: [[636, 637, -129, 638, -472, -274, 639, -282, 640, -301, 641]],
					type: "Polygon",
					properties: { name: "Sudan" },
					id: "SDN",
				},
				{
					arcs: [[642, -299, -445, 643, 644, -228, -131, 645, -637]],
					type: "Polygon",
					properties: { name: "South Sudan" },
					id: "SSD",
				},
				{ arcs: [[646, -519, -495, -334, -339, 647, -337]], type: "Polygon", properties: { name: "Senegal" }, id: "SEN" },
				{
					arcs: [[[648]], [[649]], [[650]], [[651]], [[652]]],
					type: "MultiPolygon",
					properties: { name: "Solomon Islands" },
					id: "SLB",
				},
				{ arcs: [[653, -331, -468]], type: "Polygon", properties: { name: "Sierra Leone" }, id: "SLE" },
				{ arcs: [[654, -350, -358]], type: "Polygon", properties: { name: "El Salvador" }, id: "SLV" },
				{ arcs: [[655, 656, -294, -257, 657, 658]], type: "Polygon", properties: { name: "Somaliland" }, id: "-99" },
				{ arcs: [[-446, -297, -659, 659]], type: "Polygon", properties: { name: "Somalia" }, id: "SOM" },
				{
					arcs: [[-87, -491, -458, -501, -92, 660, -362, 661, -371, -582]],
					type: "Polygon",
					properties: { name: "Republic of Serbia" },
					id: "SRB",
				},
				{ arcs: [[662, -352, 663, -116, -355]], type: "Polygon", properties: { name: "Suriname" }, id: "SUR" },
				{ arcs: [[-572, 664, -368, -54, -248]], type: "Polygon", properties: { name: "Slovakia" }, id: "SVK" },
				{ arcs: [[-49, -373, -365, 665, -418]], type: "Polygon", properties: { name: "Slovenia" }, id: "SVN" },
				{ arcs: [[[-543, -304, 666]], [[667]], [[668]], [[669]]], type: "MultiPolygon", properties: { name: "Sweden" }, id: "SWE" },
				{ arcs: [[670, -514]], type: "Polygon", properties: { name: "Swaziland" }, id: "SWZ" },
				{ arcs: [[-421, -415, -466, 671, 672, -406]], type: "Polygon", properties: { name: "Syria" }, id: "SYR" },
				{
					arcs: [[-537, 673, -535, 674, -533, -473, -639, -128, -217, 675]],
					type: "Polygon",
					properties: { name: "Chad" },
					id: "TCD",
				},
				{ arcs: [[676, -329, -77, -70]], type: "Polygon", properties: { name: "Togo" }, id: "TGO" },
				{ arcs: [[677, -526, 678, -499, -462, -449]], type: "Polygon", properties: { name: "Thailand" }, id: "THA" },
				{ arcs: [[-447, -195, -3, 679]], type: "Polygon", properties: { name: "Tajikistan" }, id: "TJK" },
				{ arcs: [[-395, 680, -429, 681, -1]], type: "Polygon", properties: { name: "Turkmenistan" }, id: "TKM" },
				{ arcs: [[682, -375]], type: "Polygon", properties: { name: "East Timor" }, id: "TLS" },
				{ arcs: [[683]], type: "Polygon", properties: { name: "Trinidad and Tobago" }, id: "TTO" },
				{ arcs: [[-270, 684, -470]], type: "Polygon", properties: { name: "Tunisia" }, id: "TUN" },
				{
					arcs: [[[-325, -36, -400, 685, -407, -673, 686]], [[-344, -84, 687]]],
					type: "MultiPolygon",
					properties: { name: "Turkey" },
					id: "TUR",
				},
				{ arcs: [[688]], type: "Polygon", properties: { name: "Taiwan" }, id: "TWN" },
				{
					arcs: [[-443, 689, 690, -510, 691, 692, 693, 694, -223, -63, 695, -628, 696]],
					type: "Polygon",
					properties: { name: "United Republic of Tanzania" },
					id: "TZA",
				},
				{ arcs: [[-630, -221, 697, -219, 698, -644, -444, -697]], type: "Polygon", properties: { name: "Uganda" }, id: "UGA" },
				{
					arcs: [[699, -619, 700, -617, 701, 702, 703, -613, 704, -580, -485, -579, -369, -665, -571, -101]],
					type: "Polygon",
					properties: { name: "Ukraine" },
					id: "UKR",
				},
				{ arcs: [[-119, 705, -28]], type: "Polygon", properties: { name: "Uruguay" }, id: "URY" },
				{
					arcs: [
						[[706]],
						[[707]],
						[[708]],
						[[709]],
						[[710]],
						[[711, -489, 712, -145]],
						[[713]],
						[[714]],
						[[715]],
						[[-149, 716, -147, 717]],
					],
					type: "MultiPolygon",
					properties: { name: "United States of America" },
					id: "USA",
				},
				{ arcs: [[-682, -428, -448, -680, -2]], type: "Polygon", properties: { name: "Uzbekistan" }, id: "UZB" },
				{ arcs: [[718, -356, -114, -236]], type: "Polygon", properties: { name: "Venezuela" }, id: "VEN" },
				{ arcs: [[719, -451, -464, -187]], type: "Polygon", properties: { name: "Vietnam" }, id: "VNM" },
				{ arcs: [[[720]], [[721]]], type: "MultiPolygon", properties: { name: "Vanuatu" }, id: "VUT" },
				{ arcs: [[-424, -411]], type: "Polygon", properties: { name: "West Bank" }, id: "PSE" },
				{ arcs: [[722, -636, -550]], type: "Polygon", properties: { name: "Yemen" }, id: "YEM" },
				{
					arcs: [[-531, -124, 723, -515, -671, -513, 724], [-475]],
					type: "Polygon",
					properties: { name: "South Africa" },
					id: "ZAF",
				},
				{ arcs: [[-522, -517, 725, -126, -530, -7, -225, 726, -694]], type: "Polygon", properties: { name: "Zambia" }, id: "ZMB" },
				{ arcs: [[-724, -127, -726, -516]], type: "Polygon", properties: { name: "Zimbabwe" }, id: "ZWE" },
			],
		},
	},
};
